// Mock data for DW Dashboard

export const dashboardStats = {
  activeProjects: 12,
  totalClients: 24,
  pendingTasks: 8,
  monthlyRevenue: 45000,
  teamMembers: 15,
  completedProjects: 89
};

export const projects = [
  {
    id: '1',
    name: 'Brand Refresh Campaign',
    client: 'Tech Startup Inc',
    status: 'In Progress',
    progress: 65,
    deadline: '2025-08-15',
    budget: 15000,
    team: ['John Doe', 'Jane Smith']
  },
  {
    id: '2',
    name: 'Social Media Content Pack',
    client: 'Fashion Boutique',
    status: 'Review',
    progress: 90,
    deadline: '2025-07-20',
    budget: 8000,
    team: ['Mike Johnson']
  },
  {
    id: '3',
    name: 'Product Photography',
    client: 'E-commerce Store',
    status: 'Planning',
    progress: 20,
    deadline: '2025-08-30',
    budget: 12000,
    team: ['Sarah Wilson', 'Tom Brown']
  }
];

export const customers = [
  {
    id: '1',
    name: 'Tech Startup Inc',
    email: 'contact@techstartup.com',
    phone: '+1 (555) 123-4567',
    totalSpent: 45000,
    projects: 5,
    status: 'Active',
    joinDate: '2024-01-15'
  },
  {
    id: '2',
    name: 'Fashion Boutique',
    email: 'info@fashionboutique.com',
    phone: '+1 (555) 234-5678',
    totalSpent: 28000,
    projects: 3,
    status: 'Active',
    joinDate: '2024-03-20'
  },
  {
    id: '3',
    name: 'E-commerce Store',
    email: 'hello@ecomstore.com',
    phone: '+1 (555) 345-6789',
    totalSpent: 62000,
    projects: 8,
    status: 'Active',
    joinDate: '2023-11-10'
  }
];

export const talents = [
  {
    id: '1',
    name: 'John Doe',
    role: 'Creative Director',
    skills: ['Branding', 'Art Direction', 'Strategy'],
    availability: 'Available',
    rate: 150,
    projects: 12,
    rating: 4.9
  },
  {
    id: '2',
    name: 'Jane Smith',
    role: 'Graphic Designer',
    skills: ['UI/UX', 'Illustration', 'Motion Graphics'],
    availability: 'Busy',
    rate: 120,
    projects: 18,
    rating: 4.8
  },
  {
    id: '3',
    name: 'Mike Johnson',
    role: 'Photographer',
    skills: ['Product Photography', 'Portraits', 'Video'],
    availability: 'Available',
    rate: 180,
    projects: 25,
    rating: 5.0
  }
];

export const documents = [
  {
    id: '1',
    name: 'CREATRVERSE PITCH DECK',
    type: 'Pitch Deck',
    uploadDate: '2025-10-31',
    category: 'Pitch Deck',
    size: '2.4 MB',
    expiryDate: null
  },
  {
    id: '2',
    name: 'Nike_Contract_2024.pdf',
    type: 'Contract',
    uploadDate: '2024-10-20',
    category: 'Contract',
    size: '1.8 MB',
    expiryDate: '2025-10-20'
  },
  {
    id: '3',
    name: 'Q4_2024_Proposal.pdf',
    type: 'Proposal',
    uploadDate: '2024-09-01',
    category: 'Proposal',
    size: '3.2 MB',
    expiryDate: null
  },
  {
    id: '4',
    name: 'JBL_Partnership_Agreement.pdf',
    type: 'Contract',
    uploadDate: '2025-01-15',
    category: 'Contract',
    size: '2.1 MB',
    expiryDate: '2026-01-15'
  }
];

export const tasks = [
  {
    id: '1',
    title: 'Review client feedback',
    description: 'Review and incorporate feedback from Tech Startup Inc',
    status: 'Pending',
    priority: 'High',
    dueDate: '2025-07-16',
    assignedTo: 'John Doe',
    project: 'Brand Refresh Campaign'
  },
  {
    id: '2',
    title: 'Finalize design mockups',
    description: 'Complete final revisions for social media templates',
    status: 'In Progress',
    priority: 'High',
    dueDate: '2025-07-18',
    assignedTo: 'Jane Smith',
    project: 'Social Media Content Pack'
  },
  {
    id: '3',
    title: 'Schedule photoshoot',
    description: 'Book studio and arrange product samples',
    status: 'Pending',
    priority: 'Medium',
    dueDate: '2025-07-25',
    assignedTo: 'Mike Johnson',
    project: 'Product Photography'
  },
  {
    id: '4',
    title: 'Update project documentation',
    description: 'Create comprehensive documentation for the new feature set',
    status: 'In Progress',
    priority: 'Medium',
    dueDate: '2025-12-31',
    assignedTo: 'Sarah Wilson',
    project: 'Documentation'
  },
  {
    id: '5',
    title: 'Deploy production hotfix',
    description: 'Fix critical bug in payment processing system',
    status: 'Pending',
    priority: 'High',
    dueDate: '2025-12-30',
    assignedTo: 'Tech Team',
    project: 'Production Support'
  },
  {
    id: '6',
    title: 'Quarterly business review preparation',
    description: 'Prepare slides and reports for Q4 2025 business review',
    status: 'In Progress',
    priority: 'High',
    dueDate: '2026-01-05',
    assignedTo: 'Leadership Team',
    project: 'Business Planning'
  },
  {
    id: '7',
    title: 'Interview candidates for designer role',
    description: 'Conduct interviews with 5 shortlisted candidates',
    status: 'Pending',
    priority: 'Medium',
    dueDate: '2026-01-10',
    assignedTo: 'HR Team',
    project: 'Hiring'
  },
  {
    id: '8',
    title: 'Update website homepage',
    description: 'Refresh homepage design with new brand guidelines',
    status: 'Completed',
    priority: 'Low',
    dueDate: '2025-12-20',
    assignedTo: 'Jane Smith',
    project: 'Website Redesign'
  },
  {
    id: '9',
    title: 'Security audit review',
    description: 'Review and address findings from external security audit',
    status: 'In Progress',
    priority: 'High',
    dueDate: '2025-12-29',
    assignedTo: 'Security Team',
    project: 'Security'
  },
  {
    id: '10',
    title: 'Client onboarding - New Enterprise Account',
    description: 'Set up enterprise client with custom configurations',
    status: 'Pending',
    priority: 'High',
    dueDate: '2025-12-30',
    assignedTo: 'Customer Success',
    project: 'Client Onboarding'
  },
  {
    id: '11',
    title: 'Database performance optimization',
    description: 'Optimize slow queries and add missing indexes',
    status: 'In Progress',
    priority: 'Medium',
    dueDate: '2026-01-02',
    assignedTo: 'Backend Team',
    project: 'Performance'
  },
  {
    id: '12',
    title: 'Mobile app beta testing',
    description: 'Coordinate beta testing with 50 selected users',
    status: 'Pending',
    priority: 'Medium',
    dueDate: '2026-01-15',
    assignedTo: 'Product Team',
    project: 'Mobile App Launch'
  },
  {
    id: '13',
    title: 'API documentation update',
    description: 'Update API docs for v2.0 release',
    status: 'Completed',
    priority: 'Low',
    dueDate: '2025-12-15',
    assignedTo: 'Tech Writers',
    project: 'Documentation'
  },
  {
    id: '14',
    title: 'Marketing campaign launch',
    description: 'Launch Q1 2026 marketing campaign across all channels',
    status: 'Pending',
    priority: 'High',
    dueDate: '2026-01-08',
    assignedTo: 'Marketing Team',
    project: 'Q1 Marketing'
  },
  {
    id: '15',
    title: 'Budget planning for 2026',
    description: 'Create and finalize budget for fiscal year 2026',
    status: 'In Progress',
    priority: 'High',
    dueDate: '2026-01-03',
    assignedTo: 'Finance Team',
    project: 'Financial Planning'
  },
  {
    id: '16',
    title: 'Customer feedback analysis',
    description: 'Analyze Q4 customer feedback and create action plan',
    status: 'Pending',
    priority: 'Medium',
    dueDate: '2026-01-06',
    assignedTo: 'Product Team',
    project: 'Customer Experience'
  },
  {
    id: '17',
    title: 'Team offsite planning',
    description: 'Plan and organize Q1 team offsite event',
    status: 'In Progress',
    priority: 'Low',
    dueDate: '2026-01-20',
    assignedTo: 'HR Team',
    project: 'Team Culture'
  },
  {
    id: '18',
    title: 'Contract renewal with vendors',
    description: 'Review and renew contracts with key vendors',
    status: 'Pending',
    priority: 'Medium',
    dueDate: '2026-01-12',
    assignedTo: 'Operations Team',
    project: 'Vendor Management'
  },
  {
    id: '19',
    title: 'Code refactoring - Authentication module',
    description: 'Refactor authentication code to improve maintainability',
    status: 'In Progress',
    priority: 'Low',
    dueDate: '2026-01-18',
    assignedTo: 'Engineering Team',
    project: 'Technical Debt'
  },
  {
    id: '20',
    title: 'Competitor analysis report',
    description: 'Research competitors and create comprehensive analysis',
    status: 'Completed',
    priority: 'Medium',
    dueDate: '2025-12-22',
    assignedTo: 'Strategy Team',
    project: 'Market Research'
  },
  {
    id: '21',
    title: 'Email template redesign',
    description: 'Update all transactional email templates with new branding',
    status: 'Pending',
    priority: 'Low',
    dueDate: '2026-01-25',
    assignedTo: 'Design Team',
    project: 'Brand Update'
  },
  {
    id: '22',
    title: 'Implement feature flags system',
    description: 'Build feature flagging system for gradual rollouts',
    status: 'In Progress',
    priority: 'Medium',
    dueDate: '2026-01-09',
    assignedTo: 'Platform Team',
    project: 'Infrastructure'
  },
  {
    id: '23',
    title: 'Customer webinar preparation',
    description: 'Prepare content and demos for monthly customer webinar',
    status: 'Pending',
    priority: 'Medium',
    dueDate: '2026-01-07',
    assignedTo: 'Customer Success',
    project: 'Customer Education'
  },
  {
    id: '24',
    title: 'Legal compliance review',
    description: 'Ensure compliance with new data protection regulations',
    status: 'In Progress',
    priority: 'High',
    dueDate: '2025-12-31',
    assignedTo: 'Legal Team',
    project: 'Compliance'
  },
  {
    id: '25',
    title: 'Sales pipeline cleanup',
    description: 'Review and update all deals in sales pipeline',
    status: 'Pending',
    priority: 'Low',
    dueDate: '2026-01-04',
    assignedTo: 'Sales Team',
    project: 'Sales Operations'
  }
];

export const services = [
  {
    id: '1',
    name: 'Brand Identity Design',
    category: 'Creative Services',
    price: 5000,
    duration: '2-3 weeks',
    description: 'Complete brand identity package including logo, colors, typography'
  },
  {
    id: '2',
    name: 'Social Media Management',
    category: 'Creative Services',
    price: 2000,
    duration: 'Monthly',
    description: 'Full social media content creation and management'
  },
  {
    id: '3',
    name: 'AI Content Generation',
    category: 'AI Services',
    price: 1500,
    duration: '1 week',
    description: 'AI-powered content creation for marketing materials'
  },
  {
    id: '4',
    name: 'Product Photography',
    category: 'Creative Services',
    price: 3000,
    duration: '1-2 weeks',
    description: 'Professional product photography and editing'
  }
];

export const messages = [
  {
    id: '1',
    sender: 'Tech Startup Inc',
    subject: 'Project Update Request',
    preview: 'Hi, can we schedule a call to discuss the latest revisions?',
    timestamp: '2025-07-15T10:30:00',
    read: false
  },
  {
    id: '2',
    sender: 'Fashion Boutique',
    subject: 'Final Approval',
    preview: 'Everything looks great! Approved for final delivery.',
    timestamp: '2025-07-14T15:45:00',
    read: true
  },
  {
    id: '3',
    sender: 'E-commerce Store',
    subject: 'New Project Inquiry',
    preview: 'We\'re interested in a new campaign for fall season...',
    timestamp: '2025-07-14T09:20:00',
    read: false
  }
];

export const finances = {
  totalRevenue: 145000,
  totalExpenses: 82000,
  profit: 63000,
  pendingInvoices: 12000,
  paidInvoices: 133000,
  monthlyBreakdown: [
    { month: 'Jan', revenue: 18000, expenses: 10000 },
    { month: 'Feb', revenue: 22000, expenses: 12000 },
    { month: 'Mar', revenue: 25000, expenses: 14000 },
    { month: 'Apr', revenue: 20000, expenses: 11000 },
    { month: 'May', revenue: 28000, expenses: 15000 },
    { month: 'Jun', revenue: 32000, expenses: 20000 }
  ]
};

export const equipment = [
  {
    id: '1',
    name: 'Canon EOS R5',
    category: 'Camera',
    status: 'Available',
    location: 'Studio A',
    lastMaintenance: '2025-06-01',
    value: 3900
  },
  {
    id: '2',
    name: 'MacBook Pro 16"',
    category: 'Computer',
    status: 'In Use',
    location: 'Office',
    lastMaintenance: '2025-05-15',
    value: 2500
  },
  {
    id: '3',
    name: 'Studio Lighting Kit',
    category: 'Lighting',
    status: 'Available',
    location: 'Studio A',
    lastMaintenance: '2025-06-20',
    value: 1200
  }
];

// Local Calendar Events Mockup - For MainCalendar component
export const localCalendarEvents = [
  // December 2025 - Events for immediate display
  {
    id: 'local-dec-1',
    title: 'Year-End Team Celebration',
    date: '2025-12-30',
    time: '17:00',
    duration: '3h',
    location: 'Office Common Area',
    description: 'Celebrate 2025 achievements',
    category: 'events',
    type: 'Social'
  },
  {
    id: 'local-dec-2',
    title: 'Final Budget Review',
    date: '2025-12-30',
    time: '10:00',
    duration: '2h',
    location: 'Finance Office',
    description: 'Close out 2025 financials',
    category: 'meeting',
    type: 'Meeting'
  },
  {
    id: 'local-dec-3',
    title: 'New Year Planning Session',
    date: '2025-12-31',
    time: '09:00',
    duration: '2h',
    location: 'Conference Room A',
    description: 'Set 2026 objectives',
    category: 'meeting',
    type: 'Meeting'
  },
  {
    id: 'local-dec-4',
    title: 'Office Closure Prep',
    date: '2025-12-31',
    time: '14:00',
    duration: '2h',
    location: 'Office',
    description: 'Prepare for holiday closure',
    category: 'meeting',
    type: 'Meeting'
  },
  // January 2026 - Work Events
  {
    id: 'local-1',
    title: 'Quarterly Business Review',
    date: '2026-01-02',
    time: '09:00',
    duration: '2h',
    location: 'Board Room',
    description: 'Q4 2025 results presentation',
    category: 'meeting',
    type: 'Meeting'
  },
  {
    id: 'local-2',
    title: 'New Hire Orientation',
    date: '2026-01-03',
    time: '09:00',
    duration: '3h',
    location: 'Training Room A',
    description: 'Welcome new team members',
    category: 'meeting',
    type: 'Meeting'
  },
  {
    id: 'local-3',
    title: 'Project Kickoff - Mobile App',
    date: '2026-01-06',
    time: '14:00',
    duration: '2h',
    location: 'Conference Room',
    description: 'Launch new mobile app project',
    category: 'meeting',
    type: 'Meeting'
  },
  {
    id: 'local-4',
    title: 'Tech Lunch & Learn',
    date: '2026-01-08',
    time: '12:00',
    duration: '1h',
    location: 'Cafeteria',
    description: 'AI and Machine Learning trends',
    category: 'events',
    type: 'Event'
  },
  {
    id: 'local-5',
    title: 'Client Presentation - Phase 2',
    date: '2026-01-09',
    time: '15:00',
    duration: '2h',
    location: 'Virtual - Zoom',
    description: 'Present deliverables to client',
    category: 'meeting',
    type: 'Meeting'
  },
  {
    id: 'local-6',
    title: 'Team Happy Hour',
    date: '2026-01-10',
    time: '17:30',
    duration: '2h',
    location: 'Local Pub',
    description: 'Informal team gathering',
    category: 'events',
    type: 'Social'
  },
  {
    id: 'local-7',
    title: 'Strategic Planning Workshop',
    date: '2026-01-13',
    time: '10:00',
    duration: '5h',
    location: 'Executive Suite',
    description: '2026 strategy session',
    category: 'meeting',
    type: 'Workshop'
  },
  {
    id: 'local-8',
    title: 'Performance Review - Direct Reports',
    date: '2026-01-14',
    time: '13:00',
    duration: '4h',
    location: 'Office',
    description: 'Annual performance evaluations',
    category: 'meeting',
    type: 'Meeting'
  },
  {
    id: 'local-9',
    title: 'Product Roadmap Planning',
    date: '2026-01-16',
    time: '09:00',
    duration: '3h',
    location: 'Product Office',
    description: 'Define Q1 priorities',
    category: 'meeting',
    type: 'Planning'
  },
  {
    id: 'local-10',
    title: 'Industry Conference - Tech Summit',
    date: '2026-01-20',
    time: '08:00',
    duration: '10h',
    location: 'Convention Center',
    description: 'Annual tech industry event',
    category: 'events',
    type: 'Conference'
  },
  {
    id: 'local-11',
    title: 'Vendor Negotiation Meeting',
    date: '2026-01-22',
    time: '14:00',
    duration: '2h',
    location: 'Conference Room B',
    description: 'Negotiate software licensing',
    category: 'meeting',
    type: 'Meeting'
  },
  {
    id: 'local-12',
    title: 'All-Hands Town Hall',
    date: '2026-01-24',
    time: '16:00',
    duration: '1h',
    location: 'Main Auditorium',
    description: 'Company updates and Q&A',
    category: 'meeting',
    type: 'Meeting'
  },
  {
    id: 'local-13',
    title: 'Marketing Campaign Launch',
    date: '2026-01-27',
    time: '10:00',
    duration: '1h',
    location: 'Marketing Department',
    description: 'Launch Q1 marketing campaign',
    category: 'events',
    type: 'Event'
  },
  {
    id: 'local-14',
    title: 'Innovation Workshop',
    date: '2026-01-29',
    time: '13:00',
    duration: '4h',
    location: 'Innovation Lab',
    description: 'Brainstorm new product ideas',
    category: 'meeting',
    type: 'Workshop'
  },
  // February 2026
  {
    id: 'local-15',
    title: 'Monthly Team Sync',
    date: '2026-02-03',
    time: '10:00',
    duration: '1h',
    location: 'Virtual - Teams',
    description: 'February team alignment',
    category: 'meeting',
    type: 'Meeting'
  },
  {
    id: 'local-16',
    title: 'Sales Kickoff Event',
    date: '2026-02-05',
    time: '09:00',
    duration: '8h',
    location: 'Hotel Conference Center',
    description: 'Q1 sales targets and strategy',
    category: 'events',
    type: 'Event'
  },
  {
    id: 'local-17',
    title: 'IT Infrastructure Review',
    date: '2026-02-07',
    time: '14:00',
    duration: '2h',
    location: 'IT Department',
    description: 'System performance and upgrades',
    category: 'meeting',
    type: 'Meeting'
  },
  {
    id: 'local-18',
    title: 'Customer Advisory Board',
    date: '2026-02-10',
    time: '11:00',
    duration: '4h',
    location: 'Virtual - Zoom',
    description: 'Quarterly customer feedback session',
    category: 'meeting',
    type: 'Meeting'
  },
  {
    id: 'local-19',
    title: 'Diversity & Inclusion Workshop',
    date: '2026-02-12',
    time: '13:00',
    duration: '3h',
    location: 'Training Center',
    description: 'Building inclusive teams',
    category: 'events',
    type: 'Workshop'
  },
  {
    id: 'local-20',
    title: 'Executive Leadership Retreat',
    date: '2026-02-17',
    time: '08:00',
    duration: '3 days',
    location: 'Mountain Resort',
    description: '3-day strategic planning offsite',
    category: 'events',
    type: 'Retreat'
  },
  {
    id: 'local-21',
    title: 'Product Beta Testing Review',
    date: '2026-02-21',
    time: '10:00',
    duration: '2h',
    location: 'Product Office',
    description: 'Analyze beta user feedback',
    category: 'meeting',
    type: 'Meeting'
  },
  {
    id: 'local-22',
    title: 'Compliance Training - Data Privacy',
    date: '2026-02-25',
    time: '14:00',
    duration: '2h',
    location: 'Legal Department',
    description: 'GDPR and CCPA requirements',
    category: 'events',
    type: 'Training'
  },
  {
    id: 'local-23',
    title: 'Engineering Architecture Review',
    date: '2026-02-27',
    time: '13:00',
    duration: '3h',
    location: 'Tech Lab',
    description: 'Technical design review',
    category: 'meeting',
    type: 'Meeting'
  },
  // March 2026
  {
    id: 'local-24',
    title: 'Board of Directors Meeting',
    date: '2026-03-03',
    time: '09:00',
    duration: '4h',
    location: 'Executive Board Room',
    description: 'Quarterly board meeting',
    category: 'meeting',
    type: 'Meeting'
  },
  {
    id: 'local-25',
    title: 'Product Launch Event',
    date: '2026-03-05',
    time: '10:00',
    duration: '2h',
    location: 'Press Conference Hall',
    description: 'Public launch of new product',
    category: 'events',
    type: 'Event'
  },
  {
    id: 'local-26',
    title: 'Partner Summit',
    date: '2026-03-10',
    time: '09:00',
    duration: '2 days',
    location: 'Downtown Hotel',
    description: 'Annual partner conference',
    category: 'events',
    type: 'Conference'
  },
  {
    id: 'local-27',
    title: 'Security Awareness Training',
    date: '2026-03-12',
    time: '10:00',
    duration: '1.5h',
    location: 'Virtual - Webinar',
    description: 'Cybersecurity best practices',
    category: 'events',
    type: 'Training'
  },
  {
    id: 'local-28',
    title: 'Customer Success Workshop',
    date: '2026-03-16',
    time: '14:00',
    duration: '3h',
    location: 'Customer Success Office',
    description: 'Improve customer retention',
    category: 'meeting',
    type: 'Workshop'
  },
  {
    id: 'local-29',
    title: 'Hackathon - Innovation Day',
    date: '2026-03-20',
    time: '09:00',
    duration: '11h',
    location: 'Engineering Floor',
    description: '24-hour coding challenge',
    category: 'events',
    type: 'Event'
  },
  {
    id: 'local-30',
    title: 'Financial Year-End Review',
    date: '2026-03-25',
    time: '11:00',
    duration: '3h',
    location: 'Finance Department',
    description: 'FY 2025 closing review',
    category: 'meeting',
    type: 'Meeting'
  },
  {
    id: 'local-31',
    title: 'Employee Recognition Ceremony',
    date: '2026-03-28',
    time: '16:00',
    duration: '2h',
    location: 'Main Auditorium',
    description: 'Celebrate team achievements',
    category: 'events',
    type: 'Event'
  },
  {
    id: 'local-32',
    title: 'Q1 Results Presentation',
    date: '2026-03-31',
    time: '10:00',
    duration: '2h',
    location: 'Executive Suite',
    description: 'Present Q1 2026 results',
    category: 'meeting',
    type: 'Meeting'
  }
];

export const calendar = [
  {
    id: '1',
    title: 'Client Meeting - Tech Startup',
    date: '2025-07-16',
    time: '10:00 AM',
    type: 'Meeting',
    location: 'Conference Room'
  },
  {
    id: '2',
    title: 'Photoshoot - E-commerce',
    date: '2025-07-18',
    time: '2:00 PM',
    type: 'Production',
    location: 'Studio A'
  },
  {
    id: '3',
    title: 'Design Review',
    date: '2025-07-19',
    time: '11:00 AM',
    type: 'Review',
    location: 'Online'
  },
  {
    id: '4',
    title: 'Team Standup',
    date: '2025-12-30',
    time: '9:00 AM',
    type: 'Meeting',
    location: 'Virtual - Zoom'
  },
  {
    id: '5',
    title: 'Product Launch Planning',
    date: '2025-12-30',
    time: '2:00 PM',
    type: 'Planning',
    location: 'Main Office'
  },
  {
    id: '6',
    title: 'Investor Presentation',
    date: '2025-12-31',
    time: '10:30 AM',
    type: 'Presentation',
    location: 'Board Room'
  },
  {
    id: '7',
    title: 'Year-End Company Party',
    date: '2025-12-31',
    time: '6:00 PM',
    type: 'Social',
    location: 'Downtown Event Center'
  },
  {
    id: '8',
    title: 'Marketing Campaign Review',
    date: '2026-01-02',
    time: '11:00 AM',
    type: 'Review',
    location: 'Marketing Department'
  },
  {
    id: '9',
    title: 'New Employee Onboarding',
    date: '2026-01-02',
    time: '9:00 AM',
    type: 'Training',
    location: 'HR Conference Room'
  },
  {
    id: '10',
    title: 'Engineering Sprint Planning',
    date: '2026-01-03',
    time: '10:00 AM',
    type: 'Planning',
    location: 'Engineering Office'
  },
  {
    id: '11',
    title: 'Customer Feedback Session',
    date: '2026-01-03',
    time: '3:00 PM',
    type: 'Meeting',
    location: 'Virtual - Google Meet'
  },
  {
    id: '12',
    title: 'Budget Planning Workshop',
    date: '2026-01-04',
    time: '1:00 PM',
    type: 'Workshop',
    location: 'Finance Department'
  },
  {
    id: '13',
    title: 'Sales Team Training',
    date: '2026-01-05',
    time: '9:00 AM',
    type: 'Training',
    location: 'Training Center'
  },
  {
    id: '14',
    title: 'Board Meeting - Q4 Review',
    date: '2026-01-05',
    time: '2:00 PM',
    type: 'Meeting',
    location: 'Executive Board Room'
  },
  {
    id: '15',
    title: 'Product Demo for Enterprise Client',
    date: '2026-01-06',
    time: '11:00 AM',
    type: 'Demonstration',
    location: 'Client Office'
  },
  {
    id: '16',
    title: 'Team Building Activity',
    date: '2026-01-06',
    time: '4:00 PM',
    type: 'Social',
    location: 'Outdoor Park'
  },
  {
    id: '17',
    title: 'Security Audit Meeting',
    date: '2026-01-07',
    time: '10:00 AM',
    type: 'Meeting',
    location: 'IT Department'
  },
  {
    id: '18',
    title: 'Quarterly All-Hands Meeting',
    date: '2026-01-08',
    time: '3:00 PM',
    type: 'Meeting',
    location: 'Main Auditorium'
  },
  {
    id: '19',
    title: 'UI/UX Design Workshop',
    date: '2026-01-09',
    time: '10:00 AM',
    type: 'Workshop',
    location: 'Design Studio'
  },
  {
    id: '20',
    title: 'Partnership Discussion - Tech Corp',
    date: '2026-01-09',
    time: '2:00 PM',
    type: 'Meeting',
    location: 'Virtual - Microsoft Teams'
  },
  {
    id: '21',
    title: 'Content Strategy Planning',
    date: '2026-01-10',
    time: '11:00 AM',
    type: 'Planning',
    location: 'Marketing Office'
  },
  {
    id: '22',
    title: 'Developer Coffee Chat',
    date: '2026-01-10',
    time: '3:30 PM',
    type: 'Social',
    location: 'Office Cafeteria'
  },
  {
    id: '23',
    title: 'Mobile App Beta Testing Review',
    date: '2026-01-13',
    time: '9:00 AM',
    type: 'Review',
    location: 'Product Office'
  },
  {
    id: '24',
    title: 'Legal Compliance Training',
    date: '2026-01-13',
    time: '2:00 PM',
    type: 'Training',
    location: 'Legal Department'
  },
  {
    id: '25',
    title: 'Customer Webinar - Product Updates',
    date: '2026-01-14',
    time: '1:00 PM',
    type: 'Webinar',
    location: 'Virtual - Zoom Webinar'
  },
  {
    id: '26',
    title: 'Infrastructure Planning Meeting',
    date: '2026-01-14',
    time: '4:00 PM',
    type: 'Planning',
    location: 'DevOps Room'
  },
  {
    id: '27',
    title: 'Vendor Contract Negotiation',
    date: '2026-01-15',
    time: '10:00 AM',
    type: 'Meeting',
    location: 'Procurement Office'
  },
  {
    id: '28',
    title: 'Team Lunch - Celebrating Milestone',
    date: '2026-01-15',
    time: '12:30 PM',
    type: 'Social',
    location: 'Italian Restaurant Downtown'
  },
  {
    id: '29',
    title: 'Annual Performance Reviews',
    date: '2026-01-16',
    time: '9:00 AM',
    type: 'Review',
    location: 'HR Office'
  },
  {
    id: '30',
    title: 'Tech Conference - AI Summit',
    date: '2026-01-17',
    time: '8:00 AM',
    type: 'Conference',
    location: 'Convention Center'
  }
];

// iCloud Calendar Events Mockup - Expanded with more categories
export const icloudCalendarEvents = [
  // January 2026
  {
    id: 'icloud-1',
    title: 'Doctor Appointment',
    summary: 'Doctor Appointment',
    start: '2026-01-02T14:00:00',
    end: '2026-01-02T15:00:00',
    location: 'Medical Center',
    description: 'Annual checkup',
    category: 'personal'
  },
  {
    id: 'icloud-2',
    title: 'Kids Soccer Practice',
    summary: 'Kids Soccer Practice',
    start: '2026-01-03T16:00:00',
    end: '2026-01-03T17:30:00',
    location: 'Community Sports Field',
    description: 'Weekly practice session',
    category: 'personal'
  },
  {
    id: 'icloud-3',
    title: 'Dinner with Family',
    summary: 'Dinner with Family',
    start: '2026-01-04T19:00:00',
    end: '2026-01-04T21:00:00',
    location: 'Steakhouse Downtown',
    description: 'Family dinner celebration',
    category: 'personal'
  },
  {
    id: 'icloud-4',
    title: 'Gym Session',
    summary: 'Gym Session',
    start: '2026-01-06T07:00:00',
    end: '2026-01-06T08:00:00',
    location: 'Fitness Center',
    description: 'Morning workout',
    category: 'personal'
  },
  {
    id: 'icloud-5',
    title: 'Book Club Meeting',
    summary: 'Book Club Meeting',
    start: '2026-01-07T18:30:00',
    end: '2026-01-07T20:00:00',
    location: 'Local Library',
    description: 'Discussing "The Great Novel"',
    category: 'event'
  },
  {
    id: 'icloud-6',
    title: 'Car Service Appointment',
    summary: 'Car Service Appointment',
    start: '2026-01-08T10:00:00',
    end: '2026-01-08T12:00:00',
    location: 'Auto Service Center',
    description: 'Regular maintenance',
    category: 'personal'
  },
  {
    id: 'icloud-7',
    title: 'Yoga Class',
    summary: 'Yoga Class',
    start: '2026-01-09T18:00:00',
    end: '2026-01-09T19:00:00',
    location: 'Wellness Studio',
    description: 'Evening yoga session',
    category: 'personal'
  },
  {
    id: 'icloud-8',
    title: 'Parent-Teacher Conference',
    summary: 'Parent-Teacher Conference',
    start: '2026-01-10T15:00:00',
    end: '2026-01-10T16:00:00',
    location: 'Elementary School',
    description: 'Q2 progress review',
    category: 'meeting'
  },
  {
    id: 'icloud-9',
    title: 'Dentist Appointment',
    summary: 'Dentist Appointment',
    start: '2026-01-12T09:00:00',
    end: '2026-01-12T10:00:00',
    location: 'Dental Clinic',
    description: 'Routine cleaning',
    category: 'personal'
  },
  {
    id: 'icloud-10',
    title: 'Weekend Hiking Trip',
    summary: 'Weekend Hiking Trip',
    start: '2026-01-18T08:00:00',
    end: '2026-01-18T17:00:00',
    location: 'Mountain Trail',
    description: 'Family outdoor activity',
    category: 'event'
  },
  {
    id: 'icloud-11',
    title: 'Birthday Party - Sarah',
    summary: 'Birthday Party - Sarah',
    start: '2026-01-20T18:00:00',
    end: '2026-01-20T22:00:00',
    location: 'Home',
    description: 'Celebrate Sarah\'s birthday',
    category: 'event'
  },
  {
    id: 'icloud-12',
    title: 'Piano Lesson',
    summary: 'Piano Lesson',
    start: '2026-01-22T16:00:00',
    end: '2026-01-22T17:00:00',
    location: 'Music School',
    description: 'Weekly piano practice',
    category: 'personal'
  },
  {
    id: 'icloud-13',
    title: 'Farmers Market',
    summary: 'Farmers Market',
    start: '2026-01-25T09:00:00',
    end: '2026-01-25T11:00:00',
    location: 'Downtown Square',
    description: 'Weekly grocery shopping',
    category: 'personal'
  },
  {
    id: 'icloud-14',
    title: 'Movie Night with Friends',
    summary: 'Movie Night with Friends',
    start: '2026-01-30T19:00:00',
    end: '2026-01-30T22:00:00',
    location: 'Cinema',
    description: 'Watch new release',
    category: 'event'
  },
  // February 2026
  {
    id: 'icloud-15',
    title: 'Vet Appointment - Max',
    summary: 'Vet Appointment - Max',
    start: '2026-02-03T14:00:00',
    end: '2026-02-03T15:00:00',
    location: 'Animal Hospital',
    description: 'Annual checkup for dog',
    category: 'personal'
  },
  {
    id: 'icloud-16',
    title: 'Cooking Class',
    summary: 'Cooking Class',
    start: '2026-02-05T18:30:00',
    end: '2026-02-05T20:30:00',
    location: 'Culinary School',
    description: 'Italian cuisine workshop',
    category: 'event'
  },
  {
    id: 'icloud-17',
    title: 'School Fundraiser',
    summary: 'School Fundraiser',
    start: '2026-02-08T15:00:00',
    end: '2026-02-08T18:00:00',
    location: 'School Gym',
    description: 'Annual charity event',
    category: 'event'
  },
  {
    id: 'icloud-18',
    title: 'Swimming Lessons',
    summary: 'Swimming Lessons',
    start: '2026-02-12T17:00:00',
    end: '2026-02-12T18:00:00',
    location: 'Community Pool',
    description: 'Kids swimming class',
    category: 'personal'
  },
  {
    id: 'icloud-19',
    title: 'Valentine Day Dinner',
    summary: 'Valentine Day Dinner',
    start: '2026-02-14T19:00:00',
    end: '2026-02-14T22:00:00',
    location: 'French Restaurant',
    description: 'Romantic dinner',
    category: 'event'
  },
  {
    id: 'icloud-20',
    title: 'Home Renovation Meeting',
    summary: 'Home Renovation Meeting',
    start: '2026-02-18T10:00:00',
    end: '2026-02-18T11:30:00',
    location: 'Home',
    description: 'Meet with contractor',
    category: 'meeting'
  },
  {
    id: 'icloud-21',
    title: 'Neighborhood BBQ',
    summary: 'Neighborhood BBQ',
    start: '2026-02-22T17:00:00',
    end: '2026-02-22T21:00:00',
    location: 'Community Park',
    description: 'Community gathering',
    category: 'event'
  },
  {
    id: 'icloud-22',
    title: 'Art Gallery Opening',
    summary: 'Art Gallery Opening',
    start: '2026-02-27T18:00:00',
    end: '2026-02-27T21:00:00',
    location: 'Downtown Gallery',
    description: 'Local artist exhibition',
    category: 'event'
  },
  // March 2026
  {
    id: 'icloud-23',
    title: 'Spring Garden Prep',
    summary: 'Spring Garden Prep',
    start: '2026-03-05T10:00:00',
    end: '2026-03-05T14:00:00',
    location: 'Home Garden',
    description: 'Prepare garden for spring',
    category: 'personal'
  },
  {
    id: 'icloud-24',
    title: 'Wine Tasting Event',
    summary: 'Wine Tasting Event',
    start: '2026-03-08T19:00:00',
    end: '2026-03-08T22:00:00',
    location: 'Winery',
    description: 'Wine appreciation night',
    category: 'event'
  },
  {
    id: 'icloud-25',
    title: 'Financial Planning Session',
    summary: 'Financial Planning Session',
    start: '2026-03-12T14:00:00',
    end: '2026-03-12T16:00:00',
    location: 'Financial Advisor Office',
    description: 'Annual review',
    category: 'meeting'
  },
  {
    id: 'icloud-26',
    title: 'Spring Break Trip Planning',
    summary: 'Spring Break Trip Planning',
    start: '2026-03-15T11:00:00',
    end: '2026-03-15T12:00:00',
    location: 'Home',
    description: 'Plan family vacation',
    category: 'personal'
  },
  {
    id: 'icloud-27',
    title: 'Charity Run 5K',
    summary: 'Charity Run 5K',
    start: '2026-03-21T08:00:00',
    end: '2026-03-21T11:00:00',
    location: 'City Park',
    description: 'Annual charity running event',
    category: 'event'
  },
  {
    id: 'icloud-28',
    title: 'Home Inspection',
    summary: 'Home Inspection',
    start: '2026-03-25T13:00:00',
    end: '2026-03-25T15:00:00',
    location: 'Home',
    description: 'Annual property inspection',
    category: 'personal'
  },
  {
    id: 'icloud-29',
    title: 'Music Concert',
    summary: 'Music Concert',
    start: '2026-03-28T20:00:00',
    end: '2026-03-28T23:00:00',
    location: 'Concert Hall',
    description: 'Symphony orchestra performance',
    category: 'event'
  },
  {
    id: 'icloud-30',
    title: 'Easter Celebration',
    summary: 'Easter Celebration',
    start: '2026-03-29T12:00:00',
    end: '2026-03-29T16:00:00',
    location: 'Family Home',
    description: 'Easter brunch and egg hunt',
    category: 'event'
  }
];

// Gmail Calendar Events Mockup
export const gmailCalendarEvents = [
  {
    id: 'gmail-1',
    title: 'Team Retrospective',
    summary: 'Team Retrospective',
    start: '2026-01-02T15:00:00',
    end: '2026-01-02T16:00:00',
    location: 'Virtual - Zoom',
    description: 'Sprint 24 retrospective',
    category: 'meeting'
  },
  {
    id: 'gmail-2',
    title: 'Code Review Session',
    summary: 'Code Review Session',
    start: '2026-01-03T13:00:00',
    end: '2026-01-03T14:00:00',
    location: 'Engineering Office',
    description: 'Review pending PRs',
    category: 'meeting'
  },
  {
    id: 'gmail-3',
    title: 'Product Roadmap Discussion',
    summary: 'Product Roadmap Discussion',
    start: '2026-01-05T16:00:00',
    end: '2026-01-05T17:30:00',
    location: 'Conference Room B',
    description: 'Q1 2026 planning',
    category: 'meeting'
  },
  {
    id: 'gmail-4',
    title: 'Client Demo - Beta Features',
    summary: 'Client Demo - Beta Features',
    start: '2026-01-06T14:00:00',
    end: '2026-01-06T15:00:00',
    location: 'Virtual - Google Meet',
    description: 'Showcase new features',
    category: 'meeting'
  },
  {
    id: 'gmail-5',
    title: 'Architecture Review',
    summary: 'Architecture Review',
    start: '2026-01-07T15:00:00',
    end: '2026-01-07T17:00:00',
    location: 'Tech Lab',
    description: 'Microservices design review',
    category: 'meeting'
  },
  {
    id: 'gmail-6',
    title: 'Stakeholder Update Meeting',
    summary: 'Stakeholder Update Meeting',
    start: '2026-01-08T17:00:00',
    end: '2026-01-08T18:00:00',
    location: 'Executive Conference Room',
    description: 'Monthly progress update',
    category: 'meeting'
  },
  {
    id: 'gmail-7',
    title: 'DevOps Workshop',
    summary: 'DevOps Workshop',
    start: '2026-01-09T14:00:00',
    end: '2026-01-09T16:00:00',
    location: 'Training Room',
    description: 'CI/CD best practices',
    category: 'event'
  },
  {
    id: 'gmail-8',
    title: 'Customer Success Check-in',
    summary: 'Customer Success Check-in',
    start: '2026-01-10T16:00:00',
    end: '2026-01-10T16:30:00',
    location: 'Virtual - Teams',
    description: 'Quarterly customer health review',
    category: 'meeting'
  }
];

// Meeting Mockups - For Meetings page
export const meetingsMockData = [
  // Past Meetings (Completed)
  {
    id: 'meet-1',
    title: 'Q4 2025 Business Review',
    date: '2025-12-15',
    time: '14:00',
    duration: 90,
    meeting_link: 'https://zoom.us/j/1234567890',
    location: '',
    meeting_type: 'virtual',
    category: 'Cresa',
    agenda: '1. Review Q4 financial performance\n2. Discuss key wins and challenges\n3. Set priorities for Q1 2026\n4. Team feedback session',
    notes: 'Strong quarter overall. Revenue exceeded targets by 12%. Team morale is high. Need to focus on client retention in Q1.',
    transcript: 'John: Welcome everyone to our Q4 review. Let\'s start with the financials.\nSarah: We exceeded our revenue target by 12%, which is fantastic.\nMike: The client satisfaction scores are up as well.\nJohn: Great work team. For Q1, let\'s focus on retention strategies.',
    transcription_id: '',
    participants: [
      {
        name: 'John Anderson',
        email: 'john@cresa.com',
        company: 'Cresa',
        role: 'CEO',
        phone: '+1 (555) 100-0001',
        image_url: 'https://randomuser.me/api/portraits/men/1.jpg'
      },
      {
        name: 'Sarah Mitchell',
        email: 'sarah@cresa.com',
        company: 'Cresa',
        role: 'CFO',
        phone: '+1 (555) 100-0002',
        image_url: 'https://randomuser.me/api/portraits/women/2.jpg'
      },
      {
        name: 'Mike Johnson',
        email: 'mike@cresa.com',
        company: 'Cresa',
        role: 'VP Sales',
        phone: '+1 (555) 100-0003',
        image_url: 'https://randomuser.me/api/portraits/men/3.jpg'
      }
    ]
  },
  {
    id: 'meet-2',
    title: 'Product Roadmap Planning',
    date: '2025-12-20',
    time: '10:00',
    duration: 120,
    meeting_link: 'https://teams.microsoft.com/l/meetup-join/19%3ameeting_sample',
    location: '',
    meeting_type: 'virtual',
    category: 'CounterFind',
    agenda: '1. Review current product features\n2. Customer feedback analysis\n3. Prioritize Q1 2026 features\n4. Technical feasibility discussion\n5. Timeline and resource allocation',
    notes: 'Decided to prioritize mobile app enhancements and AI-powered search. Team consensus on 3-month sprint cycles.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Emily Chen',
        email: 'emily@counterfind.com',
        company: 'CounterFind',
        role: 'Product Manager',
        phone: '+1 (555) 200-0001',
        image_url: 'https://randomuser.me/api/portraits/women/4.jpg'
      },
      {
        name: 'David Park',
        email: 'david@counterfind.com',
        company: 'CounterFind',
        role: 'Engineering Lead',
        phone: '+1 (555) 200-0002',
        image_url: 'https://randomuser.me/api/portraits/men/5.jpg'
      }
    ]
  },
  {
    id: 'meet-3',
    title: 'Investor Relations Meeting',
    date: '2025-12-22',
    time: '15:30',
    duration: 60,
    meeting_link: '',
    location: 'Downtown Office - Conference Room A',
    meeting_type: 'in-person',
    category: 'Investments',
    agenda: '1. Portfolio performance update\n2. New investment opportunities\n3. Market trends discussion\n4. Q&A session',
    notes: 'Investors pleased with portfolio performance. Expressed interest in expanding into emerging markets. Follow-up meeting scheduled for February.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Robert Williams',
        email: 'robert@greenstone.capital',
        company: 'Greenstone Capital',
        role: 'Managing Partner',
        phone: '+1 (555) 300-0001',
        image_url: 'https://randomuser.me/api/portraits/men/6.jpg'
      },
      {
        name: 'Lisa Thompson',
        email: 'lisa@venture.group',
        company: 'Venture Group',
        role: 'Investment Director',
        phone: '+1 (555) 300-0002',
        image_url: 'https://randomuser.me/api/portraits/women/7.jpg'
      }
    ]
  },

  // Upcoming Meetings
  {
    id: 'meet-4',
    title: 'Tech Conference Keynote Prep',
    date: '2026-01-05',
    time: '09:00',
    duration: 90,
    meeting_link: 'https://zoom.us/j/9876543210',
    location: '',
    meeting_type: 'virtual',
    category: 'Speaking',
    agenda: '1. Review keynote presentation slides\n2. Practice Q&A responses\n3. Technical setup review\n4. Marketing coordination\n5. Final rehearsal',
    notes: '',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Rachel Adams',
        email: 'rachel@techconf.com',
        company: 'Tech Conference 2026',
        role: 'Event Coordinator',
        phone: '+1 (555) 400-0001',
        image_url: 'https://randomuser.me/api/portraits/women/8.jpg'
      },
      {
        name: 'Tom Baker',
        email: 'tom@speakerbureau.com',
        company: 'Speaker Bureau',
        role: 'Speaking Coach',
        phone: '+1 (555) 400-0002',
        image_url: 'https://randomuser.me/api/portraits/men/9.jpg'
      }
    ]
  },
  {
    id: 'meet-5',
    title: 'Weekly Team Sync',
    date: '2026-01-06',
    time: '10:00',
    duration: 30,
    meeting_link: 'https://teams.microsoft.com/l/meetup-join/19%3ameeting_weekly',
    location: '',
    meeting_type: 'virtual',
    category: 'Personal',
    agenda: '1. Week highlights and blockers\n2. Sprint progress review\n3. Resource allocation\n4. Upcoming deliverables',
    notes: '',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Jennifer Lee',
        email: 'jennifer@company.com',
        company: 'Internal Team',
        role: 'Team Lead',
        phone: '+1 (555) 500-0001',
        image_url: 'https://randomuser.me/api/portraits/women/10.jpg'
      },
      {
        name: 'Chris Martinez',
        email: 'chris@company.com',
        company: 'Internal Team',
        role: 'Senior Developer',
        phone: '+1 (555) 500-0002',
        image_url: 'https://randomuser.me/api/portraits/men/11.jpg'
      },
      {
        name: 'Amanda Foster',
        email: 'amanda@company.com',
        company: 'Internal Team',
        role: 'Designer',
        phone: '+1 (555) 500-0003',
        image_url: 'https://randomuser.me/api/portraits/women/12.jpg'
      }
    ]
  },
  {
    id: 'meet-6',
    title: 'Client Onboarding Session',
    date: '2026-01-07',
    time: '14:00',
    duration: 60,
    meeting_link: 'https://zoom.us/j/5555555555',
    location: '',
    meeting_type: 'virtual',
    category: 'Cresa',
    agenda: '1. Welcome and introductions\n2. Platform walkthrough\n3. Account setup\n4. Training resources overview\n5. Q&A session',
    notes: '',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Patricia Davis',
        email: 'patricia@newclient.com',
        company: 'New Client Corp',
        role: 'Operations Manager',
        phone: '+1 (555) 600-0001',
        image_url: 'https://randomuser.me/api/portraits/women/13.jpg'
      },
      {
        name: 'Kevin Wright',
        email: 'kevin@cresa.com',
        company: 'Cresa',
        role: 'Customer Success Manager',
        phone: '+1 (555) 600-0002',
        image_url: 'https://randomuser.me/api/portraits/men/14.jpg'
      }
    ]
  },
  {
    id: 'meet-7',
    title: 'Strategic Partnership Discussion',
    date: '2026-01-08',
    time: '11:00',
    duration: 90,
    meeting_link: '',
    location: 'Partner Office - 123 Business Plaza',
    meeting_type: 'in-person',
    category: 'CounterFind',
    agenda: '1. Partnership opportunity overview\n2. Integration possibilities\n3. Revenue sharing model\n4. Timeline and milestones\n5. Legal considerations',
    notes: '',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Steven Garcia',
        email: 'steven@partnerco.com',
        company: 'Partner Co',
        role: 'VP Business Development',
        phone: '+1 (555) 700-0001',
        image_url: 'https://randomuser.me/api/portraits/men/15.jpg'
      },
      {
        name: 'Michelle Rodriguez',
        email: 'michelle@counterfind.com',
        company: 'CounterFind',
        role: 'Chief Strategy Officer',
        phone: '+1 (555) 700-0002',
        image_url: 'https://randomuser.me/api/portraits/women/16.jpg'
      }
    ]
  },
  {
    id: 'meet-8',
    title: 'Q1 Budget Review',
    date: '2026-01-09',
    time: '13:00',
    duration: 75,
    meeting_link: 'https://teams.microsoft.com/l/meetup-join/19%3ameeting_budget',
    location: '',
    meeting_type: 'virtual',
    category: 'Personal',
    agenda: '1. Q4 spending analysis\n2. Q1 budget allocation\n3. Cost optimization opportunities\n4. Department requests review\n5. Approval process',
    notes: '',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Daniel Taylor',
        email: 'daniel@company.com',
        company: 'Finance Team',
        role: 'Financial Controller',
        phone: '+1 (555) 800-0001',
        image_url: 'https://randomuser.me/api/portraits/men/17.jpg'
      },
      {
        name: 'Nancy Wilson',
        email: 'nancy@company.com',
        company: 'Finance Team',
        role: 'Budget Analyst',
        phone: '+1 (555) 800-0002',
        image_url: 'https://randomuser.me/api/portraits/women/18.jpg'
      }
    ]
  },
  {
    id: 'meet-9',
    title: 'Innovation Workshop',
    date: '2026-01-10',
    time: '10:00',
    duration: 180,
    meeting_link: '',
    location: 'Innovation Lab - Building C',
    meeting_type: 'in-person',
    category: 'Other',
    agenda: '1. Brainstorming session: Future products\n2. Market trends analysis\n3. Customer pain points discussion\n4. Rapid prototyping exercises\n5. Action items and next steps',
    notes: '',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Brian Moore',
        email: 'brian@company.com',
        company: 'Innovation Team',
        role: 'Innovation Director',
        phone: '+1 (555) 900-0001',
        image_url: 'https://randomuser.me/api/portraits/men/19.jpg'
      },
      {
        name: 'Jessica Brown',
        email: 'jessica@company.com',
        company: 'Innovation Team',
        role: 'Design Lead',
        phone: '+1 (555) 900-0002',
        image_url: 'https://randomuser.me/api/portraits/women/20.jpg'
      },
      {
        name: 'Mark Phillips',
        email: 'mark@company.com',
        company: 'Innovation Team',
        role: 'Product Strategist',
        phone: '+1 (555) 900-0003',
        image_url: 'https://randomuser.me/api/portraits/men/21.jpg'
      }
    ]
  },
  {
    id: 'meet-10',
    title: 'Quarterly All-Hands Meeting',
    date: '2026-01-13',
    time: '16:00',
    duration: 60,
    meeting_link: 'https://zoom.us/j/1111111111',
    location: '',
    meeting_type: 'virtual',
    category: 'Personal',
    agenda: '1. Company updates and milestones\n2. Team achievements recognition\n3. Strategic direction for Q1\n4. Open forum Q&A\n5. Closing remarks',
    notes: '',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'William Scott',
        email: 'william@company.com',
        company: 'Executive Team',
        role: 'CEO',
        phone: '+1 (555) 1000-0001',
        image_url: 'https://randomuser.me/api/portraits/men/22.jpg'
      },
      {
        name: 'Linda Harris',
        email: 'linda@company.com',
        company: 'Executive Team',
        role: 'COO',
        phone: '+1 (555) 1000-0002',
        image_url: 'https://randomuser.me/api/portraits/women/23.jpg'
      }
    ]
  },
  {
    id: 'meet-11',
    title: 'Sales Strategy Session',
    date: '2026-01-14',
    time: '09:30',
    duration: 90,
    meeting_link: 'https://teams.microsoft.com/l/meetup-join/19%3ameeting_sales',
    location: '',
    meeting_type: 'virtual',
    category: 'Cresa',
    agenda: '1. Q1 sales targets review\n2. New prospect pipeline\n3. Competitive analysis\n4. Sales enablement tools\n5. Territory assignments',
    notes: '',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Andrew Clark',
        email: 'andrew@cresa.com',
        company: 'Cresa',
        role: 'Sales Director',
        phone: '+1 (555) 1100-0001',
        image_url: 'https://randomuser.me/api/portraits/men/24.jpg'
      },
      {
        name: 'Karen Lewis',
        email: 'karen@cresa.com',
        company: 'Cresa',
        role: 'Senior Sales Manager',
        phone: '+1 (555) 1100-0002',
        image_url: 'https://randomuser.me/api/portraits/women/25.jpg'
      }
    ]
  },
  {
    id: 'meet-12',
    title: 'Technical Architecture Review',
    date: '2026-01-15',
    time: '14:00',
    duration: 120,
    meeting_link: 'https://zoom.us/j/2222222222',
    location: '',
    meeting_type: 'virtual',
    category: 'CounterFind',
    agenda: '1. Current system architecture overview\n2. Scalability challenges discussion\n3. Proposed improvements and migration plan\n4. Security audit findings\n5. Implementation timeline',
    notes: '',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Richard Turner',
        email: 'richard@counterfind.com',
        company: 'CounterFind',
        role: 'Chief Technology Officer',
        phone: '+1 (555) 1200-0001',
        image_url: 'https://randomuser.me/api/portraits/men/26.jpg'
      },
      {
        name: 'Susan White',
        email: 'susan@counterfind.com',
        company: 'CounterFind',
        role: 'Solutions Architect',
        phone: '+1 (555) 1200-0002',
        image_url: 'https://randomuser.me/api/portraits/women/27.jpg'
      },
      {
        name: 'James King',
        email: 'james@counterfind.com',
        company: 'CounterFind',
        role: 'Security Engineer',
        phone: '+1 (555) 1200-0003',
        image_url: 'https://randomuser.me/api/portraits/men/28.jpg'
      }
    ]
  }
];

// Design Team Meetings Mock Data - For Design Team Meetings page
export const designTeamMeetingsMockData = [
  {
    id: 'dt-meet-1',
    title: 'Brand Identity Presentation - TechFlow Startup',
    date: '2026-01-02',
    time: '10:00',
    duration: 90,
    meeting_link: 'https://zoom.us/j/designteam001',
    location: '',
    meeting_type: 'virtual',
    category: 'Client',
    agenda: '1. Brand discovery workshop results\n2. Logo concepts presentation\n3. Color palette & typography review\n4. Brand guidelines overview\n5. Next steps and timeline',
    notes: 'Client loves the modern, tech-focused direction. Requested minor adjustments to logo concept #2.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Sarah Chen',
        email: 'sarah@techflow.com',
        company: 'TechFlow Startup',
        role: 'CEO',
        phone: '+1 (555) 100-0001',
        image_url: 'https://randomuser.me/api/portraits/women/1.jpg'
      },
      {
        name: 'David Park',
        email: 'david@designagency.com',
        company: 'Design Agency',
        role: 'Creative Director',
        phone: '+1 (555) 100-0002',
        image_url: 'https://randomuser.me/api/portraits/men/2.jpg'
      }
    ]
  },
  {
    id: 'dt-meet-2',
    title: 'Urban Fashion Photoshoot Planning',
    date: '2026-01-03',
    time: '14:00',
    duration: 60,
    meeting_link: '',
    location: 'Studio A - 456 Design Street',
    meeting_type: 'in-person',
    category: 'Production',
    agenda: '1. Shot list review\n2. Location scouting results\n3. Model selection\n4. Wardrobe coordination\n5. Production timeline',
    notes: 'Confirmed studio booking for Jan 15-16. Need to finalize model contracts by end of week.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Jennifer Williams',
        email: 'jennifer@designagency.com',
        company: 'Design Agency',
        role: 'Lead Photographer',
        phone: '+1 (555) 100-0003',
        image_url: 'https://randomuser.me/api/portraits/women/3.jpg'
      },
      {
        name: 'Marcus Johnson',
        email: 'marcus@designagency.com',
        company: 'Design Agency',
        role: 'Production Manager',
        phone: '+1 (555) 100-0004',
        image_url: 'https://randomuser.me/api/portraits/men/4.jpg'
      }
    ]
  },
  {
    id: 'dt-meet-3',
    title: 'Website Redesign Kickoff - E-commerce Client',
    date: '2026-01-05',
    time: '11:00',
    duration: 120,
    meeting_link: 'https://teams.microsoft.com/l/meetup-join/19%3ameeting_designteam',
    location: '',
    meeting_type: 'virtual',
    category: 'Client',
    agenda: '1. Current website audit findings\n2. User experience pain points\n3. New design direction proposal\n4. Technical requirements\n5. Project timeline and milestones',
    notes: 'Client wants mobile-first approach. Priority on improving checkout flow.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Emily Rodriguez',
        email: 'emily@ecommerce.com',
        company: 'E-commerce Store',
        role: 'Marketing Director',
        phone: '+1 (555) 100-0005',
        image_url: 'https://randomuser.me/api/portraits/women/5.jpg'
      },
      {
        name: 'Alex Thompson',
        email: 'alex@designagency.com',
        company: 'Design Agency',
        role: 'UX Lead',
        phone: '+1 (555) 100-0006',
        image_url: 'https://randomuser.me/api/portraits/men/6.jpg'
      }
    ]
  },
  {
    id: 'dt-meet-4',
    title: 'Creative Team Weekly Sync',
    date: '2026-01-06',
    time: '09:00',
    duration: 45,
    meeting_link: 'https://zoom.us/j/designteam002',
    location: '',
    meeting_type: 'virtual',
    category: 'Team',
    agenda: '1. Project status updates\n2. Resource allocation\n3. Client feedback review\n4. Blockers and challenges\n5. Week ahead priorities',
    notes: '',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'David Park',
        email: 'david@designagency.com',
        company: 'Design Agency',
        role: 'Creative Director',
        phone: '+1 (555) 100-0007',
        image_url: 'https://randomuser.me/api/portraits/men/7.jpg'
      },
      {
        name: 'Rachel Kim',
        email: 'rachel@designagency.com',
        company: 'Design Agency',
        role: 'Senior Designer',
        phone: '+1 (555) 100-0008',
        image_url: 'https://randomuser.me/api/portraits/women/8.jpg'
      },
      {
        name: 'Chris Martinez',
        email: 'chris@designagency.com',
        company: 'Design Agency',
        role: 'Art Director',
        phone: '+1 (555) 100-0009',
        image_url: 'https://randomuser.me/api/portraits/men/9.jpg'
      }
    ]
  },
  {
    id: 'dt-meet-5',
    title: 'Social Media Campaign Review',
    date: '2026-01-08',
    time: '15:00',
    duration: 60,
    meeting_link: '',
    location: 'Conference Room B',
    meeting_type: 'in-person',
    category: 'Internal',
    agenda: '1. Campaign performance metrics\n2. Content calendar review\n3. Engagement analysis\n4. A/B testing results\n5. Q1 strategy adjustments',
    notes: 'Instagram Stories outperforming static posts. Consider increasing video content.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Lisa Anderson',
        email: 'lisa@designagency.com',
        company: 'Design Agency',
        role: 'Social Media Manager',
        phone: '+1 (555) 100-0010',
        image_url: 'https://randomuser.me/api/portraits/women/10.jpg'
      },
      {
        name: 'Tom Wilson',
        email: 'tom@designagency.com',
        company: 'Design Agency',
        role: 'Content Strategist',
        phone: '+1 (555) 100-0011',
        image_url: 'https://randomuser.me/api/portraits/men/11.jpg'
      }
    ]
  },
  {
    id: 'dt-meet-6',
    title: 'Motion Graphics Project - Animation Review',
    date: '2026-01-09',
    time: '13:00',
    duration: 90,
    meeting_link: 'https://zoom.us/j/designteam003',
    location: '',
    meeting_type: 'virtual',
    category: 'Production',
    agenda: '1. Storyboard walkthrough\n2. Animation style frames review\n3. Sound design discussion\n4. Client feedback incorporation\n5. Final delivery timeline',
    notes: 'Client approved animation style. Moving to full production phase.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Kevin Zhang',
        email: 'kevin@designagency.com',
        company: 'Design Agency',
        role: 'Motion Designer',
        phone: '+1 (555) 100-0012',
        image_url: 'https://randomuser.me/api/portraits/men/12.jpg'
      },
      {
        name: 'Sophia Lee',
        email: 'sophia@brandcorp.com',
        company: 'Brand Corp',
        role: 'Brand Manager',
        phone: '+1 (555) 100-0013',
        image_url: 'https://randomuser.me/api/portraits/women/13.jpg'
      }
    ]
  },
  {
    id: 'dt-meet-7',
    title: 'Quarterly Business Review - Q4 2025',
    date: '2026-01-10',
    time: '10:00',
    duration: 120,
    meeting_link: '',
    location: 'Executive Boardroom',
    meeting_type: 'in-person',
    category: 'Internal',
    agenda: '1. Q4 financial performance\n2. Client acquisition and retention\n3. Team growth and hiring\n4. 2026 strategic priorities\n5. Investment in new capabilities',
    notes: 'Strong Q4 results. Approved budget for 2 new hires and studio equipment upgrade.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'David Park',
        email: 'david@designagency.com',
        company: 'Design Agency',
        role: 'Creative Director',
        phone: '+1 (555) 100-0014',
        image_url: 'https://randomuser.me/api/portraits/men/14.jpg'
      },
      {
        name: 'Amanda Foster',
        email: 'amanda@designagency.com',
        company: 'Design Agency',
        role: 'Managing Director',
        phone: '+1 (555) 100-0015',
        image_url: 'https://randomuser.me/api/portraits/women/15.jpg'
      }
    ]
  },
  {
    id: 'dt-meet-8',
    title: 'Packaging Design Review - Product Launch',
    date: '2026-01-13',
    time: '14:30',
    duration: 75,
    meeting_link: 'https://teams.microsoft.com/l/meetup-join/19%3ameeting_packaging',
    location: '',
    meeting_type: 'virtual',
    category: 'Client',
    agenda: '1. Packaging concept presentations\n2. Material and printing considerations\n3. Sustainability requirements\n4. Cost analysis\n5. Production timeline',
    notes: 'Client prefers eco-friendly materials. Need to source sustainable suppliers.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Michael Brown',
        email: 'michael@consumergoods.com',
        company: 'Consumer Goods Inc',
        role: 'Product Manager',
        phone: '+1 (555) 100-0016',
        image_url: 'https://randomuser.me/api/portraits/men/16.jpg'
      },
      {
        name: 'Nina Patel',
        email: 'nina@designagency.com',
        company: 'Design Agency',
        role: 'Package Designer',
        phone: '+1 (555) 100-0017',
        image_url: 'https://randomuser.me/api/portraits/women/17.jpg'
      }
    ]
  },
  {
    id: 'dt-meet-9',
    title: 'Typography Workshop - Team Training',
    date: '2026-01-14',
    time: '10:00',
    duration: 180,
    meeting_link: '',
    location: 'Design Studio',
    meeting_type: 'in-person',
    category: 'Team',
    agenda: '1. Typography fundamentals\n2. Font pairing techniques\n3. Hierarchy and readability\n4. Web typography best practices\n5. Hands-on exercises',
    notes: 'Highly valuable training. Team requested follow-up on variable fonts.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Robert Harrison',
        email: 'robert@typemaster.com',
        company: 'Type Master Studio',
        role: 'Typography Expert',
        phone: '+1 (555) 100-0018',
        image_url: 'https://randomuser.me/api/portraits/men/18.jpg'
      },
      {
        name: 'Design Team',
        email: 'team@designagency.com',
        company: 'Design Agency',
        role: 'Creative Team',
        phone: '',
        image_url: ''
      }
    ]
  },
  {
    id: 'dt-meet-10',
    title: 'New Business Pitch - Tech Conference',
    date: '2026-01-15',
    time: '11:00',
    duration: 60,
    meeting_link: 'https://zoom.us/j/designteam004',
    location: '',
    meeting_type: 'virtual',
    category: 'Client',
    agenda: '1. Conference branding opportunity\n2. Portfolio showcase\n3. Capabilities presentation\n4. Pricing and timeline discussion\n5. Next steps',
    notes: 'Strong interest from conference organizers. Expecting proposal by end of week.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Jessica Moore',
        email: 'jessica@techconference.com',
        company: 'Tech Conference 2026',
        role: 'Event Director',
        phone: '+1 (555) 100-0019',
        image_url: 'https://randomuser.me/api/portraits/women/19.jpg'
      },
      {
        name: 'David Park',
        email: 'david@designagency.com',
        company: 'Design Agency',
        role: 'Creative Director',
        phone: '+1 (555) 100-0020',
        image_url: 'https://randomuser.me/api/portraits/men/20.jpg'
      },
      {
        name: 'Amanda Foster',
        email: 'amanda@designagency.com',
        company: 'Design Agency',
        role: 'Managing Director',
        phone: '+1 (555) 100-0021',
        image_url: 'https://randomuser.me/api/portraits/women/21.jpg'
      }
    ]
  }
];

// Documents and Folders Mockup - For Documents page
export const documentsFoldersMockData = {
  folders: [
    // Cresa Folders
    {
      id: 'folder-1',
      name: 'Client Contracts',
      color: '#3b82f6',
      category: 'cresa',
      order: 0
    },
    {
      id: 'folder-2',
      name: 'Property Listings',
      color: '#10b981',
      category: 'cresa',
      order: 1
    },
    {
      id: 'folder-3',
      name: 'Market Reports',
      color: '#f59e0b',
      category: 'cresa',
      order: 2
    },
    // CounterFind Folders
    {
      id: 'folder-4',
      name: 'Product Documentation',
      color: '#8b5cf6',
      category: 'counterfind',
      order: 0
    },
    {
      id: 'folder-5',
      name: 'User Guides',
      color: '#ec4899',
      category: 'counterfind',
      order: 1
    },
    // Personal Folders
    {
      id: 'folder-6',
      name: 'Financial Documents',
      color: '#06b6d4',
      category: 'personal',
      order: 0
    },
    {
      id: 'folder-7',
      name: 'Legal Documents',
      color: '#ef4444',
      category: 'personal',
      order: 1
    },
    // Speaking Folders
    {
      id: 'folder-8',
      name: 'Keynote Presentations',
      color: '#f97316',
      category: 'speaking',
      order: 0
    },
    // Investments Folders
    {
      id: 'folder-9',
      name: 'Portfolio Reports',
      color: '#14b8a6',
      category: 'investments',
      order: 0
    }
  ],
  documents: [
    // Cresa Documents
    {
      id: 'doc-1',
      name: 'Nike Commercial Lease Agreement',
      type: 'PDF',
      category: 'cresa',
      size: '2.4 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-1',
      upload_date: '2025-12-10',
      description: 'Commercial lease agreement for Nike retail space'
    },
    {
      id: 'doc-2',
      name: 'JBL Partnership Agreement',
      type: 'PDF',
      category: 'cresa',
      size: '1.8 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-1',
      upload_date: '2025-12-15',
      description: 'Partnership agreement with JBL'
    },
    {
      id: 'doc-3',
      name: 'Downtown Office Listing',
      type: 'PDF',
      category: 'cresa',
      size: '3.2 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-2',
      upload_date: '2025-12-18',
      description: 'Premium office space in downtown district'
    },
    {
      id: 'doc-4',
      name: 'Warehouse Complex - Industrial Park',
      type: 'PDF',
      category: 'cresa',
      size: '2.9 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-2',
      upload_date: '2025-12-20',
      description: 'Industrial warehouse property listing'
    },
    {
      id: 'doc-5',
      name: 'Q4 2025 Market Analysis',
      type: 'PDF',
      category: 'cresa',
      size: '4.1 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-3',
      upload_date: '2025-12-22',
      description: 'Comprehensive market analysis for Q4 2025'
    },
    {
      id: 'doc-6',
      name: 'Commercial Real Estate Trends 2026',
      type: 'PDF',
      category: 'cresa',
      size: '3.8 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-3',
      upload_date: '2025-12-28',
      description: 'Market trends forecast for 2026'
    },
    
    // CounterFind Documents
    {
      id: 'doc-7',
      name: 'API Documentation v2.0',
      type: 'PDF',
      category: 'counterfind',
      size: '1.5 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-4',
      upload_date: '2025-12-05',
      description: 'Complete API documentation for developers'
    },
    {
      id: 'doc-8',
      name: 'System Architecture Overview',
      type: 'PDF',
      category: 'counterfind',
      size: '2.7 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-4',
      upload_date: '2025-12-08',
      description: 'Technical architecture documentation'
    },
    {
      id: 'doc-9',
      name: 'User Manual - Getting Started',
      type: 'PDF',
      category: 'counterfind',
      size: '1.2 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-5',
      upload_date: '2025-12-12',
      description: 'Beginner guide for new users'
    },
    {
      id: 'doc-10',
      name: 'Advanced Features Guide',
      type: 'PDF',
      category: 'counterfind',
      size: '2.1 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-5',
      upload_date: '2025-12-14',
      description: 'Advanced user guide and tips'
    },
    
    // Personal Documents
    {
      id: 'doc-11',
      name: '2025 Tax Returns',
      type: 'PDF',
      category: 'personal',
      size: '890 KB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-6',
      upload_date: '2025-12-01',
      description: 'Annual tax return documents'
    },
    {
      id: 'doc-12',
      name: 'Investment Portfolio Statement',
      type: 'PDF',
      category: 'personal',
      size: '1.4 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-6',
      upload_date: '2025-12-15',
      description: 'Q4 investment portfolio summary'
    },
    {
      id: 'doc-13',
      name: 'Property Title Deed',
      type: 'PDF',
      category: 'personal',
      size: '1.1 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-7',
      upload_date: '2025-11-20',
      description: 'Real estate property title documentation'
    },
    {
      id: 'doc-14',
      name: 'Insurance Policy Documents',
      type: 'PDF',
      category: 'personal',
      size: '750 KB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-7',
      upload_date: '2025-12-03',
      description: 'Home and auto insurance policies'
    },
    
    // Speaking Documents
    {
      id: 'doc-15',
      name: 'Tech Summit 2026 - AI Trends',
      type: 'PPTX',
      category: 'speaking',
      size: '5.3 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-8',
      upload_date: '2025-12-10',
      description: 'Keynote presentation on AI trends'
    },
    {
      id: 'doc-16',
      name: 'Leadership Conference Slides',
      type: 'PPTX',
      category: 'speaking',
      size: '4.8 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-8',
      upload_date: '2025-12-18',
      description: 'Leadership best practices presentation'
    },
    {
      id: 'doc-17',
      name: 'Speaker Bio and Headshots',
      type: 'ZIP',
      category: 'speaking',
      size: '12.5 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: null,
      upload_date: '2025-11-15',
      description: 'Professional bio and photography'
    },
    
    // Investments Documents
    {
      id: 'doc-18',
      name: 'Q4 2025 Portfolio Performance',
      type: 'PDF',
      category: 'investments',
      size: '2.2 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-9',
      upload_date: '2025-12-20',
      description: 'Quarterly investment performance report'
    },
    {
      id: 'doc-19',
      name: 'Venture Capital Opportunities 2026',
      type: 'PDF',
      category: 'investments',
      size: '3.1 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: 'folder-9',
      upload_date: '2025-12-22',
      description: 'VC investment opportunities analysis'
    },
    {
      id: 'doc-20',
      name: 'Startup Pitch Deck - TechCo',
      type: 'PDF',
      category: 'investments',
      size: '8.7 MB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: null,
      upload_date: '2025-12-28',
      description: 'Investment pitch deck review'
    },
    
    // Other Documents (Unfiled)
    {
      id: 'doc-21',
      name: 'Conference Registration Confirmation',
      type: 'PDF',
      category: 'other',
      size: '245 KB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: null,
      upload_date: '2025-12-05',
      description: 'Event registration details'
    },
    {
      id: 'doc-22',
      name: 'Hotel Booking Itinerary',
      type: 'PDF',
      category: 'other',
      size: '186 KB',
      url: 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
      folder_id: null,
      upload_date: '2025-12-12',
      description: 'Travel accommodation details'
    }
  ]
};

// Passwords Mockup - For Passwords page
export const passwordsMockData = [
  // Banking
  {
    id: 'pwd-1',
    service_name: 'Chase Bank',
    url: 'https://www.chase.com',
    username: 'darren.woodson@email.com',
    password: 'Chase2025$ecure',
    category: 'Banking',
    tags: ['banking', 'primary'],
    icon_url: 'https://www.google.com/s2/favicons?domain=chase.com&sz=64',
    notes: 'Main checking account',
    created_at: '2025-11-01',
    updated_at: '2025-12-15'
  },
  {
    id: 'pwd-2',
    service_name: 'Wells Fargo',
    url: 'https://www.wellsfargo.com',
    username: 'dwoodson',
    password: 'WellsF@rgo123',
    category: 'Banking',
    tags: ['banking', 'savings'],
    icon_url: 'https://www.google.com/s2/favicons?domain=wellsfargo.com&sz=64',
    notes: 'Savings account',
    created_at: '2025-10-20',
    updated_at: '2025-12-10'
  },
  {
    id: 'pwd-3',
    service_name: 'American Express',
    url: 'https://www.americanexpress.com',
    username: 'darrenwoodson@email.com',
    password: 'AmEx#2025Strong',
    category: 'Banking',
    tags: ['credit-card', 'rewards'],
    icon_url: 'https://www.google.com/s2/favicons?domain=americanexpress.com&sz=64',
    notes: 'Business rewards card',
    created_at: '2025-09-15',
    updated_at: '2025-12-20'
  },

  // Business
  {
    id: 'pwd-4',
    service_name: 'Salesforce',
    url: 'https://login.salesforce.com',
    username: 'darren@cresa.com',
    password: 'SalesF0rce!CRM',
    category: 'Business',
    tags: ['crm', 'work', 'cresa'],
    icon_url: 'https://www.google.com/s2/favicons?domain=salesforce.com&sz=64',
    notes: 'CRM access for Cresa',
    created_at: '2025-08-01',
    updated_at: '2025-12-18'
  },
  {
    id: 'pwd-5',
    service_name: 'Slack - Cresa Workspace',
    url: 'https://cresa.slack.com',
    username: 'darren.woodson@cresa.com',
    password: 'Sl@ck2025Work',
    category: 'Business',
    tags: ['communication', 'work', 'cresa'],
    icon_url: 'https://www.google.com/s2/favicons?domain=slack.com&sz=64',
    notes: 'Team communication platform',
    created_at: '2025-07-10',
    updated_at: '2025-12-05'
  },
  {
    id: 'pwd-6',
    service_name: 'Google Workspace',
    url: 'https://workspace.google.com',
    username: 'darren@cresa.com',
    password: 'G00gle#Workspace',
    category: 'Business',
    tags: ['email', 'productivity', 'work'],
    icon_url: 'https://www.google.com/s2/favicons?domain=google.com&sz=64',
    notes: 'Company email and docs',
    created_at: '2025-06-15',
    updated_at: '2025-12-22'
  },

  // Social
  {
    id: 'pwd-7',
    service_name: 'LinkedIn',
    url: 'https://www.linkedin.com',
    username: 'darren.woodson',
    password: 'Link3dIn!Pro',
    category: 'Social',
    tags: ['social', 'professional', 'networking'],
    icon_url: 'https://www.google.com/s2/favicons?domain=linkedin.com&sz=64',
    notes: 'Professional networking',
    created_at: '2025-05-20',
    updated_at: '2025-12-12'
  },
  {
    id: 'pwd-8',
    service_name: 'Twitter / X',
    url: 'https://twitter.com',
    username: '@darrenwoodson',
    password: 'Tw1tter$ecure',
    category: 'Social',
    tags: ['social', 'news'],
    icon_url: 'https://www.google.com/s2/favicons?domain=x.com&sz=64',
    notes: 'Personal Twitter account',
    created_at: '2025-04-10',
    updated_at: '2025-11-30'
  },
  {
    id: 'pwd-9',
    service_name: 'Instagram',
    url: 'https://www.instagram.com',
    username: 'darren.woodson',
    password: 'Inst@gram2025',
    category: 'Social',
    tags: ['social', 'photos'],
    icon_url: 'https://www.google.com/s2/favicons?domain=instagram.com&sz=64',
    notes: 'Personal photos and stories',
    created_at: '2025-03-25',
    updated_at: '2025-12-08'
  },

  // Streaming
  {
    id: 'pwd-10',
    service_name: 'Netflix',
    url: 'https://www.netflix.com',
    username: 'dwoodson@email.com',
    password: 'N3tflix!Stream',
    category: 'Streaming',
    tags: ['entertainment', 'streaming', 'family'],
    icon_url: 'https://www.google.com/s2/favicons?domain=netflix.com&sz=64',
    notes: 'Family premium plan',
    created_at: '2025-02-14',
    updated_at: '2025-12-01'
  },
  {
    id: 'pwd-11',
    service_name: 'Spotify',
    url: 'https://www.spotify.com',
    username: 'darren.woodson',
    password: 'Sp0tify#Music',
    category: 'Streaming',
    tags: ['music', 'streaming'],
    icon_url: 'https://www.google.com/s2/favicons?domain=spotify.com&sz=64',
    notes: 'Premium subscription',
    created_at: '2025-01-20',
    updated_at: '2025-11-28'
  },
  {
    id: 'pwd-12',
    service_name: 'Disney+',
    url: 'https://www.disneyplus.com',
    username: 'darren.woodson@email.com',
    password: 'D1sney+Fam',
    category: 'Streaming',
    tags: ['entertainment', 'streaming', 'family', 'kids'],
    icon_url: 'https://www.google.com/s2/favicons?domain=disneyplus.com&sz=64',
    notes: 'Family account with kids profiles',
    created_at: '2025-01-10',
    updated_at: '2025-12-15'
  },

  // Dev
  {
    id: 'pwd-13',
    service_name: 'GitHub',
    url: 'https://github.com',
    username: 'dwoodson-dev',
    password: 'G1tHub!Dev2025',
    category: 'Dev',
    tags: ['development', 'code', 'repositories'],
    icon_url: 'https://www.google.com/s2/favicons?domain=github.com&sz=64',
    notes: 'Main development account',
    created_at: '2024-12-05',
    updated_at: '2025-12-20'
  },
  {
    id: 'pwd-14',
    service_name: 'AWS Console',
    url: 'https://console.aws.amazon.com',
    username: 'darren.woodson',
    password: 'AWS#Cl0ud2025',
    category: 'Dev',
    tags: ['cloud', 'aws', 'infrastructure'],
    icon_url: 'https://www.google.com/s2/favicons?domain=aws.amazon.com&sz=64',
    notes: 'Cloud infrastructure management',
    created_at: '2024-11-15',
    updated_at: '2025-12-18'
  },
  {
    id: 'pwd-15',
    service_name: 'Docker Hub',
    url: 'https://hub.docker.com',
    username: 'darren_woodson',
    password: 'D0cker!Hub',
    category: 'Dev',
    tags: ['containers', 'docker', 'development'],
    icon_url: 'https://www.google.com/s2/favicons?domain=docker.com&sz=64',
    notes: 'Container registry',
    created_at: '2024-10-20',
    updated_at: '2025-11-25'
  },

  // Personal
  {
    id: 'pwd-16',
    service_name: 'iCloud',
    url: 'https://www.icloud.com',
    username: 'darren.woodson@icloud.com',
    password: 'iCl0ud$ecure',
    category: 'Personal',
    tags: ['apple', 'cloud', 'personal'],
    icon_url: 'https://www.google.com/s2/favicons?domain=icloud.com&sz=64',
    notes: 'Personal iCloud account',
    created_at: '2024-09-01',
    updated_at: '2025-12-10'
  },
  {
    id: 'pwd-17',
    service_name: 'Gmail Personal',
    url: 'https://mail.google.com',
    username: 'darren.woodson@gmail.com',
    password: 'Gm@il2025Pers',
    category: 'Personal',
    tags: ['email', 'personal'],
    icon_url: 'https://www.google.com/s2/favicons?domain=gmail.com&sz=64',
    notes: 'Personal email account',
    created_at: '2024-08-15',
    updated_at: '2025-12-05'
  },
  {
    id: 'pwd-18',
    service_name: 'Dropbox',
    url: 'https://www.dropbox.com',
    username: 'dwoodson@email.com',
    password: 'Dr0pb0x!Files',
    category: 'Personal',
    tags: ['storage', 'files', 'cloud'],
    icon_url: 'https://www.google.com/s2/favicons?domain=dropbox.com&sz=64',
    notes: 'Personal file storage',
    created_at: '2024-07-10',
    updated_at: '2025-11-20'
  },

  // Shopping
  {
    id: 'pwd-19',
    service_name: 'Amazon',
    url: 'https://www.amazon.com',
    username: 'darren.woodson@email.com',
    password: 'Am@z0n!Shop',
    category: 'Shopping',
    tags: ['shopping', 'retail', 'prime'],
    icon_url: 'https://www.google.com/s2/favicons?domain=amazon.com&sz=64',
    notes: 'Prime member account',
    created_at: '2024-06-01',
    updated_at: '2025-12-22'
  },
  {
    id: 'pwd-20',
    service_name: 'Target',
    url: 'https://www.target.com',
    username: 'dwoodson',
    password: 'T@rget2025',
    category: 'Shopping',
    tags: ['shopping', 'retail', 'redcard'],
    icon_url: 'https://www.google.com/s2/favicons?domain=target.com&sz=64',
    notes: 'RedCard holder',
    created_at: '2024-05-15',
    updated_at: '2025-11-18'
  },

  // Entertainment
  {
    id: 'pwd-21',
    service_name: 'Ticketmaster',
    url: 'https://www.ticketmaster.com',
    username: 'darren.woodson@email.com',
    password: 'T1cketM@ster',
    category: 'Entertainment',
    tags: ['events', 'concerts', 'tickets'],
    icon_url: 'https://www.google.com/s2/favicons?domain=ticketmaster.com&sz=64',
    notes: 'Concert and event tickets',
    created_at: '2024-04-20',
    updated_at: '2025-12-01'
  },
  {
    id: 'pwd-22',
    service_name: 'PlayStation Network',
    url: 'https://www.playstation.com',
    username: 'DarrenW_Gaming',
    password: 'PS5!G@ming',
    category: 'Entertainment',
    tags: ['gaming', 'playstation', 'entertainment'],
    icon_url: 'https://www.google.com/s2/favicons?domain=playstation.com&sz=64',
    notes: 'PS5 gaming account',
    created_at: '2024-03-10',
    updated_at: '2025-11-15'
  },
  {
    id: 'pwd-23',
    service_name: 'Audible',
    url: 'https://www.audible.com',
    username: 'dwoodson@email.com',
    password: 'Aud1ble!Books',
    category: 'Entertainment',
    tags: ['audiobooks', 'reading', 'entertainment'],
    icon_url: 'https://www.google.com/s2/favicons?domain=audible.com&sz=64',
    notes: 'Monthly audiobook subscription',
    created_at: '2024-02-14',
    updated_at: '2025-12-08'
  }
];

// Media/Photos Mockup - For Media page
export const mediaMockData = {
  photos: [
    // Family Photos (30 items)
    { id: 'media-1', uuid: 'family-001', filename: 'Family_Beach_Vacation_2025.jpg', thumbnail_url: 'https://picsum.photos/seed/2001/400/300', full_url: 'https://picsum.photos/seed/2001/1920/1080', asset_type: 'photo', file_size: 3245678, created_date: '2025-07-15T14:30:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-2', uuid: 'family-002', filename: 'Kids_Birthday_Party.jpg', thumbnail_url: 'https://picsum.photos/seed/2002/400/300', full_url: 'https://picsum.photos/seed/2002/1920/1080', asset_type: 'photo', file_size: 2891234, created_date: '2025-08-22T16:45:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-3', uuid: 'family-003', filename: 'Christmas_Morning_2024.jpg', thumbnail_url: 'https://picsum.photos/seed/2003/400/300', full_url: 'https://picsum.photos/seed/2003/1920/1080', asset_type: 'photo', file_size: 4123456, created_date: '2024-12-25T09:15:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-4', uuid: 'family-004', filename: 'Thanksgiving_Dinner.jpg', thumbnail_url: 'https://picsum.photos/seed/2004/400/300', full_url: 'https://picsum.photos/seed/2004/1920/1080', asset_type: 'photo', file_size: 3567890, created_date: '2024-11-28T18:00:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-5', uuid: 'family-005', filename: 'Family_Picnic_Park.jpg', thumbnail_url: 'https://picsum.photos/seed/2005/400/300', full_url: 'https://picsum.photos/seed/2005/1920/1080', asset_type: 'photo', file_size: 2987654, created_date: '2025-06-10T12:30:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-101', uuid: 'family-006', filename: 'Kids_Playing_Playground.jpg', thumbnail_url: 'https://picsum.photos/seed/2006/400/300', full_url: 'https://picsum.photos/seed/2006/1920/1080', asset_type: 'photo', file_size: 3123456, created_date: '2025-05-18T15:20:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-102', uuid: 'family-007', filename: 'Family_BBQ_Backyard.jpg', thumbnail_url: 'https://picsum.photos/seed/2007/400/300', full_url: 'https://picsum.photos/seed/2007/1920/1080', asset_type: 'photo', file_size: 2789012, created_date: '2025-07-04T17:00:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-103', uuid: 'family-008', filename: 'Baby_First_Steps.jpg', thumbnail_url: 'https://picsum.photos/seed/2008/400/300', full_url: 'https://picsum.photos/seed/2008/1920/1080', asset_type: 'photo', file_size: 2456789, created_date: '2025-04-22T11:30:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-104', uuid: 'family-009', filename: 'Wedding_Anniversary.jpg', thumbnail_url: 'https://picsum.photos/seed/2009/400/300', full_url: 'https://picsum.photos/seed/2009/1920/1080', asset_type: 'photo', file_size: 3678901, created_date: '2025-09-12T19:00:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-105', uuid: 'family-010', filename: 'Grandparents_Visit.jpg', thumbnail_url: 'https://picsum.photos/seed/2010/400/300', full_url: 'https://picsum.photos/seed/2010/1920/1080', asset_type: 'photo', file_size: 2890123, created_date: '2025-03-20T14:15:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-106', uuid: 'family-011', filename: 'School_First_Day.jpg', thumbnail_url: 'https://picsum.photos/seed/2011/400/300', full_url: 'https://picsum.photos/seed/2011/1920/1080', asset_type: 'photo', file_size: 3234567, created_date: '2025-09-01T08:00:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-107', uuid: 'family-012', filename: 'Halloween_Costumes.jpg', thumbnail_url: 'https://picsum.photos/seed/2012/400/300', full_url: 'https://picsum.photos/seed/2012/1920/1080', asset_type: 'photo', file_size: 2567890, created_date: '2024-10-31T18:30:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-108', uuid: 'family-013', filename: 'Easter_Egg_Hunt.jpg', thumbnail_url: 'https://picsum.photos/seed/2013/400/300', full_url: 'https://picsum.photos/seed/2013/1920/1080', asset_type: 'photo', file_size: 2789012, created_date: '2025-03-31T10:45:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-109', uuid: 'family-014', filename: 'Family_Movie_Night.jpg', thumbnail_url: 'https://picsum.photos/seed/2014/400/300', full_url: 'https://picsum.photos/seed/2014/1920/1080', asset_type: 'photo', file_size: 3123456, created_date: '2025-11-08T20:00:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-110', uuid: 'family-015', filename: 'Kids_Swimming_Pool.jpg', thumbnail_url: 'https://picsum.photos/seed/2015/400/300', full_url: 'https://picsum.photos/seed/2015/1920/1080', asset_type: 'photo', file_size: 2890123, created_date: '2025-08-05T15:30:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-111', uuid: 'family-016', filename: 'Family_Camping_Trip.jpg', thumbnail_url: 'https://picsum.photos/seed/2016/400/300', full_url: 'https://picsum.photos/seed/2016/1920/1080', asset_type: 'photo', file_size: 3567890, created_date: '2025-07-20T19:00:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-112', uuid: 'family-017', filename: 'Siblings_Playing.jpg', thumbnail_url: 'https://picsum.photos/seed/2017/400/300', full_url: 'https://picsum.photos/seed/2017/1920/1080', asset_type: 'photo', file_size: 2456789, created_date: '2025-06-15T16:20:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-113', uuid: 'family-018', filename: 'Family_Portrait_Studio.jpg', thumbnail_url: 'https://picsum.photos/seed/2018/400/300', full_url: 'https://picsum.photos/seed/2018/1920/1080', asset_type: 'photo', file_size: 3678901, created_date: '2025-02-14T13:00:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-114', uuid: 'family-019', filename: 'Kids_Art_Projects.jpg', thumbnail_url: 'https://picsum.photos/seed/2019/400/300', full_url: 'https://picsum.photos/seed/2019/1920/1080', asset_type: 'photo', file_size: 2234567, created_date: '2025-05-10T14:45:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-115', uuid: 'family-020', filename: 'Family_Game_Night.jpg', thumbnail_url: 'https://picsum.photos/seed/2020/400/300', full_url: 'https://picsum.photos/seed/2020/1920/1080', asset_type: 'photo', file_size: 2987654, created_date: '2025-10-18T19:30:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-116', uuid: 'family-021', filename: 'Mothers_Day_Brunch.jpg', thumbnail_url: 'https://picsum.photos/seed/2021/400/300', full_url: 'https://picsum.photos/seed/2021/1920/1080', asset_type: 'photo', file_size: 3123456, created_date: '2025-05-11T11:00:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-117', uuid: 'family-022', filename: 'Fathers_Day_Golf.jpg', thumbnail_url: 'https://picsum.photos/seed/2022/400/300', full_url: 'https://picsum.photos/seed/2022/1920/1080', asset_type: 'photo', file_size: 2789012, created_date: '2025-06-15T14:00:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-118', uuid: 'family-023', filename: 'Kids_Bedtime_Stories.jpg', thumbnail_url: 'https://picsum.photos/seed/2023/400/300', full_url: 'https://picsum.photos/seed/2023/1920/1080', asset_type: 'photo', file_size: 2456789, created_date: '2025-09-20T20:15:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-119', uuid: 'family-024', filename: 'Family_Bike_Ride.jpg', thumbnail_url: 'https://picsum.photos/seed/2024/400/300', full_url: 'https://picsum.photos/seed/2024/1920/1080', asset_type: 'photo', file_size: 3234567, created_date: '2025-04-25T16:00:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-120', uuid: 'family-025', filename: 'Snow_Day_Fun.jpg', thumbnail_url: 'https://picsum.photos/seed/2025/400/300', full_url: 'https://picsum.photos/seed/2025/1920/1080', asset_type: 'photo', file_size: 2890123, created_date: '2025-01-15T10:30:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-121', uuid: 'family-026', filename: 'Summer_Vacation_Road_Trip.jpg', thumbnail_url: 'https://picsum.photos/seed/2026/400/300', full_url: 'https://picsum.photos/seed/2026/1920/1080', asset_type: 'photo', file_size: 3567890, created_date: '2025-08-10T12:00:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-122', uuid: 'family-027', filename: 'Kids_Science_Fair.jpg', thumbnail_url: 'https://picsum.photos/seed/2027/400/300', full_url: 'https://picsum.photos/seed/2027/1920/1080', asset_type: 'photo', file_size: 2678901, created_date: '2025-03-15T15:30:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-123', uuid: 'family-028', filename: 'Family_Cooking_Together.jpg', thumbnail_url: 'https://picsum.photos/seed/2028/400/300', full_url: 'https://picsum.photos/seed/2028/1920/1080', asset_type: 'photo', file_size: 2987654, created_date: '2025-11-15T18:00:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-124', uuid: 'family-029', filename: 'Kids_Sports_Day.jpg', thumbnail_url: 'https://picsum.photos/seed/2029/400/300', full_url: 'https://picsum.photos/seed/2029/1920/1080', asset_type: 'photo', file_size: 3123456, created_date: '2025-05-20T14:00:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-125', uuid: 'family-030', filename: 'Family_Garden_Planting.jpg', thumbnail_url: 'https://picsum.photos/seed/2030/400/300', full_url: 'https://picsum.photos/seed/2030/1920/1080', asset_type: 'photo', file_size: 2789012, created_date: '2025-04-10T13:30:00', category: 'Family', source: 'mac_photos_bridge' },

    // Travel Photos (25 items)
    { id: 'media-6', uuid: 'travel-001', filename: 'Paris_Eiffel_Tower.jpg', thumbnail_url: 'https://picsum.photos/seed/2031/400/300', full_url: 'https://picsum.photos/seed/2031/1920/1080', asset_type: 'photo', file_size: 4567890, created_date: '2025-05-20T15:45:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-7', uuid: 'travel-002', filename: 'Tokyo_Cherry_Blossoms.jpg', thumbnail_url: 'https://picsum.photos/seed/2032/400/300', full_url: 'https://picsum.photos/seed/2032/1920/1080', asset_type: 'photo', file_size: 3789012, created_date: '2025-04-08T10:20:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-8', uuid: 'travel-003', filename: 'Grand_Canyon_Sunset.jpg', thumbnail_url: 'https://picsum.photos/seed/2033/400/300', full_url: 'https://picsum.photos/seed/2033/1920/1080', asset_type: 'photo', file_size: 5123456, created_date: '2025-09-15T18:30:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-9', uuid: 'travel-004', filename: 'Venice_Gondola_Ride.jpg', thumbnail_url: 'https://picsum.photos/seed/2034/400/300', full_url: 'https://picsum.photos/seed/2034/1920/1080', asset_type: 'photo', file_size: 3456789, created_date: '2025-06-25T14:15:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-10', uuid: 'travel-005', filename: 'Iceland_Northern_Lights.jpg', thumbnail_url: 'https://picsum.photos/seed/2035/400/300', full_url: 'https://picsum.photos/seed/2035/1920/1080', asset_type: 'photo', file_size: 4789123, created_date: '2025-03-12T22:45:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-126', uuid: 'travel-006', filename: 'London_Big_Ben.jpg', thumbnail_url: 'https://picsum.photos/seed/2036/400/300', full_url: 'https://picsum.photos/seed/2036/1920/1080', asset_type: 'photo', file_size: 4234567, created_date: '2025-07-10T16:00:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-127', uuid: 'travel-007', filename: 'New_York_Times_Square.jpg', thumbnail_url: 'https://picsum.photos/seed/2037/400/300', full_url: 'https://picsum.photos/seed/2037/1920/1080', asset_type: 'photo', file_size: 3890123, created_date: '2025-10-05T19:30:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-128', uuid: 'travel-008', filename: 'Santorini_Sunset.jpg', thumbnail_url: 'https://picsum.photos/seed/2038/400/300', full_url: 'https://picsum.photos/seed/2038/1920/1080', asset_type: 'photo', file_size: 4567890, created_date: '2025-08-15T20:00:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-129', uuid: 'travel-009', filename: 'Dubai_Burj_Khalifa.jpg', thumbnail_url: 'https://picsum.photos/seed/2039/400/300', full_url: 'https://picsum.photos/seed/2039/1920/1080', asset_type: 'photo', file_size: 3678901, created_date: '2025-02-20T14:30:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-130', uuid: 'travel-010', filename: 'Sydney_Opera_House.jpg', thumbnail_url: 'https://picsum.photos/seed/2040/400/300', full_url: 'https://picsum.photos/seed/2040/1920/1080', asset_type: 'photo', file_size: 4123456, created_date: '2025-11-12T11:00:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-131', uuid: 'travel-011', filename: 'Rome_Colosseum.jpg', thumbnail_url: 'https://picsum.photos/seed/2041/400/300', full_url: 'https://picsum.photos/seed/2041/1920/1080', asset_type: 'photo', file_size: 3987654, created_date: '2025-06-05T15:20:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-132', uuid: 'travel-012', filename: 'Barcelona_Sagrada_Familia.jpg', thumbnail_url: 'https://picsum.photos/seed/2042/400/300', full_url: 'https://picsum.photos/seed/2042/1920/1080', asset_type: 'photo', file_size: 4456789, created_date: '2025-07-18T16:45:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-133', uuid: 'travel-013', filename: 'Bali_Rice_Terraces.jpg', thumbnail_url: 'https://picsum.photos/seed/2043/400/300', full_url: 'https://picsum.photos/seed/2043/1920/1080', asset_type: 'photo', file_size: 3678901, created_date: '2025-09-22T10:30:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-134', uuid: 'travel-014', filename: 'Machu_Picchu_Peru.jpg', thumbnail_url: 'https://picsum.photos/seed/2044/400/300', full_url: 'https://picsum.photos/seed/2044/1920/1080', asset_type: 'photo', file_size: 4789012, created_date: '2025-04-15T12:00:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-135', uuid: 'travel-015', filename: 'Egyptian_Pyramids.jpg', thumbnail_url: 'https://picsum.photos/seed/2045/400/300', full_url: 'https://picsum.photos/seed/2045/1920/1080', asset_type: 'photo', file_size: 4234567, created_date: '2025-03-08T14:45:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-136', uuid: 'travel-016', filename: 'Thailand_Floating_Market.jpg', thumbnail_url: 'https://picsum.photos/seed/2046/400/300', full_url: 'https://picsum.photos/seed/2046/1920/1080', asset_type: 'photo', file_size: 3567890, created_date: '2025-10-25T09:30:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-137', uuid: 'travel-017', filename: 'Swiss_Alps_Mountains.jpg', thumbnail_url: 'https://picsum.photos/seed/2047/400/300', full_url: 'https://picsum.photos/seed/2047/1920/1080', asset_type: 'photo', file_size: 4890123, created_date: '2025-12-10T11:00:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-138', uuid: 'travel-018', filename: 'Morocco_Marrakech_Market.jpg', thumbnail_url: 'https://picsum.photos/seed/2048/400/300', full_url: 'https://picsum.photos/seed/2048/1920/1080', asset_type: 'photo', file_size: 3456789, created_date: '2025-05-28T15:20:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-139', uuid: 'travel-019', filename: 'China_Great_Wall.jpg', thumbnail_url: 'https://picsum.photos/seed/2049/400/300', full_url: 'https://picsum.photos/seed/2049/1920/1080', asset_type: 'photo', file_size: 4678901, created_date: '2025-04-20T13:45:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-140', uuid: 'travel-020', filename: 'Amsterdam_Canals.jpg', thumbnail_url: 'https://picsum.photos/seed/2050/400/300', full_url: 'https://picsum.photos/seed/2050/1920/1080', asset_type: 'photo', file_size: 3789012, created_date: '2025-08-08T17:00:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-141', uuid: 'travel-021', filename: 'Norway_Fjords.jpg', thumbnail_url: 'https://picsum.photos/seed/2051/400/300', full_url: 'https://picsum.photos/seed/2051/1920/1080', asset_type: 'photo', file_size: 4567890, created_date: '2025-07-22T10:15:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-142', uuid: 'travel-022', filename: 'Singapore_Marina_Bay.jpg', thumbnail_url: 'https://picsum.photos/seed/2052/400/300', full_url: 'https://picsum.photos/seed/2052/1920/1080', asset_type: 'photo', file_size: 3987654, created_date: '2025-11-05T19:30:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-143', uuid: 'travel-023', filename: 'Brazil_Rio_Christ.jpg', thumbnail_url: 'https://picsum.photos/seed/2053/400/300', full_url: 'https://picsum.photos/seed/2053/1920/1080', asset_type: 'photo', file_size: 4123456, created_date: '2025-02-28T16:00:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-144', uuid: 'travel-024', filename: 'New_Zealand_Milford_Sound.jpg', thumbnail_url: 'https://picsum.photos/seed/2054/400/300', full_url: 'https://picsum.photos/seed/2054/1920/1080', asset_type: 'photo', file_size: 4789012, created_date: '2025-12-05T12:30:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-145', uuid: 'travel-025', filename: 'Ireland_Cliffs_Moher.jpg', thumbnail_url: 'https://picsum.photos/seed/2055/400/300', full_url: 'https://picsum.photos/seed/2055/1920/1080', asset_type: 'photo', file_size: 4456789, created_date: '2025-06-18T14:00:00', category: 'Travel', source: 'mac_photos_bridge' },

    // Food Photos (20 items)
    { id: 'media-11', uuid: 'food-001', filename: 'Gourmet_Steak_Dinner.jpg', thumbnail_url: 'https://picsum.photos/seed/2056/400/300', full_url: 'https://picsum.photos/seed/2056/1920/1080', asset_type: 'photo', file_size: 2567890, created_date: '2025-10-05T19:30:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-12', uuid: 'food-002', filename: 'Homemade_Pizza.jpg', thumbnail_url: 'https://picsum.photos/seed/2057/400/300', full_url: 'https://picsum.photos/seed/2057/1920/1080', asset_type: 'photo', file_size: 2234567, created_date: '2025-11-02T18:00:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-13', uuid: 'food-003', filename: 'Sushi_Platter.jpg', thumbnail_url: 'https://picsum.photos/seed/2058/400/300', full_url: 'https://picsum.photos/seed/2058/1920/1080', asset_type: 'photo', file_size: 2890123, created_date: '2025-08-18T20:15:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-14', uuid: 'food-004', filename: 'Birthday_Cake.jpg', thumbnail_url: 'https://picsum.photos/seed/2059/400/300', full_url: 'https://picsum.photos/seed/2059/1920/1080', asset_type: 'photo', file_size: 1987654, created_date: '2025-08-22T17:00:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-146', uuid: 'food-005', filename: 'Italian_Pasta_Carbonara.jpg', thumbnail_url: 'https://picsum.photos/seed/2060/400/300', full_url: 'https://picsum.photos/seed/2060/1920/1080', asset_type: 'photo', file_size: 2456789, created_date: '2025-09-10T19:15:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-147', uuid: 'food-006', filename: 'Breakfast_Pancakes.jpg', thumbnail_url: 'https://picsum.photos/seed/2061/400/300', full_url: 'https://picsum.photos/seed/2061/1920/1080', asset_type: 'photo', file_size: 2123456, created_date: '2025-07-08T09:00:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-148', uuid: 'food-007', filename: 'Burgers_and_Fries.jpg', thumbnail_url: 'https://picsum.photos/seed/2062/400/300', full_url: 'https://picsum.photos/seed/2062/1920/1080', asset_type: 'photo', file_size: 2678901, created_date: '2025-06-20T18:30:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-149', uuid: 'food-008', filename: 'Tacos_Mexican_Food.jpg', thumbnail_url: 'https://picsum.photos/seed/2063/400/300', full_url: 'https://picsum.photos/seed/2063/1920/1080', asset_type: 'photo', file_size: 2345678, created_date: '2025-10-12T19:45:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-150', uuid: 'food-009', filename: 'Fresh_Salad_Bowl.jpg', thumbnail_url: 'https://picsum.photos/seed/2064/400/300', full_url: 'https://picsum.photos/seed/2064/1920/1080', asset_type: 'photo', file_size: 2012345, created_date: '2025-05-15T12:30:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-151', uuid: 'food-010', filename: 'Ramen_Noodles.jpg', thumbnail_url: 'https://picsum.photos/seed/2065/400/300', full_url: 'https://picsum.photos/seed/2065/1920/1080', asset_type: 'photo', file_size: 2234567, created_date: '2025-04-18T20:00:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-152', uuid: 'food-011', filename: 'Chocolate_Dessert.jpg', thumbnail_url: 'https://picsum.photos/seed/2066/400/300', full_url: 'https://picsum.photos/seed/2066/1920/1080', asset_type: 'photo', file_size: 1987654, created_date: '2025-11-18T21:15:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-153', uuid: 'food-012', filename: 'Seafood_Platter.jpg', thumbnail_url: 'https://picsum.photos/seed/2067/400/300', full_url: 'https://picsum.photos/seed/2067/1920/1080', asset_type: 'photo', file_size: 2567890, created_date: '2025-09-25T19:00:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-154', uuid: 'food-013', filename: 'Fresh_Fruit_Smoothie.jpg', thumbnail_url: 'https://picsum.photos/seed/2068/400/300', full_url: 'https://picsum.photos/seed/2068/1920/1080', asset_type: 'photo', file_size: 1876543, created_date: '2025-07-12T10:00:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-155', uuid: 'food-014', filename: 'BBQ_Ribs.jpg', thumbnail_url: 'https://picsum.photos/seed/2069/400/300', full_url: 'https://picsum.photos/seed/2069/1920/1080', asset_type: 'photo', file_size: 2456789, created_date: '2025-08-28T18:45:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-156', uuid: 'food-015', filename: 'Artisan_Bread.jpg', thumbnail_url: 'https://picsum.photos/seed/2070/400/300', full_url: 'https://picsum.photos/seed/2070/1920/1080', asset_type: 'photo', file_size: 2123456, created_date: '2025-10-08T08:30:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-157', uuid: 'food-016', filename: 'Thai_Curry.jpg', thumbnail_url: 'https://picsum.photos/seed/2071/400/300', full_url: 'https://picsum.photos/seed/2071/1920/1080', asset_type: 'photo', file_size: 2345678, created_date: '2025-06-05T19:30:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-158', uuid: 'food-017', filename: 'French_Croissants.jpg', thumbnail_url: 'https://picsum.photos/seed/2072/400/300', full_url: 'https://picsum.photos/seed/2072/1920/1080', asset_type: 'photo', file_size: 2012345, created_date: '2025-05-22T09:15:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-159', uuid: 'food-018', filename: 'Greek_Salad.jpg', thumbnail_url: 'https://picsum.photos/seed/2073/400/300', full_url: 'https://picsum.photos/seed/2073/1920/1080', asset_type: 'photo', file_size: 1987654, created_date: '2025-08-15T13:00:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-160', uuid: 'food-019', filename: 'Ice_Cream_Sundae.jpg', thumbnail_url: 'https://picsum.photos/seed/2074/400/300', full_url: 'https://picsum.photos/seed/2074/1920/1080', asset_type: 'photo', file_size: 1876543, created_date: '2025-07-28T16:30:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-161', uuid: 'food-020', filename: 'Gourmet_Coffee.jpg', thumbnail_url: 'https://picsum.photos/seed/2075/400/300', full_url: 'https://picsum.photos/seed/2075/1920/1080', asset_type: 'photo', file_size: 1765432, created_date: '2025-09-08T08:00:00', category: 'Food', source: 'mac_photos_bridge' },

    // Work/Business Photos (15 items)
    { id: 'media-15', uuid: 'work-001', filename: 'Conference_Presentation.jpg', thumbnail_url: 'https://picsum.photos/seed/2076/400/300', full_url: 'https://picsum.photos/seed/2076/1920/1080', asset_type: 'photo', file_size: 3123456, created_date: '2025-09-10T14:30:00', category: 'Work', source: 'mac_photos_bridge' },
    { id: 'media-16', uuid: 'work-002', filename: 'Team_Meeting_Whiteboard.jpg', thumbnail_url: 'https://picsum.photos/seed/2077/400/300', full_url: 'https://picsum.photos/seed/2077/1920/1080', asset_type: 'photo', file_size: 2456789, created_date: '2025-10-15T11:00:00', category: 'Work', source: 'mac_photos_bridge' },
    { id: 'media-17', uuid: 'work-003', filename: 'Office_New_Space.jpg', thumbnail_url: 'https://picsum.photos/seed/2078/400/300', full_url: 'https://picsum.photos/seed/2078/1920/1080', asset_type: 'photo', file_size: 3789012, created_date: '2025-07-01T09:00:00', category: 'Work', source: 'mac_photos_bridge' },
    { id: 'media-162', uuid: 'work-004', filename: 'Business_Handshake.jpg', thumbnail_url: 'https://picsum.photos/seed/2079/400/300', full_url: 'https://picsum.photos/seed/2079/1920/1080', asset_type: 'photo', file_size: 2789012, created_date: '2025-08-12T15:30:00', category: 'Work', source: 'mac_photos_bridge' },
    { id: 'media-163', uuid: 'work-005', filename: 'Laptop_Working.jpg', thumbnail_url: 'https://picsum.photos/seed/2080/400/300', full_url: 'https://picsum.photos/seed/2080/1920/1080', asset_type: 'photo', file_size: 2345678, created_date: '2025-11-05T10:15:00', category: 'Work', source: 'mac_photos_bridge' },
    { id: 'media-164', uuid: 'work-006', filename: 'Office_Desk_Setup.jpg', thumbnail_url: 'https://picsum.photos/seed/2081/400/300', full_url: 'https://picsum.photos/seed/2081/1920/1080', asset_type: 'photo', file_size: 2567890, created_date: '2025-06-18T13:00:00', category: 'Work', source: 'mac_photos_bridge' },
    { id: 'media-165', uuid: 'work-007', filename: 'Video_Conference_Call.jpg', thumbnail_url: 'https://picsum.photos/seed/2082/400/300', full_url: 'https://picsum.photos/seed/2082/1920/1080', asset_type: 'photo', file_size: 2234567, created_date: '2025-10-22T16:00:00', category: 'Work', source: 'mac_photos_bridge' },
    { id: 'media-166', uuid: 'work-008', filename: 'Business_Documents.jpg', thumbnail_url: 'https://picsum.photos/seed/2083/400/300', full_url: 'https://picsum.photos/seed/2083/1920/1080', asset_type: 'photo', file_size: 2456789, created_date: '2025-09-05T14:45:00', category: 'Work', source: 'mac_photos_bridge' },
    { id: 'media-167', uuid: 'work-009', filename: 'Corporate_Event.jpg', thumbnail_url: 'https://picsum.photos/seed/2084/400/300', full_url: 'https://picsum.photos/seed/2084/1920/1080', asset_type: 'photo', file_size: 3123456, created_date: '2025-11-20T18:00:00', category: 'Work', source: 'mac_photos_bridge' },
    { id: 'media-168', uuid: 'work-010', filename: 'Networking_Event.jpg', thumbnail_url: 'https://picsum.photos/seed/2085/400/300', full_url: 'https://picsum.photos/seed/2085/1920/1080', asset_type: 'photo', file_size: 2789012, created_date: '2025-08-28T19:30:00', category: 'Work', source: 'mac_photos_bridge' },
    { id: 'media-169', uuid: 'work-011', filename: 'Product_Launch.jpg', thumbnail_url: 'https://picsum.photos/seed/2086/400/300', full_url: 'https://picsum.photos/seed/2086/1920/1080', asset_type: 'photo', file_size: 3345678, created_date: '2025-07-15T17:00:00', category: 'Work', source: 'mac_photos_bridge' },
    { id: 'media-170', uuid: 'work-012', filename: 'Team_Brainstorming.jpg', thumbnail_url: 'https://picsum.photos/seed/2087/400/300', full_url: 'https://picsum.photos/seed/2087/1920/1080', asset_type: 'photo', file_size: 2678901, created_date: '2025-10-08T15:15:00', category: 'Work', source: 'mac_photos_bridge' },
    { id: 'media-171', uuid: 'work-013', filename: 'Client_Meeting.jpg', thumbnail_url: 'https://picsum.photos/seed/2088/400/300', full_url: 'https://picsum.photos/seed/2088/1920/1080', asset_type: 'photo', file_size: 2890123, created_date: '2025-09-18T11:30:00', category: 'Work', source: 'mac_photos_bridge' },
    { id: 'media-172', uuid: 'work-014', filename: 'Office_Lobby.jpg', thumbnail_url: 'https://picsum.photos/seed/2089/400/300', full_url: 'https://picsum.photos/seed/2089/1920/1080', asset_type: 'photo', file_size: 3123456, created_date: '2025-06-25T09:00:00', category: 'Work', source: 'mac_photos_bridge' },
    { id: 'media-173', uuid: 'work-015', filename: 'Business_Cards_Exchange.jpg', thumbnail_url: 'https://picsum.photos/seed/2090/400/300', full_url: 'https://picsum.photos/seed/2090/1920/1080', asset_type: 'photo', file_size: 2456789, created_date: '2025-11-12T16:45:00', category: 'Work', source: 'mac_photos_bridge' },

    // Nature/Landscape Photos (20 items)
    { id: 'media-18', uuid: 'nature-001', filename: 'Mountain_Sunrise.jpg', thumbnail_url: 'https://picsum.photos/seed/2091/400/300', full_url: 'https://picsum.photos/seed/2091/1920/1080', asset_type: 'photo', file_size: 4567890, created_date: '2025-10-20T06:30:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-19', uuid: 'nature-002', filename: 'Forest_Trail_Autumn.jpg', thumbnail_url: 'https://picsum.photos/seed/2092/400/300', full_url: 'https://picsum.photos/seed/2092/1920/1080', asset_type: 'photo', file_size: 3890123, created_date: '2025-10-25T15:45:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-20', uuid: 'nature-003', filename: 'Beach_Sunset_Ocean.jpg', thumbnail_url: 'https://picsum.photos/seed/2093/400/300', full_url: 'https://picsum.photos/seed/2093/1920/1080', asset_type: 'photo', file_size: 4123456, created_date: '2025-07-15T19:30:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-21', uuid: 'nature-004', filename: 'Waterfall_Rainforest.jpg', thumbnail_url: 'https://picsum.photos/seed/2094/400/300', full_url: 'https://picsum.photos/seed/2094/1920/1080', asset_type: 'photo', file_size: 4789012, created_date: '2025-06-12T13:20:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-174', uuid: 'nature-005', filename: 'Desert_Sand_Dunes.jpg', thumbnail_url: 'https://picsum.photos/seed/2095/400/300', full_url: 'https://picsum.photos/seed/2095/1920/1080', asset_type: 'photo', file_size: 3987654, created_date: '2025-09-08T17:00:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-175', uuid: 'nature-006', filename: 'Lake_Reflection.jpg', thumbnail_url: 'https://picsum.photos/seed/2096/400/300', full_url: 'https://picsum.photos/seed/2096/1920/1080', asset_type: 'photo', file_size: 4234567, created_date: '2025-08-20T07:30:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-176', uuid: 'nature-007', filename: 'Rocky_Mountains.jpg', thumbnail_url: 'https://picsum.photos/seed/2097/400/300', full_url: 'https://picsum.photos/seed/2097/1920/1080', asset_type: 'photo', file_size: 4567890, created_date: '2025-07-28T11:15:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-177', uuid: 'nature-008', filename: 'Flower_Meadow.jpg', thumbnail_url: 'https://picsum.photos/seed/2098/400/300', full_url: 'https://picsum.photos/seed/2098/1920/1080', asset_type: 'photo', file_size: 3456789, created_date: '2025-05-18T14:00:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-178', uuid: 'nature-009', filename: 'Aurora_Borealis.jpg', thumbnail_url: 'https://picsum.photos/seed/2099/400/300', full_url: 'https://picsum.photos/seed/2099/1920/1080', asset_type: 'photo', file_size: 4789012, created_date: '2025-02-12T22:00:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-179', uuid: 'nature-010', filename: 'Canyon_Valley.jpg', thumbnail_url: 'https://picsum.photos/seed/2100/400/300', full_url: 'https://picsum.photos/seed/2100/1920/1080', asset_type: 'photo', file_size: 4123456, created_date: '2025-09-22T16:30:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-180', uuid: 'nature-011', filename: 'Tropical_Beach.jpg', thumbnail_url: 'https://picsum.photos/seed/2101/400/300', full_url: 'https://picsum.photos/seed/2101/1920/1080', asset_type: 'photo', file_size: 3890123, created_date: '2025-06-28T13:45:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-181', uuid: 'nature-012', filename: 'Winter_Snowscape.jpg', thumbnail_url: 'https://picsum.photos/seed/2102/400/300', full_url: 'https://picsum.photos/seed/2102/1920/1080', asset_type: 'photo', file_size: 4456789, created_date: '2025-01-20T09:00:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-182', uuid: 'nature-013', filename: 'Jungle_Canopy.jpg', thumbnail_url: 'https://picsum.photos/seed/2103/400/300', full_url: 'https://picsum.photos/seed/2103/1920/1080', asset_type: 'photo', file_size: 3678901, created_date: '2025-09-05T11:30:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-183', uuid: 'nature-014', filename: 'River_Stream.jpg', thumbnail_url: 'https://picsum.photos/seed/2104/400/300', full_url: 'https://picsum.photos/seed/2104/1920/1080', asset_type: 'photo', file_size: 3987654, created_date: '2025-07-08T15:00:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-184', uuid: 'nature-015', filename: 'Volcanic_Landscape.jpg', thumbnail_url: 'https://picsum.photos/seed/2105/400/300', full_url: 'https://picsum.photos/seed/2105/1920/1080', asset_type: 'photo', file_size: 4234567, created_date: '2025-03-18T12:00:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-185', uuid: 'nature-016', filename: 'Coastal_Cliffs.jpg', thumbnail_url: 'https://picsum.photos/seed/2106/400/300', full_url: 'https://picsum.photos/seed/2106/1920/1080', asset_type: 'photo', file_size: 4567890, created_date: '2025-08-12T17:30:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-186', uuid: 'nature-017', filename: 'Starry_Night_Sky.jpg', thumbnail_url: 'https://picsum.photos/seed/2107/400/300', full_url: 'https://picsum.photos/seed/2107/1920/1080', asset_type: 'photo', file_size: 3789012, created_date: '2025-11-08T21:00:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-187', uuid: 'nature-018', filename: 'Bamboo_Forest.jpg', thumbnail_url: 'https://picsum.photos/seed/2108/400/300', full_url: 'https://picsum.photos/seed/2108/1920/1080', asset_type: 'photo', file_size: 3456789, created_date: '2025-04-22T10:30:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-188', uuid: 'nature-019', filename: 'Sunrise_Valley.jpg', thumbnail_url: 'https://picsum.photos/seed/2109/400/300', full_url: 'https://picsum.photos/seed/2109/1920/1080', asset_type: 'photo', file_size: 4123456, created_date: '2025-10-15T06:00:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-189', uuid: 'nature-020', filename: 'Cherry_Blossom_Trees.jpg', thumbnail_url: 'https://picsum.photos/seed/2110/400/300', full_url: 'https://picsum.photos/seed/2110/1920/1080', asset_type: 'photo', file_size: 3890123, created_date: '2025-04-05T14:15:00', category: 'Nature', source: 'mac_photos_bridge' },

    // Pets Photos (10 items)
    { id: 'media-22', uuid: 'pets-001', filename: 'Dog_Golden_Retriever.jpg', thumbnail_url: 'https://picsum.photos/seed/2111/400/300', full_url: 'https://picsum.photos/seed/2111/1920/1080', asset_type: 'photo', file_size: 2567890, created_date: '2025-11-10T16:00:00', category: 'Pets', source: 'mac_photos_bridge' },
    { id: 'media-23', uuid: 'pets-002', filename: 'Cat_Playing_Toys.jpg', thumbnail_url: 'https://picsum.photos/seed/2112/400/300', full_url: 'https://picsum.photos/seed/2112/1920/1080', asset_type: 'photo', file_size: 1890123, created_date: '2025-11-15T14:30:00', category: 'Pets', source: 'mac_photos_bridge' },
    { id: 'media-190', uuid: 'pets-003', filename: 'Puppy_Sleeping.jpg', thumbnail_url: 'https://picsum.photos/seed/2113/400/300', full_url: 'https://picsum.photos/seed/2113/1920/1080', asset_type: 'photo', file_size: 2123456, created_date: '2025-10-05T13:00:00', category: 'Pets', source: 'mac_photos_bridge' },
    { id: 'media-191', uuid: 'pets-004', filename: 'Kitten_Curious.jpg', thumbnail_url: 'https://picsum.photos/seed/2114/400/300', full_url: 'https://picsum.photos/seed/2114/1920/1080', asset_type: 'photo', file_size: 1987654, created_date: '2025-09-18T15:45:00', category: 'Pets', source: 'mac_photos_bridge' },
    { id: 'media-192', uuid: 'pets-005', filename: 'Dog_Park_Playing.jpg', thumbnail_url: 'https://picsum.photos/seed/2115/400/300', full_url: 'https://picsum.photos/seed/2115/1920/1080', asset_type: 'photo', file_size: 2456789, created_date: '2025-08-22T17:00:00', category: 'Pets', source: 'mac_photos_bridge' },
    { id: 'media-193', uuid: 'pets-006', filename: 'Cat_Window_Sunbathing.jpg', thumbnail_url: 'https://picsum.photos/seed/2116/400/300', full_url: 'https://picsum.photos/seed/2116/1920/1080', asset_type: 'photo', file_size: 2234567, created_date: '2025-07-15T11:30:00', category: 'Pets', source: 'mac_photos_bridge' },
    { id: 'media-194', uuid: 'pets-007', filename: 'Dog_Beach_Running.jpg', thumbnail_url: 'https://picsum.photos/seed/2117/400/300', full_url: 'https://picsum.photos/seed/2117/1920/1080', asset_type: 'photo', file_size: 2678901, created_date: '2025-06-28T16:15:00', category: 'Pets', source: 'mac_photos_bridge' },
    { id: 'media-195', uuid: 'pets-008', filename: 'Cat_Playing_String.jpg', thumbnail_url: 'https://picsum.photos/seed/2118/400/300', full_url: 'https://picsum.photos/seed/2118/1920/1080', asset_type: 'photo', file_size: 1876543, created_date: '2025-05-10T14:00:00', category: 'Pets', source: 'mac_photos_bridge' },
    { id: 'media-196', uuid: 'pets-009', filename: 'Dog_Agility_Training.jpg', thumbnail_url: 'https://picsum.photos/seed/2119/400/300', full_url: 'https://picsum.photos/seed/2119/1920/1080', asset_type: 'photo', file_size: 2345678, created_date: '2025-09-05T10:30:00', category: 'Pets', source: 'mac_photos_bridge' },
    { id: 'media-197', uuid: 'pets-010', filename: 'Rabbit_Pet_Eating.jpg', thumbnail_url: 'https://picsum.photos/seed/2120/400/300', full_url: 'https://picsum.photos/seed/2120/1920/1080', asset_type: 'photo', file_size: 2012345, created_date: '2025-10-18T13:15:00', category: 'Pets', source: 'mac_photos_bridge' },

    // Screenshots (10 items)
    { id: 'media-24', uuid: 'screenshot-001', filename: 'Screenshot_Dashboard_Analytics.png', thumbnail_url: 'https://picsum.photos/seed/2121/400/300', full_url: 'https://picsum.photos/seed/2121/1920/1080', asset_type: 'photo', file_size: 987654, created_date: '2025-12-01T10:15:00', category: 'Screenshots', source: 'mac_photos_bridge' },
    { id: 'media-25', uuid: 'screenshot-002', filename: 'Screenshot_Project_Plan.png', thumbnail_url: 'https://picsum.photos/seed/2122/400/300', full_url: 'https://picsum.photos/seed/2122/1920/1080', asset_type: 'photo', file_size: 1234567, created_date: '2025-11-28T15:45:00', category: 'Screenshots', source: 'mac_photos_bridge' },
    { id: 'media-198', uuid: 'screenshot-003', filename: 'Screenshot_Code_Editor.png', thumbnail_url: 'https://picsum.photos/seed/2123/400/300', full_url: 'https://picsum.photos/seed/2123/1920/1080', asset_type: 'photo', file_size: 876543, created_date: '2025-11-22T09:30:00', category: 'Screenshots', source: 'mac_photos_bridge' },
    { id: 'media-199', uuid: 'screenshot-004', filename: 'Screenshot_Financial_Report.png', thumbnail_url: 'https://picsum.photos/seed/2124/400/300', full_url: 'https://picsum.photos/seed/2124/1920/1080', asset_type: 'photo', file_size: 1123456, created_date: '2025-10-30T14:00:00', category: 'Screenshots', source: 'mac_photos_bridge' },
    { id: 'media-200', uuid: 'screenshot-005', filename: 'Screenshot_Design_Mockup.png', thumbnail_url: 'https://picsum.photos/seed/2125/400/300', full_url: 'https://picsum.photos/seed/2125/1920/1080', asset_type: 'photo', file_size: 998765, created_date: '2025-09-15T11:15:00', category: 'Screenshots', source: 'mac_photos_bridge' },
    { id: 'media-201', uuid: 'screenshot-006', filename: 'Screenshot_Email_Client.png', thumbnail_url: 'https://picsum.photos/seed/2126/400/300', full_url: 'https://picsum.photos/seed/2126/1920/1080', asset_type: 'photo', file_size: 876543, created_date: '2025-11-18T16:00:00', category: 'Screenshots', source: 'mac_photos_bridge' },
    { id: 'media-202', uuid: 'screenshot-007', filename: 'Screenshot_Video_Call.png', thumbnail_url: 'https://picsum.photos/seed/2127/400/300', full_url: 'https://picsum.photos/seed/2127/1920/1080', asset_type: 'photo', file_size: 1234567, created_date: '2025-10-12T15:30:00', category: 'Screenshots', source: 'mac_photos_bridge' },
    { id: 'media-203', uuid: 'screenshot-008', filename: 'Screenshot_Calendar_App.png', thumbnail_url: 'https://picsum.photos/seed/2128/400/300', full_url: 'https://picsum.photos/seed/2128/1920/1080', asset_type: 'photo', file_size: 765432, created_date: '2025-09-28T10:45:00', category: 'Screenshots', source: 'mac_photos_bridge' },
    { id: 'media-204', uuid: 'screenshot-009', filename: 'Screenshot_Spreadsheet.png', thumbnail_url: 'https://picsum.photos/seed/2129/400/300', full_url: 'https://picsum.photos/seed/2129/1920/1080', asset_type: 'photo', file_size: 898765, created_date: '2025-11-05T13:20:00', category: 'Screenshots', source: 'mac_photos_bridge' },
    { id: 'media-205', uuid: 'screenshot-010', filename: 'Screenshot_Social_Media.png', thumbnail_url: 'https://picsum.photos/seed/2130/400/300', full_url: 'https://picsum.photos/seed/2130/1920/1080', asset_type: 'photo', file_size: 1098765, created_date: '2025-10-25T17:00:00', category: 'Screenshots', source: 'mac_photos_bridge' },

    // Videos (15 items)
    { id: 'media-26', uuid: 'video-001', filename: 'Kids_Soccer_Game.mov', thumbnail_url: 'https://picsum.photos/seed/2131/400/300', full_url: 'https://picsum.photos/seed/2131/1920/1080', asset_type: 'video', file_size: 45678901, created_date: '2025-09-05T16:30:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-27', uuid: 'video-002', filename: 'Beach_Vacation_Waves.mov', thumbnail_url: 'https://picsum.photos/seed/2132/400/300', full_url: 'https://picsum.photos/seed/2132/1920/1080', asset_type: 'video', file_size: 38901234, created_date: '2025-07-15T15:00:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-28', uuid: 'video-003', filename: 'Product_Demo_Presentation.mov', thumbnail_url: 'https://picsum.photos/seed/2133/400/300', full_url: 'https://picsum.photos/seed/2133/1920/1080', asset_type: 'video', file_size: 52345678, created_date: '2025-09-10T14:45:00', category: 'Work', source: 'mac_photos_bridge' },
    { id: 'media-206', uuid: 'video-004', filename: 'Birthday_Party_Highlights.mov', thumbnail_url: 'https://picsum.photos/seed/2134/400/300', full_url: 'https://picsum.photos/seed/2134/1920/1080', asset_type: 'video', file_size: 42345678, created_date: '2025-08-22T17:30:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-207', uuid: 'video-005', filename: 'Mountain_Hiking_Trail.mov', thumbnail_url: 'https://picsum.photos/seed/2135/400/300', full_url: 'https://picsum.photos/seed/2135/1920/1080', asset_type: 'video', file_size: 48901234, created_date: '2025-10-20T12:00:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-208', uuid: 'video-006', filename: 'Dog_Playing_Fetch.mov', thumbnail_url: 'https://picsum.photos/seed/2136/400/300', full_url: 'https://picsum.photos/seed/2136/1920/1080', asset_type: 'video', file_size: 35678901, created_date: '2025-11-10T16:45:00', category: 'Pets', source: 'mac_photos_bridge' },
    { id: 'media-209', uuid: 'video-007', filename: 'Paris_City_Tour.mov', thumbnail_url: 'https://picsum.photos/seed/2137/400/300', full_url: 'https://picsum.photos/seed/2137/1920/1080', asset_type: 'video', file_size: 56789012, created_date: '2025-05-20T18:00:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-210', uuid: 'video-008', filename: 'Cooking_Tutorial.mov', thumbnail_url: 'https://picsum.photos/seed/2138/400/300', full_url: 'https://picsum.photos/seed/2138/1920/1080', asset_type: 'video', file_size: 39876543, created_date: '2025-11-15T19:30:00', category: 'Food', source: 'mac_photos_bridge' },
    { id: 'media-211', uuid: 'video-009', filename: 'Conference_Keynote.mov', thumbnail_url: 'https://picsum.photos/seed/2139/400/300', full_url: 'https://picsum.photos/seed/2139/1920/1080', asset_type: 'video', file_size: 62345678, created_date: '2025-09-10T15:00:00', category: 'Work', source: 'mac_photos_bridge' },
    { id: 'media-212', uuid: 'video-010', filename: 'Waterfall_Nature_Sound.mov', thumbnail_url: 'https://picsum.photos/seed/2140/400/300', full_url: 'https://picsum.photos/seed/2140/1920/1080', asset_type: 'video', file_size: 44567890, created_date: '2025-06-12T14:30:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-213', uuid: 'video-011', filename: 'Kids_School_Play.mov', thumbnail_url: 'https://picsum.photos/seed/2141/400/300', full_url: 'https://picsum.photos/seed/2141/1920/1080', asset_type: 'video', file_size: 53456789, created_date: '2025-05-10T19:00:00', category: 'Family', source: 'mac_photos_bridge' },
    { id: 'media-214', uuid: 'video-012', filename: 'Tokyo_Timelapse.mov', thumbnail_url: 'https://picsum.photos/seed/2142/400/300', full_url: 'https://picsum.photos/seed/2142/1920/1080', asset_type: 'video', file_size: 58901234, created_date: '2025-04-08T20:30:00', category: 'Travel', source: 'mac_photos_bridge' },
    { id: 'media-215', uuid: 'video-013', filename: 'Cat_Funny_Moments.mov', thumbnail_url: 'https://picsum.photos/seed/2143/400/300', full_url: 'https://picsum.photos/seed/2143/1920/1080', asset_type: 'video', file_size: 32345678, created_date: '2025-11-15T15:30:00', category: 'Pets', source: 'mac_photos_bridge' },
    { id: 'media-216', uuid: 'video-014', filename: 'Sunset_Timelapse.mov', thumbnail_url: 'https://picsum.photos/seed/2144/400/300', full_url: 'https://picsum.photos/seed/2144/1920/1080', asset_type: 'video', file_size: 41234567, created_date: '2025-07-15T20:15:00', category: 'Nature', source: 'mac_photos_bridge' },
    { id: 'media-217', uuid: 'video-015', filename: 'Team_Building_Activity.mov', thumbnail_url: 'https://picsum.photos/seed/2145/400/300', full_url: 'https://picsum.photos/seed/2145/1920/1080', asset_type: 'video', file_size: 46789012, created_date: '2025-10-15T16:00:00', category: 'Work', source: 'mac_photos_bridge' }
  ],
  categories: ['All', 'Family', 'Travel', 'Food', 'Work', 'Nature', 'Pets', 'Screenshots'],
  categoryStats: {
    'Family': 33,
    'Food': 21,
    'Nature': 23,
    'Pets': 12,
    'Screenshots': 10,
    'Travel': 28,
    'Work': 18
  }
};

// Transcribe Conversations Mockup - For WhisperTranscribe page
export const transcribeConversationsMockData = [
  {
    id: 'conv-1',
    title: 'Q4 Strategy Planning Meeting',
    transcript: 'James: Good morning everyone, thank you for joining. Today we\'re here to discuss our Q4 strategy and key priorities. Let\'s start with the sales forecast. Sarah, can you give us an update?\n\nSarah: Yes, thank you. We\'re projecting a 15% increase in Q4 revenue compared to last year. Our focus will be on enterprise clients and expanding into the healthcare sector. We\'ve already got three major enterprise deals in the pipeline worth over $2 million combined.\n\nJames: That\'s great news. Mike, how are we positioned from a product perspective?\n\nMike: We have three major releases planned. The first one launches next week with AI-powered analytics. The team has been working around the clock to ensure we\'re ready. The second release in November will introduce advanced reporting capabilities, and the third in December focuses on mobile optimization.\n\nJames: Excellent work. Let\'s make sure marketing is aligned with these launches. Jennifer, can you brief us on the campaign strategy?\n\nJennifer: Absolutely. We\'re launching a multi-channel campaign focusing on thought leadership and case studies. We\'ve secured speaking slots at two major conferences - TechCrunch Disrupt and Healthcare Innovation Summit. We\'re also planning a webinar series featuring customer success stories.\n\nJames: That sounds comprehensive. What about our competitive positioning?\n\nSarah: We\'re seeing strong differentiation in the market. Our main competitors are struggling with integration issues, while our platform offers seamless connectivity. This is our biggest selling point right now.\n\nMike: I agree. The feedback from beta testers has been overwhelmingly positive. They especially love the AI analytics feature - it\'s saving them hours of manual work.\n\nJennifer: We\'re capturing all this feedback and turning it into marketing collateral. Our case study with HealthTech Inc. shows a 40% reduction in administrative time.\n\nJames: Perfect. Let\'s talk about resource allocation. Sarah, what does your team need to hit these targets?\n\nSarah: We need two additional sales engineers to support the enterprise deals. These are complex implementations that require technical expertise during the sales process.\n\nJames: Approved. Mike, any resource constraints on your end?\n\nMike: We\'re good for the next two releases, but for the December launch, I\'ll need to bring in a couple of contract developers to help with the mobile work.\n\nJames: Makes sense. Jennifer, marketing budget?\n\nJennifer: We\'re within budget for Q4. The conference sponsorships were our biggest expense, but we\'re getting great ROI. Our cost per lead is down 25% compared to Q3.\n\nJames: Excellent. Let\'s set up weekly check-ins to track progress. Sarah, you\'ll report on pipeline movement. Mike, release milestones. Jennifer, campaign performance metrics. Any questions?\n\nSarah: Just one - are we approved to attend the London conference in November? It would be great for our European expansion plans.\n\nJames: Yes, that\'s approved. Take two sales reps with you. Alright everyone, let\'s make Q4 our best quarter yet. Thanks for your time.',
    ai_summary: '**Meeting Overview:**\nQ4 strategy planning session with leadership team discussing revenue projections, product roadmap, and marketing initiatives.\n\n**Key Points:**\n• Sales forecast shows 15% revenue increase vs last year\n• Focus areas: Enterprise clients and healthcare sector expansion\n• Three major product releases planned for Q4\n• First release next week includes AI-powered analytics\n• Multi-channel marketing campaign launching with thought leadership focus\n• Secured speaking slots at two major conferences\n\n**Action Items:**\n• Sales team to prioritize enterprise and healthcare prospects\n• Product team finalizing AI analytics release for next week\n• Marketing team executing multi-channel campaign\n• Prepare materials for upcoming conference presentations\n\n**Participants:** Leadership team including Sarah (Sales), Mike (Product), Jennifer (Marketing)',
    category: 'Meetings',
    duration: 1847,
    created_at: '2025-12-15T10:30:00',
    audio_file_name: 'q4-strategy-meeting.mp3',
    processing: false,
    language: 'en',
    meeting_id: null
  },
  {
    id: 'conv-2',
    title: 'Client Onboarding Call - TechCorp',
    transcript: 'David: Hi Sarah, thanks for taking the time today. I\'m excited to get started with your platform.\n\nSarah: We\'re thrilled to have you onboard, David! Let me walk you through the setup process. First, we\'ll configure your account settings and integrate with your existing systems.\n\nDavid: That sounds perfect. We use Salesforce for CRM and Slack for internal communication.\n\nSarah: Great, we have native integrations for both. I\'ll show you how to set those up. Once connected, all your data will sync automatically. You\'ll also get real-time notifications in Slack whenever there\'s important activity.\n\nDavid: That\'s exactly what we need. How long does the initial setup typically take?\n\nSarah: Usually about 30 minutes. I\'ll guide you through each step. After that, your team can start using the platform immediately. We also offer training sessions for your staff.\n\nDavid: Perfect. What about data migration? We have about 5 years of historical data in our current system.\n\nSarah: We have a dedicated migration team that handles that. They\'ll work with you to map your existing data structure to our system. The process typically takes 3-5 business days depending on data volume. We\'ll do it in stages to minimize disruption.\n\nDavid: Excellent. And what kind of support do you offer after onboarding?\n\nSarah: You\'ll have a dedicated account manager - that would be me - and 24/7 technical support. We also have a comprehensive knowledge base and video tutorials. Plus, we do quarterly business reviews to ensure you\'re getting maximum value.\n\nDavid: That\'s reassuring. Can you show me the reporting features? That\'s something our current system really lacks.\n\nSarah: Absolutely. Let me share my screen. As you can see, we have pre-built dashboards for all major metrics, and you can create custom reports with our drag-and-drop builder. You can also schedule reports to be emailed automatically.\n\nDavid: Wow, this is impressive. Our CFO will love this. Can we export the data?\n\nSarah: Yes, you can export to CSV, Excel, or PDF. You also have full API access if you want to pull data into other systems.\n\nDavid: Perfect. I think we\'re ready to move forward. What are the next steps?\n\nSarah: I\'ll send you the onboarding checklist and contract after this call. Once signed, we\'ll schedule the kickoff meeting with our implementation team. They\'ll have you up and running within two weeks.\n\nDavid: Sounds great. Thanks for the thorough walkthrough, Sarah.\n\nSarah: My pleasure, David. Welcome to the family!',
    ai_summary: '**Call Summary:**\nSuccessful onboarding call with TechCorp new client covering platform setup and integrations.\n\n**Topics Covered:**\n• Account configuration and initial setup process\n• Integration with Salesforce CRM (native integration available)\n• Integration with Slack for notifications and communication\n• Automatic data synchronization across platforms\n• Real-time notification setup\n\n**Timeline:**\n• Initial setup: ~30 minutes with guided assistance\n• Platform ready for immediate use after setup\n• Training sessions to be scheduled for staff\n\n**Next Steps:**\n• Complete Salesforce and Slack integrations\n• Schedule team training sessions\n• Begin platform usage post-setup\n\n**Client:** TechCorp\n**Status:** Active onboarding in progress',
    category: 'Business',
    duration: 892,
    created_at: '2025-12-18T14:15:00',
    audio_file_name: 'techcorp-onboarding.mp3',
    processing: false,
    language: 'en',
    meeting_id: null
  },
  {
    id: 'conv-3',
    title: 'Product Demo - Healthcare Solutions',
    transcript: 'Lisa: Welcome to our healthcare platform demo. Today I\'ll show you how our solution streamlines patient management and improves clinical workflows.\n\nDr. Martinez: This is exactly what we\'re looking for. Our current system is outdated and inefficient.\n\nLisa: I understand. Let me start by showing you the patient dashboard. Here you can see real-time updates on all your patients, their vitals, medication schedules, and upcoming appointments.\n\nDr. Martinez: Wow, this is so much cleaner than what we have now. Can we customize the dashboard?\n\nLisa: Absolutely. Every element is fully customizable. You can add widgets, rearrange sections, and set up automated alerts based on specific conditions. For example, if a patient\'s blood pressure goes above a certain threshold, you can get an instant alert.\n\nDr. Martinez: And what about HIPAA compliance?\n\nLisa: Security and compliance are our top priorities. We\'re fully HIPAA compliant, with end-to-end encryption, audit logs, and role-based access controls. We undergo annual third-party audits to maintain certification.\n\nDr. Martinez: That\'s good to hear. What about integration with our existing EHR system?\n\nLisa: We have standard integrations with all major EHR systems - Epic, Cerner, Meditech. The integration is bi-directional, so data flows seamlessly between systems. Let me show you the medication management module.\n\nDr. Martinez: This is impressive. How does the prescription workflow work?\n\nLisa: You can e-prescribe directly from the platform. It checks for drug interactions, allergies, and insurance formularies in real-time. You can also see the patient\'s medication history and adherence patterns.\n\nDr. Martinez: What about the nursing staff? How do they use the system?\n\nLisa: Great question. Nurses have their own interface optimized for bedside care. They can document vitals, administer medications with barcode scanning, and update care plans. Everything syncs in real-time with the physician view.\n\nDr. Martinez: Can we handle telehealth visits through this platform?\n\nLisa: Yes, we have integrated video conferencing with full documentation capabilities. You can conduct the visit, take notes, update the treatment plan, and e-prescribe - all without leaving the platform.\n\nDr. Martinez: What about billing and coding?\n\nLisa: The system suggests appropriate billing codes based on the documentation. It integrates with your practice management system to streamline claims submission. This typically reduces claim rejections by 30-40%.\n\nDr. Martinez: How long does implementation typically take?\n\nLisa: For a practice your size, usually 4-6 weeks including training. We assign a dedicated implementation manager who works with your team throughout the process.\n\nDr. Martinez: This looks very promising. Can we schedule a trial?\n\nLisa: Absolutely. I\'ll set up a 30-day trial for your practice. I\'ll also send you case studies from similar clinics that have implemented our system.',
    ai_summary: '**Demo Summary:**\nComprehensive product demonstration of healthcare platform showcasing patient management and clinical workflow features.\n\n**Features Demonstrated:**\n• Real-time patient dashboard with comprehensive data visibility\n• Patient vitals monitoring and tracking\n• Medication schedule management\n• Appointment scheduling and reminders\n• Fully customizable dashboard with drag-and-drop widgets\n• Automated alert system based on configurable conditions\n\n**Compliance & Security:**\n• Full HIPAA compliance certification\n• End-to-end encryption for all data\n• Comprehensive audit logging\n• Role-based access control (RBAC) system\n\n**Client Feedback:**\n• Expressed strong interest - significant improvement over current system\n• Current solution described as outdated and inefficient\n• Impressed by clean interface and customization options\n\n**Industry:** Healthcare\n**Demo Duration:** 20 minutes',
    category: 'Business',
    duration: 1253,
    created_at: '2025-12-20T11:00:00',
    audio_file_name: 'healthcare-demo.mp3',
    processing: false,
    language: 'en',
    meeting_id: null
  },
  {
    id: 'conv-4',
    title: 'Team Standup - Engineering',
    transcript: 'Team Lead: Good morning team, let\'s do our daily standup. Alex, you want to start?\n\nAlex: Sure. Yesterday I finished the API integration for the payment gateway. Today I\'m working on the error handling and logging. No blockers.\n\nTeam Lead: Great. Samantha?\n\nSamantha: I completed the UI redesign for the dashboard. Working on the mobile responsive version today. I might need some help with the tablet breakpoints.\n\nTeam Lead: I can help with that after lunch. Kevin?\n\nKevin: I\'m finalizing the database migration scripts. Should be done by end of day. Testing revealed a few edge cases I\'m addressing. Specifically, we had some issues with null values in legacy data.\n\nTeam Lead: Sounds good. Make sure to document those edge cases. Rachel?\n\nRachel: I finished code review for the authentication module. Today I\'m deploying to staging and running security tests. No issues so far. The JWT implementation looks solid.\n\nTeam Lead: Excellent. Quick reminder - we have the sprint review tomorrow at 2 PM. Make sure your demos are ready. Alex, can you show the payment flow?\n\nAlex: Yes, I\'ll have it ready. Should I include the webhook testing?\n\nTeam Lead: Yes, that would be great. Samantha, you\'ll demo the new dashboard?\n\nSamantha: Absolutely. I\'ll show both desktop and mobile versions.\n\nTeam Lead: Perfect. Kevin, be ready to talk about the migration strategy.\n\nKevin: Will do. I\'ll prepare some metrics on the performance improvements.\n\nTeam Lead: Great. Rachel, anything you want to highlight in the review?\n\nRachel: I\'d like to present the security audit results. We passed all the OWASP checks.\n\nTeam Lead: Fantastic. That\'s something the stakeholders will love to hear. Alright, let\'s crush it today. Ping me if you need anything.',
    ai_summary: '**Daily Standup Summary:**\nEngineering team sync covering yesterday\'s accomplishments and today\'s priorities.\n\n**Team Updates:**\n\n**Alex (Backend Engineer):**\n• ✅ Completed: API integration for payment gateway\n• 🔄 In Progress: Error handling and logging implementation\n• ⚠️ Blockers: None\n\n**Samantha (Frontend Engineer):**\n• ✅ Completed: Dashboard UI redesign\n• 🔄 In Progress: Mobile responsive version\n• 🤝 Support Needed: Assistance with tablet breakpoints (after lunch)\n\n**Kevin (Database Engineer):**\n• 🔄 In Progress: Database migration scripts finalization\n• ⏰ ETA: End of day\n• 🐛 Issues: Addressing edge cases found during testing\n\n**Rachel (DevOps/Security):**\n• ✅ Completed: Code review of authentication module\n• 🔄 In Progress: Staging deployment and security testing\n• ✅ Status: No issues detected\n\n**Team Status:** All members on track, one cross-team collaboration identified',
    category: 'Meetings',
    duration: 428,
    created_at: '2025-12-22T09:00:00',
    audio_file_name: 'engineering-standup.mp3',
    processing: false,
    language: 'en',
    meeting_id: null
  },
  {
    id: 'conv-5',
    title: 'Interview - Senior Developer Position',
    transcript: 'Interviewer: Thanks for coming in today. Let\'s start by having you tell me about your background.\n\nCandidate: Thank you for the opportunity. I have 8 years of experience in full-stack development, primarily working with React, Node.js, and cloud infrastructure. My last role was at a fintech startup where I led a team of five engineers.\n\nInterviewer: That\'s impressive. Can you tell me about a challenging project you worked on?\n\nCandidate: Sure. We had to build a real-time fraud detection system that processed millions of transactions per day. The challenge was ensuring low latency while maintaining high accuracy. We used a combination of rule-based engines and machine learning models.\n\nInterviewer: How did you approach the architecture?\n\nCandidate: We designed a microservices architecture with event-driven processing. Used Kafka for streaming data, Redis for caching, and PostgreSQL for persistent storage. The system now processes transactions in under 100 milliseconds.\n\nInterviewer: Impressive. What was the biggest technical challenge you faced?\n\nCandidate: The biggest challenge was handling false positives. We had to fine-tune our ML models to reduce legitimate transactions being flagged. We implemented a feedback loop where analysts could mark false positives, and the system would learn from those corrections.\n\nInterviewer: How did you handle the team dynamics? You mentioned leading five engineers.\n\nCandidate: I believe in servant leadership. I made sure to remove blockers for my team, facilitated knowledge sharing through weekly tech talks, and instituted pair programming for complex features. We also did bi-weekly one-on-ones to discuss career growth and concerns.\n\nInterviewer: That\'s a great approach. What about code quality and testing?\n\nCandidate: We maintained 85% code coverage and used automated testing extensively. All PRs required two approvals and passed our CI/CD pipeline before merging. We also did quarterly code audits to identify technical debt.\n\nInterviewer: Tell me about a time when you had to make a difficult technical decision.\n\nCandidate: We had to choose between scaling vertically or horizontally for our database layer. The team was split. I organized a spike week where we tested both approaches with production-like data. The results clearly showed horizontal scaling was better for our use case, even though it was more complex to implement.\n\nInterviewer: How do you stay current with technology?\n\nCandidate: I dedicate Friday afternoons to learning. I follow tech blogs, contribute to open source, and attend local meetups. I also recently completed a course on Kubernetes and cloud-native architectures.\n\nInterviewer: Excellent. Do you have any questions for me?\n\nCandidate: Yes, what does the team structure look like, and what would my first 90 days focus on?\n\nInterviewer: Great question. You\'d be joining our platform team of eight engineers. The first 30 days would be onboarding and understanding our architecture. Days 30-60, you\'d start contributing to our next major release. Days 60-90, you\'d likely take ownership of a key service.\n\nCandidate: That sounds exciting. What\'s the tech stack?\n\nInterviewer: Primarily TypeScript, React, Node.js, with AWS infrastructure. We\'re also exploring some Go microservices.\n\nCandidate: Perfect, that aligns well with my experience.\n\nInterviewer: Wonderful. We\'ll be in touch within the next few days. Thanks for coming in.',
    ai_summary: '**Interview Summary:**\nTechnical interview for Senior Developer position with experienced full-stack engineer.\n\n**Candidate Profile:**\n• Experience: 8 years in full-stack development\n• Core Skills: React, Node.js, Cloud Infrastructure\n• Leadership: Led team of 5 engineers at fintech startup\n• Industry Background: Financial technology\n\n**Technical Deep Dive - Fraud Detection System:**\n\n**Challenge:**\n• Process millions of transactions daily\n• Maintain low latency (<100ms)\n• Ensure high accuracy in fraud detection\n\n**Solution Architecture:**\n• Microservices-based design\n• Event-driven processing model\n• Apache Kafka for data streaming\n• Redis for high-speed caching\n• PostgreSQL for persistent data storage\n• Hybrid approach: Rule-based engines + ML models\n\n**Results:**\n• Transaction processing: <100ms latency\n• Successfully scaled to handle millions of daily transactions\n• Maintained high accuracy fraud detection\n\n**Assessment:** Strong technical background with proven experience in complex, high-scale systems',
    category: 'Interviews',
    duration: 2156,
    created_at: '2025-12-10T15:30:00',
    audio_file_name: 'developer-interview.mp3',
    processing: false,
    language: 'en',
    meeting_id: null
  },
  {
    id: 'conv-6',
    title: 'Sales Call - Enterprise Prospect',
    transcript: 'Mark: Hi David, thanks for taking my call. I wanted to follow up on the proposal we sent last week.\n\nDavid: Yes, I\'ve reviewed it with my team. We\'re interested but have some questions about pricing and implementation.\n\nMark: Absolutely, I\'m happy to address those. What specific concerns do you have?\n\nDavid: The implementation timeline seems aggressive. We have a complex infrastructure and need to ensure minimal disruption.\n\nMark: I completely understand. We can extend the timeline and do a phased rollout. We\'ll start with a pilot program in one department, gather feedback, then expand.\n\nDavid: That sounds more manageable. What about ongoing support?\n\nMark: We provide 24/7 support with a dedicated account manager. You\'ll also have access to our technical team for any integration issues.\n\nDavid: And the pricing - can you break down the costs more clearly?\n\nMark: Sure. The base platform is $50,000 annually for up to 500 users. Additional users are $75 each. Implementation is a one-time fee of $25,000, but given the phased approach, we can split that payment across milestones.\n\nDavid: What about the premium features in your enterprise tier?\n\nMark: The enterprise tier adds advanced analytics, custom integrations, and priority support. That\'s an additional $20,000 annually. But I can offer you the first year at $15,000 if you commit before month-end.\n\nDavid: That\'s interesting. Can you send me case studies of similar enterprise deployments?\n\nMark: Absolutely. We recently completed a rollout for a Fortune 500 company in your industry. I\'ll send that over, along with their ROI analysis. They saw a 35% reduction in operational costs within the first year.\n\nDavid: Impressive. What\'s the typical ROI timeline?\n\nMark: Most clients break even within 8-12 months. The savings come from automation, reduced manual errors, and improved efficiency.\n\nDavid: Okay, send over those case studies and the revised proposal. I\'ll discuss with my CFO and get back to you next week.\n\nMark: Perfect. I\'ll also include some customer references you can speak with directly. Is there anything else you need from me?\n\nDavid: Not right now. Thanks for being flexible on the timeline.\n\nMark: Of course. We want to ensure this is a smooth transition for you. Talk next week!',
    ai_summary: '**Sales Call Summary:**\nFollow-up discussion with enterprise prospect David regarding proposal and implementation concerns.\n\n**Client Status:**\n• Proposal reviewed with internal team\n• General interest confirmed\n• Specific concerns about pricing and implementation raised\n\n**Key Concerns Addressed:**\n\n**1. Implementation Timeline:**\n• Client Concern: Aggressive timeline, complex infrastructure, disruption risk\n• Solution Offered: Extended timeline with phased rollout approach\n• Proposed Plan:\n  - Start with pilot program in single department\n  - Gather feedback and validate approach\n  - Expand gradually to other departments\n\n**2. Ongoing Support:**\n• 24/7 support availability\n• Dedicated account manager assignment\n• Direct access to technical team for integration issues\n\n**Next Steps:**\n• Revise proposal with extended timeline\n• Prepare phased rollout plan\n• Schedule follow-up to discuss updated terms\n\n**Prospect:** David (Enterprise client)\n**Deal Stage:** Interested - addressing concerns\n**Risk Level:** Medium (concerns manageable)',
    category: 'Calls',
    duration: 1089,
    created_at: '2025-12-23T16:45:00',
    audio_file_name: 'enterprise-sales-call.mp3',
    processing: false,
    language: 'en',
    meeting_id: null
  },
  {
    id: 'conv-7',
    title: 'Podcast Recording - Tech Trends 2026',
    transcript: 'Host: Welcome to Tech Trends podcast. Today we\'re discussing the future of AI and automation with industry expert Dr. Emily Chen.\n\nDr. Chen: Thanks for having me. I\'m excited to share insights about where technology is heading.\n\nHost: Let\'s dive right in. What do you see as the biggest AI trend for 2026?\n\nDr. Chen: I think we\'ll see AI becoming truly multimodal. Systems that can seamlessly process text, images, video, and audio together. This will unlock entirely new use cases.\n\nHost: Can you give us an example?\n\nDr. Chen: Imagine a virtual assistant that can watch a cooking video, read the recipe, hear your questions, and guide you through the process while adjusting for your skill level and available ingredients.\n\nHost: That would be incredible. What about concerns around AI safety?\n\nDr. Chen: It\'s a critical issue. We need robust frameworks for AI alignment and interpretability. The key is building systems that can explain their decisions and have built-in safety constraints.\n\nHost: How do you see AI impacting the workforce?\n\nDr. Chen: I believe AI will be more of an augmentation tool than a replacement. It will handle repetitive tasks, allowing humans to focus on creative and strategic work. We\'ll see new job categories emerge that we can\'t even imagine today.\n\nHost: What about AI in healthcare?\n\nDr. Chen: Healthcare is one of the most promising applications. AI can analyze medical images faster and more accurately than humans, predict disease outbreaks, and personalize treatment plans. We\'re already seeing AI detect cancers that human radiologists miss.\n\nHost: That\'s amazing. What are the biggest challenges in AI development right now?\n\nDr. Chen: Three main challenges: data quality, computational costs, and ethical considerations. We need high-quality, unbiased training data. The computational requirements are enormous - training large models can cost millions. And we need to ensure AI systems are fair and don\'t perpetuate societal biases.\n\nHost: How can smaller companies compete in the AI space?\n\nDr. Chen: Focus on specific niches. You don\'t need to build the next ChatGPT. Find a specific problem in your domain and solve it well. Open source models also democratize access - you can fine-tune existing models rather than training from scratch.\n\nHost: What advice do you have for people looking to enter the AI field?\n\nDr. Chen: Start with the fundamentals - linear algebra, statistics, and programming. Take online courses, work on personal projects, and contribute to open source. The field is moving fast, so continuous learning is essential.\n\nHost: Final question - what\'s your prediction for the most surprising AI application we\'ll see in 2026?\n\nDr. Chen: I think we\'ll see AI playing a major role in climate change solutions - optimizing energy grids, predicting weather patterns for agriculture, and discovering new materials for carbon capture. It\'s an area that doesn\'t get enough attention but has enormous potential.\n\nHost: Fascinating insights. Thank you so much for joining us, Dr. Chen.\n\nDr. Chen: My pleasure. Thanks for having me!',
    ai_summary: '**Podcast Episode Summary:**\nTech Trends podcast featuring Dr. Emily Chen discussing AI and automation predictions for 2026.\n\n**Guest:** Dr. Emily Chen - Industry AI Expert\n**Topic:** Future of AI and Automation\n\n**Key Predictions for 2026:**\n\n**1. Multimodal AI Systems:**\n• Primary Trend: True multimodal integration\n• Capability: Seamless processing across text, images, video, and audio\n• Impact: Unlock entirely new use cases and applications\n\n**Example Use Case - Intelligent Cooking Assistant:**\n• Watch and analyze cooking videos\n• Read and interpret recipes\n• Process voice questions in real-time\n• Provide adaptive guidance based on:\n  - User skill level\n  - Available ingredients\n  - Real-time progress\n• Adjust instructions dynamically\n\n**Discussion Topics:**\n• Convergence of different AI modalities\n• Practical applications in everyday life\n• AI safety considerations (discussed)\n\n**Format:** Interview-style podcast\n**Tone:** Forward-looking, optimistic about AI potential\n**Duration:** 31 minutes',
    category: 'Interviews',
    duration: 1876,
    created_at: '2025-12-08T13:00:00',
    audio_file_name: 'podcast-tech-trends.mp3',
    processing: false,
    language: 'en',
    meeting_id: null
  },
  {
    id: 'conv-8',
    title: 'Personal Note - Project Ideas',
    transcript: 'Recording some project ideas for next quarter. First, the mobile app redesign. Users have been requesting dark mode and offline functionality. Should be about 6 weeks of work with current team size.\n\nSecond idea is the AI assistant feature. This could be a game changer but needs careful planning. Would require partnership with an AI provider and significant backend work.\n\nThird, the analytics dashboard enhancement. Current version is basic. Need to add custom reports, data export, and visualization options.\n\nFourth, consider building an API marketplace where third-party developers can build integrations. This could drive ecosystem growth.\n\nNeed to prioritize these and discuss with the team. Mobile app redesign is probably highest priority based on user feedback.',
    ai_summary: '**Personal Project Ideas - Q1 2026:**\nBrainstorming session for potential projects and feature development priorities.\n\n**Project Ideas:**\n\n**1. Mobile App Redesign (HIGH PRIORITY):**\n• User Requests: Dark mode, Offline functionality\n• Estimated Timeline: 6 weeks\n• Priority Rationale: Based on direct user feedback\n• Resource: Current team size adequate\n• Status: Recommended for immediate prioritization\n\n**2. AI Assistant Feature:**\n• Potential Impact: Game changer for product\n• Requirements:\n  - Partnership with AI provider needed\n  - Significant backend infrastructure work\n• Complexity: High\n• Planning: Requires careful strategic planning\n\n**3. Analytics Dashboard Enhancement:**\n• Current State: Basic functionality\n• Proposed Additions:\n  - Custom report builder\n  - Data export capabilities\n  - Advanced visualization options\n• Impact: Improved data insights for users\n\n**4. API Marketplace:**\n• Concept: Platform for third-party developer integrations\n• Strategic Value: Ecosystem growth and expansion\n• Scope: New platform development\n\n**Next Actions:**\n• Prioritize ideas with team\n• Begin planning mobile app redesign\n• Evaluate AI provider partnerships',
    category: 'Personal',
    duration: 567,
    created_at: '2025-12-12T18:30:00',
    audio_file_name: 'project-ideas-note.mp3',
    processing: false,
    language: 'en',
    meeting_id: null
  },
  {
    id: 'conv-9',
    title: 'Customer Support Escalation Call',
    transcript: 'Support Engineer: Hi Mr. Johnson, I\'m calling regarding the technical issue you reported. I\'m the senior support engineer and want to help resolve this quickly.\n\nMr. Johnson: Thank you for calling. We\'ve been experiencing system crashes for the past three days and it\'s impacting our operations.\n\nSupport Engineer: I understand how critical this is. I\'ve reviewed your case and I believe I\'ve identified the root cause. It appears to be related to a recent update that conflicts with your custom integration.\n\nMr. Johnson: Can you fix it remotely?\n\nSupport Engineer: Yes, I can deploy a hotfix right now if you can give me temporary access. The fix will take about 15 minutes to apply and test.\n\nMr. Johnson: Please go ahead. We need this resolved urgently.\n\nSupport Engineer: Starting now. I\'ll keep you on the line and walk you through each step. First, I\'m connecting to your server... okay, I\'m in. I can see the error logs now. The issue is in the authentication module - there\'s a version mismatch.\n\nMr. Johnson: Will this require downtime?\n\nSupport Engineer: Minimal - about 2 minutes. I\'ll coordinate with your team to pick the best time. When do you have the least traffic?\n\nMr. Johnson: Usually between 2 and 3 AM.\n\nSupport Engineer: Perfect. But I can also do a hot-swap deployment to avoid any downtime. It\'s slightly more complex but totally doable.\n\nMr. Johnson: Let\'s do the hot-swap. We can\'t afford any downtime right now.\n\nSupport Engineer: Understood. I\'m deploying the hotfix now... applying patch... restarting services in rolling fashion... checking health endpoints... All green! Can you try accessing the system?\n\nMr. Johnson: Let me check... yes, it\'s working! No errors.\n\nSupport Engineer: Excellent. I\'m going to monitor it for the next 15 minutes to make sure everything stabilizes. I\'m also adding additional logging to catch any future issues early.\n\nMr. Johnson: Thank you so much. This was causing us major problems.\n\nSupport Engineer: Happy to help. I\'m also documenting this issue and will send you a detailed report with recommendations to prevent similar issues. I suggest we schedule a call next week to review your integration setup.\n\nMr. Johnson: That would be great. I really appreciate the quick response.\n\nSupport Engineer: That\'s what we\'re here for. I\'ll send you my direct number in case you need anything else. Have a great day!',
    ai_summary: '**Support Escalation Summary:**\nSenior engineer call with Mr. Johnson to resolve critical system crash issue.\n\n**Issue Details:**\n• Problem: System crashes occurring repeatedly\n• Duration: Past 3 days\n• Business Impact: Operations disrupted\n• Severity: CRITICAL\n• Escalation Level: Senior Support Engineer\n\n**Root Cause Analysis:**\n• Cause Identified: Recent update conflict\n• Conflict Type: Update incompatibility with custom integration\n• Investigation: Case reviewed prior to call\n\n**Resolution Plan:**\n• Method: Remote hotfix deployment\n• Access Required: Temporary system access from client\n• Estimated Time: 15 minutes (deploy + test)\n• Approach: Real-time implementation with client on line\n• Communication: Step-by-step walkthrough provided\n\n**Client Response:**\n• Urgency: High - immediate resolution needed\n• Cooperation: Approved remote access\n• Status: Hotfix deployment initiated\n\n**Customer:** Mr. Johnson\n**Support Tier:** Senior Engineer (escalated)\n**Resolution Status:** IN PROGRESS - Live deployment',
    category: 'Calls',
    duration: 945,
    created_at: '2025-12-19T11:20:00',
    audio_file_name: 'support-escalation.mp3',
    processing: false,
    language: 'en',
    meeting_id: null
  },
  {
    id: 'conv-10',
    title: 'Board Meeting - Quarterly Review',
    transcript: 'CEO: Good afternoon everyone. Thank you all for joining today\'s board meeting. We have a lot to cover, so let\'s get started with the quarterly financial review.\n\nCFO: As you can see from the report, we exceeded our revenue targets by 18%. Net income is up 22% year over year. Our cash position remains strong at $45 million.\n\nBoard Member 1: Impressive numbers. What\'s driving this growth?\n\nCEO: Three main factors. First, our enterprise segment grew 35%. Second, customer retention improved to 94%. Third, our new product line contributed $8 million in revenue.\n\nBoard Member 2: That\'s excellent. What about the expansion plans we discussed last quarter?\n\nCEO: We\'re on track. We\'ve opened offices in London and Singapore. Hiring is progressing well, with 45 new employees added this quarter.\n\nBoard Member 1: How\'s the competitive landscape?\n\nCEO: We\'re maintaining our market leadership position. Our two main competitors have been struggling with product issues, giving us an opportunity to capture more market share.\n\nCFO: We\'re also seeing improved gross margins - up from 68% to 72%. This is due to operational efficiencies and better vendor negotiations.\n\nBoard Member 2: What about R&D spending? Are we investing enough in innovation?\n\nCEO: R&D is at 18% of revenue, up from 15% last quarter. We\'re investing heavily in AI and machine learning capabilities. We\'ve also hired a VP of Innovation.\n\nBoard Member 1: Good to hear. What are the risks we should be aware of?\n\nCEO: Three main risks. First, potential economic slowdown could impact enterprise sales. Second, we\'re watching regulatory changes in Europe. Third, talent acquisition remains competitive.\n\nCFO: We\'re also monitoring our burn rate with the expansion. We\'re projecting to remain cash-flow positive, but the international offices do require upfront investment.\n\nBoard Member 2: What\'s the plan for the next quarter?\n\nCEO: Focus on three areas: scale the enterprise sales team, launch our mobile platform, and expand our partner ecosystem. We\'re aiming for 25% revenue growth.\n\nBoard Member 1: Ambitious but achievable given your track record. Any capital needs?\n\nCFO: We\'re in good shape. Current cash reserves are sufficient for the next 18 months of planned growth. We may consider a strategic raise next year for international expansion, but not urgent.\n\nCEO: We\'re also exploring potential acquisition targets to accelerate our AI capabilities. Nothing imminent, but doing our due diligence.\n\nBoard Member 2: Keep us posted on that. Overall, excellent quarter. Congratulations to the team.\n\nCEO: Thank you. We\'ll send the detailed board package after this meeting. Any other questions?',
    ai_summary: '**Board Meeting - Q4 Review Summary:**\nQuarterly board meeting presenting financial performance and expansion updates.\n\n**Financial Performance:**\n\n**Revenue & Income:**\n• Revenue: Exceeded targets by 18%\n• Net Income: Up 22% year-over-year\n• Cash Position: $45 million (strong)\n• Overall Performance: Significantly exceeded expectations\n\n**Growth Drivers:**\n\n**1. Enterprise Segment:**\n• Growth Rate: 35% increase\n• Contribution: Major revenue driver\n\n**2. Customer Retention:**\n• Current Rate: 94%\n• Impact: Improved from previous quarter\n• Significance: High retention indicates customer satisfaction\n\n**3. New Product Line:**\n• Revenue Contribution: $8 million\n• Status: Successful launch and market adoption\n\n**Expansion Update:**\n\n**Geographic Expansion:**\n• New Offices: London and Singapore operational\n• Status: On track with Q3 plan\n\n**Team Growth:**\n• New Hires: 45 employees this quarter\n• Hiring Progress: Progressing well\n\n**Board Assessment:** Strong quarter with exceeded targets across all key metrics',
    category: 'Meetings',
    duration: 2134,
    created_at: '2025-12-05T14:00:00',
    audio_file_name: 'board-meeting-q4.mp3',
    processing: false,
    language: 'en',
    meeting_id: null
  },
  {
    id: 'conv-11',
    title: 'Training Session - New Hire Orientation',
    transcript: 'HR Manager: Welcome to the team! Today is your orientation and we\'ll cover everything you need to know to get started.\n\nNew Hire: Thank you, I\'m excited to be here!\n\nHR Manager: Let\'s start with company culture and values. We prioritize collaboration, innovation, and customer success. We have a flat organizational structure and encourage everyone to contribute ideas.\n\nNew Hire: That sounds great. What tools will I be using?\n\nHR Manager: We use Slack for communication, Notion for documentation, GitHub for code, and Jira for project management. I\'ll send you invite links after this session.\n\nNew Hire: Perfect. When do I get access to production systems?\n\nHR Manager: You\'ll have read access immediately. Write access requires completing security training, which is scheduled for tomorrow. Any questions so far?\n\nNew Hire: Yes, what\'s the process for code reviews and deployments?\n\nHR Manager: Great question. All code requires two peer reviews before merging. We deploy to staging first, run automated tests, then promote to production. Deployments happen daily at 3 PM.\n\nNew Hire: What about team structure? Who will I be working with?\n\nHR Manager: You\'ll be on the platform team with eight other engineers. Your team lead is Sarah - she\'ll meet with you after this orientation. The team does daily standups at 9:30 AM.\n\nNew Hire: How flexible are the work hours?\n\nHR Manager: Very flexible. Core hours are 10 AM to 3 PM when everyone should be available. Outside that, work whenever you\'re most productive. We also offer remote work two days a week.\n\nNew Hire: That\'s perfect. What about professional development?\n\nHR Manager: We have a $2,000 annual learning budget per employee. You can use it for courses, conferences, or certifications. We also do internal tech talks every Friday.\n\nNew Hire: Excellent. What\'s the onboarding plan for my first month?\n\nHR Manager: Week one is orientation and setup. Week two, you\'ll start on small bug fixes to learn the codebase. Week three, you\'ll take on your first feature. Week four, you\'ll be fully integrated with the team.\n\nNew Hire: Sounds well structured. What are the team\'s current priorities?\n\nHR Manager: The team is working on the mobile platform launch. It\'s our biggest initiative this quarter. You\'ll likely contribute to the API development.\n\nNew Hire: I\'m excited to contribute. What\'s the company\'s vision long-term?\n\nHR Manager: We want to be the leading platform in our space within three years. We\'re focusing on enterprise customers and international expansion. The founder will talk more about this in the all-hands meeting next week.\n\nNew Hire: Can\'t wait. When do I get my laptop?\n\nHR Manager: IT will bring it over in about an hour. It\'s pre-configured with all the tools you need. You\'ll also get your employee handbook and benefits information. Any other questions?\n\nNew Hire: Not right now. This has been really helpful.\n\nHR Manager: Great! Welcome aboard. Let me introduce you to your team lead now.',
    ai_summary: '**New Hire Orientation Summary:**\nWelcome and onboarding session for new team member covering culture, tools, and access.\n\n**Company Culture & Values:**\n• Core Priorities:\n  - Collaboration\n  - Innovation\n  - Customer success\n• Organizational Structure: Flat hierarchy\n• Culture: Open contribution of ideas encouraged\n• Environment: Team-oriented and inclusive\n\n**Tools & Systems:**\n\n**Communication & Collaboration:**\n• Slack - Primary communication platform\n• Notion - Documentation and knowledge base\n\n**Development:**\n• GitHub - Code repository and version control\n• Jira - Project management and task tracking\n\n**Access Setup:**\n• Invite links to be sent post-session\n\n**System Access Protocol:**\n\n**Immediate Access:**\n• Read access to production systems granted immediately\n\n**Write Access:**\n• Requirement: Security training completion\n• Training Scheduled: Tomorrow\n• Access Granted: After training completion\n\n**New Hire Status:** Engaged and excited\n**Onboarding Stage:** Initial orientation (Day 1)\n**Next Step:** Security training scheduled',
    category: 'Business',
    duration: 768,
    created_at: '2025-12-11T10:00:00',
    audio_file_name: 'new-hire-orientation.mp3',
    processing: false,
    language: 'en',
    meeting_id: null
  },
  {
    id: 'conv-12',
    title: 'Brainstorming Session - Marketing Campaign',
    transcript: 'Marketing Director: Alright team, let\'s brainstorm ideas for our Q1 marketing campaign. The goal is to increase brand awareness and drive leads.\n\nSarah: What if we do a video series featuring customer success stories?\n\nMarketing Director: I like that. We could interview clients and show real results they\'ve achieved. Make it authentic and relatable.\n\nMike: We could also do a social media challenge. Get users to share how they use our product with a branded hashtag.\n\nMarketing Director: Great idea! We could offer prizes for the best submissions. Maybe feature winners in our next release.\n\nJessica: What about partnering with influencers in our industry?\n\nMarketing Director: Definitely worth exploring. Let\'s identify 10 potential partners and reach out. Focus on those with engaged audiences in our target market.\n\nSarah: Should we consider paid advertising? Google Ads and LinkedIn have been effective before.\n\nMarketing Director: Yes, but let\'s be strategic. I want to focus on retargeting campaigns. People who visited our site but didn\'t convert. Our conversion rate there is 12%.\n\nMike: What about content marketing? We could create a comprehensive guide or whitepaper.\n\nMarketing Director: Good thinking. Let\'s do "The Complete Guide to Digital Transformation" - position ourselves as thought leaders. We can gate it for lead generation.\n\nJessica: We should also revamp our email nurture campaigns. Current open rates are only 18%.\n\nMarketing Director: Agreed. Let\'s segment our audience better - by industry, company size, and engagement level. Personalized emails perform 3x better.\n\nSarah: What about events? Should we host a webinar series?\n\nMarketing Director: Absolutely. Let\'s do monthly webinars. First one on "AI in Business" - that\'s hot right now. We can invite our existing customers as panelists.\n\nMike: Should we consider podcast sponsorships? Our target audience listens to several tech podcasts.\n\nMarketing Director: Good idea. Research the top five podcasts and get pricing. We want ones with 50K+ listeners in our demographic.\n\nJessica: What\'s our budget for all this?\n\nMarketing Director: We have $150,000 for Q1. I\'m thinking 40% video content, 30% paid ads, 20% events, 10% influencer partnerships.\n\nSarah: That sounds balanced. When do we need final proposals?\n\nMarketing Director: End of this week. Each of you take ownership of one major initiative. Sarah, you lead the video series. Mike, social media challenge. Jessica, influencer partnerships. I\'ll handle the webinars and paid ads.\n\nMike: What are our success metrics?\n\nMarketing Director: Target is 500 qualified leads, 50,000 website visitors, and 20% increase in social media engagement. We\'ll track everything in our analytics dashboard.\n\nJessica: When does the campaign launch?\n\nMarketing Director: January 15th. That gives us three weeks to prepare. Let\'s make Q1 our biggest quarter yet. Great ideas everyone!',
    ai_summary: '**Marketing Campaign Brainstorming:**\nTeam ideation session for Q1 marketing campaign focused on brand awareness and lead generation.\n\n**Campaign Objectives:**\n• Primary Goal: Increase brand awareness\n• Secondary Goal: Drive qualified leads\n• Target Quarter: Q1 2026\n\n**Ideas Generated:**\n\n**1. Customer Success Video Series:**\n• Format: Interview-based video content\n• Content: Real client results and achievements\n• Approach: Authentic and relatable storytelling\n• Channel: Multi-platform distribution\n• Value Proposition: Demonstrate proven results\n\n**2. Social Media Challenge:**\n• Concept: User-generated content campaign\n• Mechanic: Users share product usage with branded hashtag\n• Incentives: Prizes for best submissions\n• Recognition: Feature winners in next product release\n• Engagement: Drive community participation\n\n**3. Influencer Partnership Program:**\n• Strategy: Partner with industry influencers\n• Target: 10 potential partners identified\n• Selection Criteria:\n  - Engaged audience in target market\n  - Alignment with brand values\n  - Authentic reach and influence\n• Approach: Personalized outreach to selected partners\n\n**Next Steps:**\n• Prioritize and select campaign ideas\n• Develop detailed execution plans\n• Assign owners to each initiative',
    category: 'Meetings',
    duration: 1123,
    created_at: '2025-12-17T15:30:00',
    audio_file_name: 'marketing-brainstorm.mp3',
    processing: false,
    language: 'en',
    meeting_id: null
  }
];

// Quick Notes Mock Data
export const quickNotesMockData = [
  {
    id: 'note-1',
    title: 'Q4 Budget Review Meeting Notes',
    content: 'Key takeaways from today\'s budget meeting:\n\n- Marketing budget increased by 20% for Q4\n- Need to reallocate $50k from travel to digital advertising\n- CFO approved new analytics platform ($15k/year)\n- Sales team requesting 2 additional headcount\n- R&D budget remains flat at $200k/quarter\n\nAction items:\n- Follow up with Sarah on digital ad strategy\n- Schedule headcount discussion with HR\n- Get quotes for analytics platforms by Friday',
    tags: ['business'],
    created_at: '2025-12-28T14:30:00',
    updated_at: '2025-12-28T14:30:00'
  },
  {
    id: 'note-2',
    title: 'Cresa Client - Tower Properties Meeting',
    content: '850 Park Avenue - Potential office lease\n\nClient: Tower Properties LLC\nContact: Michael Chen, CFO\nPhone: (555) 234-5678\n\nRequirements:\n- 15,000 - 20,000 sq ft\n- Must have high-speed internet infrastructure\n- Looking for Class A building in Midtown\n- Budget: $75-85/sq ft\n- Move-in date: Q2 2026\n\nNext steps:\n- Schedule tour of 850 Park Ave next Tuesday\n- Send comparable listings in Midtown\n- Prepare financial analysis by EOW',
    tags: ['cresa'],
    created_at: '2025-12-27T10:15:00',
    updated_at: '2025-12-27T10:15:00'
  },
  {
    id: 'note-3',
    title: 'Investment Portfolio Review - December',
    content: 'Portfolio Performance:\n\nStocks: +12.5% YTD\n- Tech sector: +18%\n- Healthcare: +8%\n- Energy: -3%\n\nReal Estate:\n- Brooklyn property: $2,100/month rental income\n- Manhattan condo: Appreciation of 7% this year\n\nCrypto:\n- BTC: +45%\n- ETH: +38%\n\nBonds: +4.2%\n\nOverall portfolio up 14.8% for the year.\n\nQ1 2026 strategy:\n- Increase real estate holdings\n- Rebalance tech allocation (currently overweight)\n- Consider emerging markets ETF',
    tags: ['investments'],
    created_at: '2025-12-26T16:45:00',
    updated_at: '2025-12-26T16:45:00'
  },
  {
    id: 'note-4',
    title: 'Counterfind App - Feature Ideas',
    content: 'Brainstorming session ideas for Counterfind v2.0:\n\n1. AI-Powered Search\n- Natural language queries\n- Image-based search\n- Voice search integration\n\n2. Social Features\n- Share discoveries with friends\n- Collaborative lists\n- Community ratings and reviews\n\n3. Personalization\n- ML-based recommendations\n- Custom categories and tags\n- Save search preferences\n\n4. Integration Ideas\n- Shopify integration\n- Price tracking and alerts\n- Inventory notifications\n\n5. Monetization\n- Premium tier with advanced features\n- Affiliate partnerships\n- Sponsored listings\n\nNext meeting: Thursday 2pm with product team',
    tags: ['counterfind'],
    created_at: '2025-12-25T11:20:00',
    updated_at: '2025-12-25T11:20:00'
  },
  {
    id: 'note-5',
    title: 'Grocery List & Meal Planning',
    content: 'Weekly Grocery List:\n\nProduce:\n- Spinach, kale, arugula\n- Tomatoes, cucumbers, bell peppers\n- Avocados (4)\n- Bananas, apples, berries\n\nProtein:\n- Chicken breast (2 lbs)\n- Salmon fillets (4)\n- Ground turkey (1 lb)\n- Eggs (18 pack)\n\nDairy:\n- Greek yogurt\n- Almond milk\n- Feta cheese\n\nPantry:\n- Quinoa\n- Brown rice\n- Pasta\n- Olive oil\n\nMeal Plan:\nMon: Grilled salmon with roasted vegetables\nTue: Turkey pasta with marinara\nWed: Chicken stir-fry\nThu: Quinoa bowl with chickpeas\nFri: Pizza night!',
    tags: ['personal'],
    created_at: '2025-12-24T09:00:00',
    updated_at: '2025-12-24T09:00:00'
  },
  {
    id: 'note-6',
    title: 'Cresa - 450 Lexington Avenue Property Analysis',
    content: 'Property: 450 Lexington Avenue, 15th Floor\n\nSpecs:\n- 12,500 sq ft\n- Recently renovated\n- $82/sq ft\n- Available: March 2026\n\nPros:\n+ Prime Midtown location\n+ Modern finishes\n+ Building has great amenities (gym, conference rooms)\n+ Walking distance to Grand Central\n\nCons:\n- Slightly above client budget\n- Limited parking\n- Lease term minimum 5 years\n\nComps:\n- 420 Lexington: $78/sq ft (older building)\n- 475 Park Ave: $85/sq ft (similar quality)\n\nRecommendation: Schedule showing, negotiate on price\n\nClient call scheduled: Monday 10am',
    tags: ['cresa'],
    created_at: '2025-12-23T15:30:00',
    updated_at: '2025-12-23T15:30:00'
  },
  {
    id: 'note-7',
    title: 'Business Ideas - New Ventures',
    content: 'Potential Business Opportunities:\n\n1. SaaS for Real Estate Agents\n- CRM + property management\n- Market size: $2B\n- Competition: moderate\n- Initial investment: $150k\n\n2. E-commerce Store - Sustainable Products\n- Focus on eco-friendly home goods\n- Dropshipping model\n- Low initial cost\n- Growing market trend\n\n3. Consulting Services\n- Commercial real estate advisory\n- Leverage existing network\n- Service-based, low overhead\n- Can start immediately\n\n4. Mobile App - Fitness Tracker\n- AI personal trainer\n- Subscription model $9.99/month\n- Need technical co-founder\n\nTop priority: Research SaaS opportunity further\n\nRead: "Zero to One" by Peter Thiel',
    tags: ['business'],
    created_at: '2025-12-22T13:45:00',
    updated_at: '2025-12-22T13:45:00'
  },
  {
    id: 'note-8',
    title: 'Stock Watchlist - January 2026',
    content: 'Stocks to Monitor:\n\nTech:\n- NVDA: AI chip leader, wait for pullback\n- MSFT: Strong Azure growth, accumulate\n- AAPL: Services revenue increasing, hold current position\n\nHealthcare:\n- JNJ: Dividend aristocrat, good value\n- PFE: Undervalued, potential turnaround\n\nFinancials:\n- JPM: Interest rate beneficiary\n- V: Payment processing moat\n\nEmerging:\n- PLTR: Data analytics, high growth\n- COIN: Crypto exposure\n\nTarget allocation:\n40% Tech\n30% Healthcare\n20% Financials\n10% Emerging/Speculative\n\nNext review: January 15th',
    tags: ['investments'],
    created_at: '2025-12-21T08:30:00',
    updated_at: '2025-12-21T08:30:00'
  },
  {
    id: 'note-9',
    title: 'Vacation Planning - Summer 2026',
    content: 'Summer Vacation Ideas:\n\nOption 1: European Tour (14 days)\n- Paris (3 days)\n- Barcelona (3 days)\n- Rome (3 days)\n- Amsterdam (2 days)\n- London (3 days)\nEstimated cost: $8,000 for two\n\nOption 2: Japan Adventure (12 days)\n- Tokyo (4 days)\n- Kyoto (3 days)\n- Osaka (2 days)\n- Hiroshima (1 day)\n- Mt. Fuji (2 days)\nEstimated cost: $7,500 for two\n\nOption 3: Caribbean Cruise (7 days)\n- All-inclusive\n- Stops: Jamaica, Cayman Islands, Cozumel\nEstimated cost: $3,500 for two\n\nPreference: Japan!\n\nTo-do:\n- Check flight prices in February\n- Apply for Japan visa\n- Book hotels 3 months in advance\n- Learn basic Japanese phrases',
    tags: ['personal'],
    created_at: '2025-12-20T19:00:00',
    updated_at: '2025-12-20T19:00:00'
  },
  {
    id: 'note-10',
    title: 'Counterfind - User Feedback Summary',
    content: 'User Feedback Analysis (December 2025):\n\nTop Feature Requests:\n1. Save searches - mentioned by 45% of users\n2. Price drop alerts - 38%\n3. Mobile app - 32%\n4. Better filtering options - 28%\n5. Wishlist sharing - 22%\n\nBug Reports:\n- Search occasionally returns outdated listings (Priority: High)\n- Mobile site slow on older devices (Priority: Medium)\n- Email notifications not working for some users (Priority: High)\n\nPositive Feedback:\n- "Best discovery tool I\'ve used!"\n- "Saved me hours of searching"\n- "Love the clean interface"\n\nUser Growth:\n- 2,500 active users (up 40% from last month)\n- 65% return rate\n- Average session: 12 minutes\n\nAction Plan:\n- Fix high-priority bugs by Jan 10\n- Implement save searches feature by Feb 1\n- Start mobile app development Q1',
    tags: ['counterfind'],
    created_at: '2025-12-19T14:20:00',
    updated_at: '2025-12-19T14:20:00'
  },
  {
    id: 'note-11',
    title: 'Team Meeting Notes - Project Phoenix',
    content: 'Project Phoenix - Weekly Standup\n\nAttendees: Sarah, Mike, Jennifer, Tom, Lisa\n\nProgress Updates:\n- Frontend: 75% complete (Sarah)\n- Backend API: 90% complete (Mike)\n- Design: Final mockups approved (Jennifer)\n- QA: Testing in progress (Tom)\n- Documentation: 60% complete (Lisa)\n\nBlockers:\n- Need AWS credentials for staging deployment\n- Waiting on legal review for Terms of Service\n\nLaunch Timeline:\n- Beta testing: January 15\n- Public launch: February 1\n\nPost-meeting action items:\n□ Mike to request AWS access from IT\n□ Jennifer to follow up with legal\n□ Sarah to fix responsive design issues\n□ Tom to complete security testing\n□ Lisa to finish API documentation\n\nNext meeting: Thursday 2pm',
    tags: ['business'],
    created_at: '2025-12-18T10:00:00',
    updated_at: '2025-12-18T10:00:00'
  },
  {
    id: 'note-12',
    title: 'Book Recommendations & Reading List',
    content: 'Books to Read:\n\nBusiness/Professional:\n1. "The Lean Startup" by Eric Ries\n2. "Atomic Habits" by James Clear ⭐ Currently reading\n3. "Deep Work" by Cal Newport\n4. "The E-Myth Revisited" by Michael Gerber\n5. "Traction" by Gino Wickman\n\nInvestment/Finance:\n1. "The Intelligent Investor" by Benjamin Graham ✓ Completed\n2. "A Random Walk Down Wall Street" by Burton Malkiel\n3. "Rich Dad Poor Dad" by Robert Kiyosaki ✓ Completed\n4. "The Psychology of Money" by Morgan Housel\n\nPersonal Development:\n1. "Mindset" by Carol Dweck\n2. "The 7 Habits of Highly Effective People" by Stephen Covey ✓ Completed\n3. "Can\'t Hurt Me" by David Goggins\n\nFiction (for fun):\n1. "Project Hail Mary" by Andy Weir\n2. "The Midnight Library" by Matt Haig\n\nGoal: Read 24 books in 2026 (2 per month)',
    tags: ['personal'],
    created_at: '2025-12-17T20:30:00',
    updated_at: '2025-12-17T20:30:00'
  },
  {
    id: 'note-13',
    title: 'Cresa - Brooklyn Office Space Search',
    content: 'Client: Brooklyn Tech Startup\nContact: Alex Rivera, CEO\nBudget: $60-70/sq ft\nSize: 8,000 - 10,000 sq ft\n\nRequirements:\n- Open floor plan\n- Near subway (L or G train preferred)\n- Natural light\n- Kitchen/break room space\n- Conference rooms (2+)\n- Creative vibe\n\nProspect Properties:\n\n1. DUMBO - 55 Water Street\n   - 9,200 sq ft\n   - $68/sq ft\n   - Exposed brick, high ceilings\n   - 2 blocks from F train\n   ⭐ Top choice\n\n2. Williamsburg - 142 N 6th Street\n   - 8,500 sq ft\n   - $65/sq ft\n   - Recently renovated\n   - L train accessible\n\n3. Gowanus - 365 Bond Street\n   - 10,000 sq ft\n   - $62/sq ft\n   - Industrial loft style\n   - R train nearby\n\nTour scheduled: Next Wednesday\nPrepare proposal by Friday',
    tags: ['cresa'],
    created_at: '2025-12-16T11:45:00',
    updated_at: '2025-12-16T11:45:00'
  },
  {
    id: 'note-14',
    title: 'Tax Planning - Year End Strategies',
    content: '2025 Tax Planning Checklist:\n\n□ Max out 401(k) contributions ($23,000 limit)\n□ Contribute to Roth IRA ($7,000 limit)\n□ Harvest tax losses in brokerage account\n□ Charitable donations (target: $5,000)\n□ Review business expense deductions\n□ Estimated quarterly payments up to date?\n\nDeductions to maximize:\n- Home office: $3,000\n- Business travel: $8,000\n- Professional development: $2,000\n- Business meals: $4,000\n\nCapital Gains:\n- Short-term: $12,000 (taxed as ordinary income)\n- Long-term: $18,000 (15% rate)\n\nEstimated Tax Liability: $45,000\nPrepaid: $42,000\nRemaining: ~$3,000\n\nMeeting with CPA: January 5th\nDocuments to prepare:\n- W-2s, 1099s\n- Investment statements\n- Business expense receipts\n- Charitable donation receipts',
    tags: ['investments'],
    created_at: '2025-12-15T16:00:00',
    updated_at: '2025-12-15T16:00:00'
  },
  {
    id: 'note-15',
    title: 'Gift Ideas - Holidays & Birthdays',
    content: 'Gift Shopping List:\n\nMom (Birthday - January 15):\n- Spa day package ($200)\n- Personalized jewelry\n- Gardening tool set\n- Book: "The Four Winds"\n\nDad (Father\'s Day):\n- Golf club upgrade\n- Grilling accessories\n- Smart watch\n- Workshop tools\n\nSister (Birthday - March 8):\n- Designer handbag\n- Concert tickets\n- Yoga retreat weekend\n- Tech accessories\n\nBest Friend:\n- Custom photo album\n- Wine tasting experience\n- Cooking class for two\n\nSignificant Other:\n- Weekend getaway (Napa Valley?)\n- Custom art piece\n- High-end headphones\n- Surprise dinner reservation\n\nColleagues (Holiday):\n- Gift cards: Starbucks or Amazon ($25 each)\n- Gourmet chocolate boxes\n- Desk accessories\n\nBudget: $2,500 total',
    tags: ['personal'],
    created_at: '2025-12-14T12:15:00',
    updated_at: '2025-12-14T12:15:00'
  },
  {
    id: 'note-16',
    title: 'Counterfind Marketing Strategy Q1 2026',
    content: 'Q1 Marketing Plan:\n\nGoals:\n- Reach 5,000 active users (currently 2,500)\n- Increase engagement by 40%\n- Launch mobile app\n- Build email list to 10,000 subscribers\n\nChannels:\n\n1. Content Marketing\n- Blog posts (2x per week)\n- SEO optimization\n- Guest posts on tech blogs\nBudget: $3,000\n\n2. Social Media\n- Instagram influencer partnerships\n- TikTok trend videos\n- Twitter engagement\nBudget: $5,000\n\n3. Paid Advertising\n- Google Ads (search)\n- Facebook/Instagram ads\n- Reddit sponsored posts\nBudget: $10,000\n\n4. Email Marketing\n- Newsletter (weekly)\n- Onboarding sequence\n- Re-engagement campaigns\nBudget: $1,000\n\n5. Partnerships\n- Collaborate with complementary apps\n- Affiliate program launch\nBudget: $2,000\n\nTotal Q1 Budget: $21,000\n\nKPIs to track:\n- User acquisition cost\n- Conversion rate\n- Retention rate\n- Viral coefficient\n\nReview progress monthly',
    tags: ['counterfind'],
    created_at: '2025-12-13T09:30:00',
    updated_at: '2025-12-13T09:30:00'
  },
  {
    id: 'note-17',
    title: 'Networking Event Follow-ups',
    content: 'Tech Networking Event - December 10\n\nKey Contacts:\n\n1. Sarah Chen - VP of Product at TechCorp\n   Email: sarah.chen@techcorp.com\n   LinkedIn: connected ✓\n   Follow-up: Coffee meeting scheduled Jan 12\n   Potential: Partnership opportunity\n\n2. Marcus Johnson - Angel Investor\n   Email: marcus@innovate.vc\n   LinkedIn: pending\n   Follow-up: Send pitch deck\n   Potential: Series A funding\n\n3. Emily Rodriguez - UX Designer\n   Email: emily.r.design@gmail.com\n   LinkedIn: connected ✓\n   Follow-up: Portfolio review scheduled\n   Potential: Freelance collaboration\n\n4. David Park - Software Engineer at Google\n   Email: dpark@gmail.com\n   LinkedIn: connected ✓\n   Follow-up: Technical discussion over lunch\n   Potential: Technical advisor\n\n5. Jessica Liu - Marketing Director\n   Email: jessica.liu@growth.co\n   LinkedIn: connected ✓\n   Follow-up: Marketing strategy brainstorm\n   Potential: Marketing consultation\n\nAction items:\n□ Send personalized follow-up emails (by Friday)\n□ Share relevant articles with each contact\n□ Schedule coffee meetings\n□ Update CRM with contact details',
    tags: ['business'],
    created_at: '2025-12-11T18:00:00',
    updated_at: '2025-12-11T18:00:00'
  },
  {
    id: 'note-18',
    title: 'Home Improvement Projects 2026',
    content: 'Home Projects Priority List:\n\nHigh Priority:\n1. Kitchen Renovation\n   - New countertops (quartz)\n   - Cabinet refinishing\n   - Updated lighting\n   - Budget: $15,000\n   - Timeline: Q2 2026\n\n2. Bathroom Upgrade\n   - New vanity\n   - Walk-in shower\n   - Heated floors\n   - Budget: $10,000\n   - Timeline: Q3 2026\n\n3. Backyard Landscaping\n   - Deck renovation\n   - Outdoor kitchen area\n   - Garden beds\n   - Budget: $8,000\n   - Timeline: Spring 2026\n\nMedium Priority:\n4. Master Bedroom Refresh\n   - Paint walls\n   - New flooring\n   - Closet organization\n   - Budget: $5,000\n\n5. Home Office Setup\n   - Built-in bookshelves\n   - Desk upgrade\n   - Better lighting\n   - Budget: $3,000\n\nLow Priority:\n6. Basement Finishing\n7. Attic insulation\n8. Solar panel installation\n\nTotal estimated cost: $41,000+\nContractors to contact: 3\nGet quotes by: January 30',
    tags: ['personal'],
    created_at: '2025-12-10T15:45:00',
    updated_at: '2025-12-10T15:45:00'
  }
];

// Travel / Flights Mock Data
export const travelMockData = [
  {
    id: 'trip-1',
    destination: 'Tokyo, Japan',
    start_date: '2026-03-15',
    end_date: '2026-03-22',
    purpose: 'Tech Conference & Client Meetings',
    status: 'upcoming',
    category: 'business',
    flight_details: 'United Airlines UA7925 • JFK → NRT • Seat 12A',
    hotel_details: 'Park Hyatt Tokyo, Shinjuku • Executive Suite',
    notes: 'Attending Tokyo Tech Summit. Meeting with Mitsubishi executives on March 17th. Remember to bring adapter plugs and business cards.',
    confirmation_number: 'UA7925JK',
    departure_time: '14:30',
    arrival_time: '18:45+1',
    flight_duration: '14h 15m',
    airline: 'United Airlines',
    booking_reference: 'ABC123'
  },
  {
    id: 'trip-2',
    destination: 'London, UK',
    start_date: '2026-02-10',
    end_date: '2026-02-14',
    purpose: 'Real Estate Conference - Cresa',
    status: 'upcoming',
    category: 'cresa',
    flight_details: 'British Airways BA112 • JFK → LHR • Seat 8D',
    hotel_details: 'The Langham London • Deluxe Room',
    notes: 'Cresa Annual European Conference. Presenting on commercial real estate trends. Dinner with London team on Feb 11th.',
    confirmation_number: 'BA112XY',
    departure_time: '19:00',
    arrival_time: '07:15+1',
    flight_duration: '7h 15m',
    airline: 'British Airways',
    booking_reference: 'XYZ789'
  },
  {
    id: 'trip-3',
    destination: 'San Francisco, CA',
    start_date: '2026-04-05',
    end_date: '2026-04-08',
    purpose: 'Counterfind Product Launch Event',
    status: 'planned',
    category: 'counterfind',
    flight_details: 'Delta DL1234 • JFK → SFO • Seat 3B',
    hotel_details: 'Four Seasons San Francisco • Bay View Suite',
    notes: 'Launching Counterfind v2.0. Press event on April 6th. Meeting with investors on April 7th.',
    confirmation_number: 'DL1234SF',
    departure_time: '08:00',
    arrival_time: '11:30',
    flight_duration: '6h 30m',
    airline: 'Delta Airlines',
    booking_reference: 'DEF456'
  },
  {
    id: 'trip-4',
    destination: 'Miami, FL',
    start_date: '2026-01-20',
    end_date: '2026-01-23',
    purpose: 'Personal Vacation',
    status: 'upcoming',
    category: 'personal',
    flight_details: 'JetBlue B61503 • JFK → MIA • Seat 15C',
    hotel_details: 'Fontainebleau Miami Beach • Ocean View Room',
    notes: 'Long weekend getaway. Beach relaxation and exploring South Beach restaurants.',
    confirmation_number: 'B61503M',
    departure_time: '10:15',
    arrival_time: '13:45',
    flight_duration: '3h 30m',
    airline: 'JetBlue Airways',
    booking_reference: 'GHI789'
  },
  {
    id: 'trip-5',
    destination: 'Dubai, UAE',
    start_date: '2026-05-12',
    end_date: '2026-05-18',
    purpose: 'Investment Summit & Property Tours',
    status: 'planned',
    category: 'investments',
    flight_details: 'Emirates EK202 • JFK → DXB • Seat 2K',
    hotel_details: 'Burj Al Arab • Panoramic Suite',
    notes: 'Middle East Investment Forum. Touring luxury real estate developments. Meeting with Dubai investors.',
    confirmation_number: 'EK202DX',
    departure_time: '22:30',
    arrival_time: '19:15+1',
    flight_duration: '12h 45m',
    airline: 'Emirates',
    booking_reference: 'JKL012'
  },
  {
    id: 'trip-6',
    destination: 'Austin, TX',
    start_date: '2025-12-15',
    end_date: '2025-12-18',
    purpose: 'Speaking Engagement - SXSW Preview',
    status: 'completed',
    category: 'speaking',
    flight_details: 'Southwest WN1456 • LGA → AUS • Seat 12A',
    hotel_details: 'W Austin • Wonderful Suite',
    notes: 'Keynote on "Future of PropTech". Panel discussion on real estate innovation. Networking event Dec 16th.',
    confirmation_number: 'WN1456TX',
    departure_time: '07:00',
    arrival_time: '10:30',
    flight_duration: '4h 30m',
    airline: 'Southwest Airlines',
    booking_reference: 'MNO345'
  },
  {
    id: 'trip-7',
    destination: 'Barcelona, Spain',
    start_date: '2026-06-20',
    end_date: '2026-06-27',
    purpose: 'Summer Vacation with Family',
    status: 'planned',
    category: 'personal',
    flight_details: 'Iberia IB6251 • JFK → BCN • Seats 20A, 20B',
    hotel_details: 'Hotel Arts Barcelona • Mediterranean Suite',
    notes: 'Family trip. Visiting La Sagrada Familia, Park Güell, and Gothic Quarter. Beach days and tapas tours.',
    confirmation_number: 'IB6251BC',
    departure_time: '17:45',
    arrival_time: '07:30+1',
    flight_duration: '7h 45m',
    airline: 'Iberia',
    booking_reference: 'PQR678'
  },
  {
    id: 'trip-8',
    destination: 'Chicago, IL',
    start_date: '2026-02-25',
    end_date: '2026-02-27',
    purpose: 'Cresa Regional Meeting',
    status: 'upcoming',
    category: 'cresa',
    flight_details: 'American AA315 • LGA → ORD • Seat 5F',
    hotel_details: 'The Peninsula Chicago • Deluxe King Room',
    notes: 'Quarterly regional meeting. Presenting Q1 results. Team dinner on Feb 25th.',
    confirmation_number: 'AA315CH',
    departure_time: '06:30',
    arrival_time: '08:15',
    flight_duration: '2h 45m',
    airline: 'American Airlines',
    booking_reference: 'STU901'
  },
  {
    id: 'trip-9',
    destination: 'Singapore',
    start_date: '2025-11-10',
    end_date: '2025-11-16',
    purpose: 'FinTech Conference & Investor Meetings',
    status: 'completed',
    category: 'investments',
    flight_details: 'Singapore Airlines SQ23 • JFK → SIN • Seat 3A',
    hotel_details: 'Marina Bay Sands • Premier Room',
    notes: 'Singapore FinTech Festival. Meeting with Asian investors. Exploring blockchain opportunities.',
    confirmation_number: 'SQ23SIN',
    departure_time: '23:55',
    arrival_time: '05:30+2',
    flight_duration: '18h 35m',
    airline: 'Singapore Airlines',
    booking_reference: 'VWX234'
  },
  {
    id: 'trip-10',
    destination: 'Los Angeles, CA',
    start_date: '2026-03-02',
    end_date: '2026-03-05',
    purpose: 'Counterfind Team Offsite',
    status: 'upcoming',
    category: 'counterfind',
    flight_details: 'Alaska AS1295 • JFK → LAX • Seat 9C',
    hotel_details: 'The Ritz-Carlton Marina del Rey • Ocean View',
    notes: 'Q1 team offsite and strategy planning. Team building activities. Product roadmap workshop.',
    confirmation_number: 'AS1295LA',
    departure_time: '09:00',
    arrival_time: '12:30',
    flight_duration: '6h 30m',
    airline: 'Alaska Airlines',
    booking_reference: 'YZA567'
  },
  {
    id: 'trip-11',
    destination: 'Nashville, TN',
    start_date: '2026-04-18',
    end_date: '2026-04-20',
    purpose: 'Speaking - Music City Tech Summit',
    status: 'planned',
    category: 'speaking',
    flight_details: 'Southwest WN892 • LGA → BNA • Seat 7A',
    hotel_details: 'The Hermitage Hotel • Deluxe Room',
    notes: 'Keynote on "Tech Innovation in Traditional Industries". Panel on Friday afternoon.',
    confirmation_number: 'WN892NA',
    departure_time: '11:30',
    arrival_time: '13:15',
    flight_duration: '2h 45m',
    airline: 'Southwest Airlines',
    booking_reference: 'BCD890'
  },
  {
    id: 'trip-12',
    destination: 'Paris, France',
    start_date: '2025-10-08',
    end_date: '2025-10-13',
    purpose: 'Anniversary Trip',
    status: 'completed',
    category: 'personal',
    flight_details: 'Air France AF006 • JFK → CDG • Seats 4A, 4B',
    hotel_details: 'Four Seasons George V • Eiffel Tower View Suite',
    notes: '10th anniversary celebration. Visited Louvre, Eiffel Tower, Versailles. Amazing restaurants throughout.',
    confirmation_number: 'AF006PA',
    departure_time: '18:30',
    arrival_time: '08:00+1',
    flight_duration: '7h 30m',
    airline: 'Air France',
    booking_reference: 'EFG123'
  },
  {
    id: 'trip-13',
    destination: 'Boston, MA',
    start_date: '2026-01-15',
    end_date: '2026-01-16',
    purpose: 'Cresa Client Presentation',
    status: 'upcoming',
    category: 'cresa',
    flight_details: 'Delta DL5678 • LGA → BOS • Seat 6D',
    hotel_details: 'Boston Harbor Hotel • Harbor View Room',
    notes: 'Presenting office space proposal to major tech client. Tour of potential properties.',
    confirmation_number: 'DL5678BO',
    departure_time: '07:15',
    arrival_time: '08:30',
    flight_duration: '1h 15m',
    airline: 'Delta Airlines',
    booking_reference: 'HIJ456'
  },
  {
    id: 'trip-14',
    destination: 'Seattle, WA',
    start_date: '2026-07-10',
    end_date: '2026-07-13',
    purpose: 'Tech Company Visits',
    status: 'planned',
    category: 'business',
    flight_details: 'Alaska AS8 • JFK → SEA • Seat 4B',
    hotel_details: 'Four Seasons Seattle • Deluxe Room',
    notes: 'Meeting with Amazon, Microsoft teams. Exploring partnership opportunities for Counterfind.',
    confirmation_number: 'AS8SEA',
    departure_time: '10:00',
    arrival_time: '13:15',
    flight_duration: '6h 15m',
    airline: 'Alaska Airlines',
    booking_reference: 'KLM789'
  },
  {
    id: 'trip-15',
    destination: 'Cancún, Mexico',
    start_date: '2025-12-28',
    end_date: '2026-01-02',
    purpose: 'New Year Holiday',
    status: 'upcoming',
    category: 'personal',
    flight_details: 'JetBlue B6503 • JFK → CUN • Seat 11A',
    hotel_details: 'Rosewood Mayakoba • Ocean View Suite',
    notes: 'New Year celebration. Beach resort relaxation. Mayan ruins tour planned.',
    confirmation_number: 'B6503CU',
    departure_time: '08:30',
    arrival_time: '12:45',
    flight_duration: '4h 15m',
    airline: 'JetBlue Airways',
    booking_reference: 'NOP012'
  }
];

// Finances Mock Data
export const financesMockData = {
  stats: {
    revenue: 125680.50,
    expenses: 78942.25,
    profit: 46738.25,
    balance: 167430.25
  },
  accounts: [
    {
      id: 'acc-1',
      name: 'Chase Checking',
      institution: 'JPMorgan Chase',
      type: 'checking',
      balances: {
        current: 45680.50,
        available: 45680.50
      },
      last_four: '4829',
      status: 'active'
    },
    {
      id: 'acc-2',
      name: 'Chase Savings',
      institution: 'JPMorgan Chase',
      type: 'savings',
      balances: {
        current: 125000.00,
        available: 125000.00
      },
      last_four: '7721',
      status: 'active'
    },
    {
      id: 'acc-3',
      name: 'American Express Gold',
      institution: 'American Express',
      type: 'credit',
      balances: {
        current: -3250.25,
        available: 46749.75
      },
      last_four: '1009',
      status: 'active'
    }
  ],
  transactions: [
    {
      id: 'txn-1',
      date: '2025-12-28',
      description: 'Counterfind SaaS Revenue',
      category: 'Income',
      amount: 15800.00,
      type: 'income',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Stripe',
      notes: 'Monthly subscription revenue'
    },
    {
      id: 'txn-2',
      date: '2025-12-27',
      description: 'AWS Cloud Services',
      category: 'Technology',
      amount: 2450.75,
      type: 'expense',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Amazon Web Services',
      notes: 'Cloud hosting and infrastructure'
    },
    {
      id: 'txn-3',
      date: '2025-12-27',
      description: 'Office Rent - December',
      category: 'Real Estate',
      amount: 4500.00,
      type: 'expense',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Midtown Properties LLC',
      notes: 'Monthly office space rental'
    },
    {
      id: 'txn-4',
      date: '2025-12-26',
      description: 'Cresa Commission',
      category: 'Income',
      amount: 8500.00,
      type: 'income',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Cresa',
      notes: 'Q4 commission payment'
    },
    {
      id: 'txn-5',
      date: '2025-12-26',
      description: 'Team Lunch - Client Meeting',
      category: 'Meals',
      amount: 285.50,
      type: 'expense',
      account: 'Amex Gold',
      status: 'completed',
      merchant: 'Del Frisco\'s',
      notes: 'Client entertainment'
    },
    {
      id: 'txn-6',
      date: '2025-12-25',
      description: 'Holiday Gifts - Team',
      category: 'Gifts',
      amount: 1200.00,
      type: 'expense',
      account: 'Amex Gold',
      status: 'completed',
      merchant: 'Amazon',
      notes: 'Holiday team appreciation'
    },
    {
      id: 'txn-7',
      date: '2025-12-24',
      description: 'Speaking Fee - Tech Conference',
      category: 'Income',
      amount: 5000.00,
      type: 'income',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'TechCrunch Events',
      notes: 'Austin conference keynote'
    },
    {
      id: 'txn-8',
      date: '2025-12-23',
      description: 'Google Workspace',
      category: 'Software',
      amount: 450.00,
      type: 'expense',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Google',
      notes: 'Annual business subscription'
    },
    {
      id: 'txn-9',
      date: '2025-12-22',
      description: 'Uber Business - Month',
      category: 'Transportation',
      amount: 580.25,
      type: 'expense',
      account: 'Amex Gold',
      status: 'completed',
      merchant: 'Uber',
      notes: 'Business travel expenses'
    },
    {
      id: 'txn-10',
      date: '2025-12-21',
      description: 'Investment Dividend',
      category: 'Income',
      amount: 1250.50,
      type: 'income',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Vanguard',
      notes: 'Quarterly dividend payment'
    },
    {
      id: 'txn-11',
      date: '2025-12-20',
      description: 'LinkedIn Premium',
      category: 'Marketing',
      amount: 79.99,
      type: 'expense',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'LinkedIn',
      notes: 'Sales Navigator subscription'
    },
    {
      id: 'txn-12',
      date: '2025-12-20',
      description: 'Adobe Creative Cloud',
      category: 'Software',
      amount: 54.99,
      type: 'expense',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Adobe',
      notes: 'Monthly design tools'
    },
    {
      id: 'txn-13',
      date: '2025-12-19',
      description: 'Consulting Project Payment',
      category: 'Income',
      amount: 12500.00,
      type: 'income',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Fortune 500 Client',
      notes: 'Real estate advisory project'
    },
    {
      id: 'txn-14',
      date: '2025-12-18',
      description: 'Hotel - Business Trip NYC',
      category: 'Travel',
      amount: 850.00,
      type: 'expense',
      account: 'Amex Gold',
      status: 'completed',
      merchant: 'Four Seasons',
      notes: '2 nights business accommodation'
    },
    {
      id: 'txn-15',
      date: '2025-12-18',
      description: 'Delta Airlines - NYC to SF',
      category: 'Travel',
      amount: 420.00,
      type: 'expense',
      account: 'Amex Gold',
      status: 'completed',
      merchant: 'Delta Airlines',
      notes: 'Business class flight'
    },
    {
      id: 'txn-16',
      date: '2025-12-17',
      description: 'Salary - December',
      category: 'Income',
      amount: 25000.00,
      type: 'income',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Cresa LLC',
      notes: 'Monthly base salary'
    },
    {
      id: 'txn-17',
      date: '2025-12-16',
      description: 'Internet & Phone',
      category: 'Utilities',
      amount: 185.00,
      type: 'expense',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Verizon',
      notes: 'Business line and internet'
    },
    {
      id: 'txn-18',
      date: '2025-12-16',
      description: 'Office Supplies',
      category: 'Supplies',
      amount: 245.80,
      type: 'expense',
      account: 'Amex Gold',
      status: 'completed',
      merchant: 'Staples',
      notes: 'Printer, paper, misc supplies'
    },
    {
      id: 'txn-19',
      date: '2025-12-15',
      description: 'Health Insurance',
      category: 'Insurance',
      amount: 850.00,
      type: 'expense',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Blue Cross Blue Shield',
      notes: 'Monthly premium'
    },
    {
      id: 'txn-20',
      date: '2025-12-14',
      description: 'Counterfind Ad Revenue',
      category: 'Income',
      amount: 3200.00,
      type: 'income',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Google AdSense',
      notes: 'Monthly advertising revenue'
    },
    {
      id: 'txn-21',
      date: '2025-12-13',
      description: 'Zoom Pro Subscription',
      category: 'Software',
      amount: 19.99,
      type: 'expense',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Zoom',
      notes: 'Video conferencing tool'
    },
    {
      id: 'txn-22',
      date: '2025-12-12',
      description: 'Slack Business',
      category: 'Software',
      amount: 240.00,
      type: 'expense',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Slack Technologies',
      notes: 'Team communication platform'
    },
    {
      id: 'txn-23',
      date: '2025-12-11',
      description: 'Starbucks - Client Meetings',
      category: 'Meals',
      amount: 125.40,
      type: 'expense',
      account: 'Amex Gold',
      status: 'completed',
      merchant: 'Starbucks',
      notes: 'Coffee meetings with clients'
    },
    {
      id: 'txn-24',
      date: '2025-12-10',
      description: 'Parking - Midtown',
      category: 'Transportation',
      amount: 85.00,
      type: 'expense',
      account: 'Amex Gold',
      status: 'completed',
      merchant: 'Icon Parking',
      notes: 'Monthly parking spot'
    },
    {
      id: 'txn-25',
      date: '2025-12-09',
      description: 'Domain Renewals',
      category: 'Technology',
      amount: 180.00,
      type: 'expense',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'GoDaddy',
      notes: 'Annual domain registrations'
    },
    {
      id: 'txn-26',
      date: '2025-12-08',
      description: 'Stock Sale - Profit',
      category: 'Income',
      amount: 8500.00,
      type: 'income',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'E*TRADE',
      notes: 'Capital gains from tech stock'
    },
    {
      id: 'txn-27',
      date: '2025-12-07',
      description: 'Mailchimp Pro',
      category: 'Marketing',
      amount: 299.00,
      type: 'expense',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Mailchimp',
      notes: 'Email marketing platform'
    },
    {
      id: 'txn-28',
      date: '2025-12-06',
      description: 'QuickBooks Online',
      category: 'Software',
      amount: 75.00,
      type: 'expense',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Intuit',
      notes: 'Accounting software'
    },
    {
      id: 'txn-29',
      date: '2025-12-05',
      description: 'Business Cards',
      category: 'Marketing',
      amount: 120.00,
      type: 'expense',
      account: 'Amex Gold',
      status: 'completed',
      merchant: 'Moo',
      notes: 'Premium business cards - 500 qty'
    },
    {
      id: 'txn-30',
      date: '2025-12-04',
      description: 'Legal Fees - Contract Review',
      category: 'Professional Services',
      amount: 1500.00,
      type: 'expense',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Smith & Associates Law',
      notes: 'Client contract review'
    },
    {
      id: 'txn-31',
      date: '2025-12-03',
      description: 'Rental Income - Brooklyn Property',
      category: 'Income',
      amount: 4200.00,
      type: 'income',
      account: 'Chase Savings',
      status: 'completed',
      merchant: 'Tenant Payment',
      notes: 'December rent payment'
    },
    {
      id: 'txn-32',
      date: '2025-12-02',
      description: 'Property Tax - Q4',
      category: 'Taxes',
      amount: 2800.00,
      type: 'expense',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'NYC Department of Finance',
      notes: 'Quarterly property tax'
    },
    {
      id: 'txn-33',
      date: '2025-12-01',
      description: 'Gym Membership',
      category: 'Health',
      amount: 180.00,
      type: 'expense',
      account: 'Amex Gold',
      status: 'completed',
      merchant: 'Equinox',
      notes: 'Monthly fitness membership'
    },
    {
      id: 'txn-34',
      date: '2025-11-30',
      description: 'Freelance Design Work',
      category: 'Income',
      amount: 2500.00,
      type: 'income',
      account: 'Chase Checking',
      status: 'completed',
      merchant: 'Upwork',
      notes: 'Website design project'
    },
    {
      id: 'txn-35',
      date: '2025-11-29',
      description: 'Whole Foods - Office Snacks',
      category: 'Supplies',
      amount: 185.60,
      type: 'expense',
      account: 'Amex Gold',
      status: 'completed',
      merchant: 'Whole Foods',
      notes: 'Monthly office refreshments'
    }
  ]
};

// Analytics Hub Mock Data
export const analyticsHubMockData = {
  overallStats: {
    total_reach: 2847500,
    engagement_rate: 8.4,
    total_followers: 458900,
    total_posts: 487
  },
  platforms: [
    {
      platform: 'instagram',
      username: '@creatvrverse',
      followers: 285400,
      posts: 342,
      reach: 1850000,
      engagement_rate: 9.2,
      content_frequency: 24,
      impressions: 3240000,
      profile_views: 145000,
      website_clicks: 12400,
      email_contacts: 890,
      saves: 45600,
      shares: 23400,
      comments: 34500,
      likes: 287000,
      video_views: 1240000,
      story_views: 456000,
      last_updated: 'Dec 30, 2025 - 11:30 AM',
      status: 'connected',
      growth_rate: 15.3,
      top_performing_content: [
        {
          id: 'post-1',
          type: 'reel',
          title: 'Real Estate Tech Trends 2026',
          thumbnail: 'https://picsum.photos/seed/insta1/400/400',
          likes: 34500,
          comments: 1240,
          shares: 890,
          reach: 285000,
          engagement_rate: 12.8,
          posted_date: '2025-12-28'
        },
        {
          id: 'post-2',
          type: 'post',
          title: 'NYC Office Space Tour',
          thumbnail: 'https://picsum.photos/seed/insta2/400/400',
          likes: 28900,
          comments: 980,
          shares: 670,
          reach: 245000,
          engagement_rate: 11.4,
          posted_date: '2025-12-25'
        },
        {
          id: 'post-3',
          type: 'carousel',
          title: 'Investment Portfolio Tips',
          thumbnail: 'https://picsum.photos/seed/insta3/400/400',
          likes: 25600,
          comments: 850,
          shares: 560,
          reach: 198000,
          engagement_rate: 10.2,
          posted_date: '2025-12-22'
        }
      ],
      demographics: {
        age_groups: {
          '18-24': 18,
          '25-34': 42,
          '35-44': 28,
          '45-54': 9,
          '55+': 3
        },
        gender: {
          male: 58,
          female: 41,
          other: 1
        },
        top_locations: [
          { city: 'New York, NY', percentage: 34 },
          { city: 'Los Angeles, CA', percentage: 18 },
          { city: 'San Francisco, CA', percentage: 12 },
          { city: 'Chicago, IL', percentage: 8 },
          { city: 'Miami, FL', percentage: 6 }
        ]
      }
    },
    {
      platform: 'youtube',
      username: '@TechRealEstatePro',
      followers: 125800,
      subscribers: 125800,
      posts: 98,
      videos: 98,
      reach: 845000,
      engagement_rate: 6.8,
      content_frequency: 12,
      total_views: 5840000,
      watch_time_hours: 234000,
      avg_view_duration: '8:45',
      likes: 124000,
      comments: 8900,
      shares: 5600,
      subscribers_gained: 12400,
      last_updated: 'Dec 30, 2025 - 10:15 AM',
      status: 'connected',
      growth_rate: 22.5,
      top_performing_content: [
        {
          id: 'video-1',
          type: 'video',
          title: 'How I Built a $10M Real Estate Portfolio',
          thumbnail: 'https://picsum.photos/seed/yt1/640/360',
          views: 485000,
          likes: 28400,
          comments: 1850,
          watch_time: '42000 hours',
          engagement_rate: 8.2,
          posted_date: '2025-12-20'
        },
        {
          id: 'video-2',
          type: 'video',
          title: 'Counterfind App Demo - Find Hidden Deals',
          thumbnail: 'https://picsum.photos/seed/yt2/640/360',
          views: 342000,
          likes: 19800,
          comments: 1240,
          watch_time: '28000 hours',
          engagement_rate: 7.5,
          posted_date: '2025-12-15'
        },
        {
          id: 'video-3',
          type: 'short',
          title: 'Real Estate Investing Mistake to Avoid',
          thumbnail: 'https://picsum.photos/seed/yt3/640/360',
          views: 890000,
          likes: 45600,
          comments: 2840,
          watch_time: '15000 hours',
          engagement_rate: 9.1,
          posted_date: '2025-12-10'
        }
      ],
      demographics: {
        age_groups: {
          '18-24': 12,
          '25-34': 38,
          '35-44': 32,
          '45-54': 14,
          '55+': 4
        },
        gender: {
          male: 65,
          female: 34,
          other: 1
        },
        top_locations: [
          { city: 'United States', percentage: 68 },
          { city: 'United Kingdom', percentage: 12 },
          { city: 'Canada', percentage: 8 },
          { city: 'Australia', percentage: 5 },
          { city: 'India', percentage: 4 }
        ]
      }
    },
    {
      platform: 'tiktok',
      username: '@realestate.tech',
      followers: 47700,
      posts: 47,
      reach: 152500,
      engagement_rate: 11.5,
      content_frequency: 8,
      total_views: 3850000,
      likes: 445000,
      comments: 23400,
      shares: 34500,
      saves: 12800,
      profile_views: 89000,
      last_updated: 'Dec 30, 2025 - 9:45 AM',
      status: 'connected',
      growth_rate: 45.8,
      top_performing_content: [
        {
          id: 'tiktok-1',
          type: 'video',
          title: 'Real Estate Hack You Need to Know',
          thumbnail: 'https://picsum.photos/seed/tt1/400/600',
          views: 1240000,
          likes: 128000,
          comments: 4580,
          shares: 12400,
          engagement_rate: 14.2,
          posted_date: '2025-12-26'
        },
        {
          id: 'tiktok-2',
          type: 'video',
          title: 'Office Tour - $50M Building',
          thumbnail: 'https://picsum.photos/seed/tt2/400/600',
          views: 890000,
          likes: 89000,
          comments: 3200,
          shares: 8900,
          engagement_rate: 13.5,
          posted_date: '2025-12-23'
        },
        {
          id: 'tiktok-3',
          type: 'video',
          title: 'Investment Portfolio Review',
          thumbnail: 'https://picsum.photos/seed/tt3/400/600',
          views: 567000,
          likes: 56000,
          comments: 1890,
          shares: 5600,
          engagement_rate: 11.8,
          posted_date: '2025-12-18'
        }
      ],
      demographics: {
        age_groups: {
          '18-24': 48,
          '25-34': 35,
          '35-44': 12,
          '45-54': 4,
          '55+': 1
        },
        gender: {
          male: 52,
          female: 47,
          other: 1
        },
        top_locations: [
          { city: 'United States', percentage: 72 },
          { city: 'Canada', percentage: 11 },
          { city: 'United Kingdom', percentage: 7 },
          { city: 'Australia', percentage: 5 },
          { city: 'Germany', percentage: 3 }
        ]
      }
    }
  ]
};

// Inventory Mock Data
export const inventoryMockData = {
  stats: {
    total_items: 42,
    available: 28,
    in_use: 11,
    maintenance: 3
  },
  items: [
    {
      id: 'inv-1',
      name: 'Sony A7S III Camera Body',
      category: 'Camera',
      status: 'good',
      total_quantity: 3,
      available_quantity: 2,
      value_per_unit: 3899,
      description: 'Professional mirrorless camera with 4K 120fps recording',
      serial_number: 'SN-A7S3-001',
      purchase_date: '2024-03-15',
      last_maintenance: '2025-11-20',
      location: 'Studio A - Equipment Room'
    },
    {
      id: 'inv-2',
      name: 'Canon EOS R5 Camera',
      category: 'Camera',
      status: 'good',
      total_quantity: 2,
      available_quantity: 1,
      value_per_unit: 3899,
      description: '45MP full-frame mirrorless camera with 8K video',
      serial_number: 'SN-R5-001',
      purchase_date: '2024-06-10',
      last_maintenance: '2025-12-05',
      location: 'Studio B - Equipment Room'
    },
    {
      id: 'inv-3',
      name: 'Sony FX6 Cinema Camera',
      category: 'Camera',
      status: 'in_use',
      total_quantity: 1,
      available_quantity: 0,
      value_per_unit: 5999,
      description: 'Full-frame cinema camera with dual ISO',
      serial_number: 'SN-FX6-001',
      purchase_date: '2024-01-20',
      last_maintenance: '2025-10-15',
      location: 'On Location - Client Shoot',
      checked_out_to: 'Production Team A',
      return_date: '2026-01-05'
    },
    {
      id: 'inv-4',
      name: 'DJI Ronin RS3 Pro Gimbal',
      category: 'Camera',
      status: 'good',
      total_quantity: 2,
      available_quantity: 2,
      value_per_unit: 869,
      description: 'Professional 3-axis gimbal stabilizer',
      serial_number: 'SN-RS3-001',
      purchase_date: '2024-08-05',
      last_maintenance: '2025-11-30',
      location: 'Studio A - Storage'
    },
    {
      id: 'inv-5',
      name: 'Sennheiser MKH 416 Shotgun Mic',
      category: 'Audio',
      status: 'good',
      total_quantity: 4,
      available_quantity: 3,
      value_per_unit: 999,
      description: 'Industry-standard shotgun microphone',
      serial_number: 'SN-MKH416-001',
      purchase_date: '2023-11-12',
      last_maintenance: '2025-09-20',
      location: 'Audio Room - Shelf 2'
    },
    {
      id: 'inv-6',
      name: 'Rode Wireless GO II System',
      category: 'Audio',
      status: 'good',
      total_quantity: 3,
      available_quantity: 2,
      value_per_unit: 299,
      description: 'Dual-channel wireless microphone system',
      serial_number: 'SN-WGOII-001',
      purchase_date: '2024-04-18',
      last_maintenance: '2025-11-15',
      location: 'Audio Room - Drawer 3'
    },
    {
      id: 'inv-7',
      name: 'Zoom F6 Field Recorder',
      category: 'Audio',
      status: 'in_use',
      total_quantity: 2,
      available_quantity: 1,
      value_per_unit: 659,
      description: '6-input/8-track field recorder with 32-bit float',
      serial_number: 'SN-F6-001',
      purchase_date: '2024-02-25',
      last_maintenance: '2025-10-10',
      location: 'On Location - Documentary Shoot',
      checked_out_to: 'Audio Team',
      return_date: '2026-01-03'
    },
    {
      id: 'inv-8',
      name: 'Shure SM7B Microphone',
      category: 'Audio',
      status: 'good',
      total_quantity: 2,
      available_quantity: 2,
      value_per_unit: 399,
      description: 'Broadcast-quality dynamic microphone',
      serial_number: 'SN-SM7B-001',
      purchase_date: '2023-09-30',
      last_maintenance: '2025-08-15',
      location: 'Podcast Studio'
    },
    {
      id: 'inv-9',
      name: 'Aputure 600d Pro LED Light',
      category: 'Lighting',
      status: 'good',
      total_quantity: 2,
      available_quantity: 1,
      value_per_unit: 1899,
      description: 'High-output daylight LED with Bowens mount',
      serial_number: 'SN-600D-001',
      purchase_date: '2024-05-20',
      last_maintenance: '2025-11-25',
      location: 'Lighting Grid - Studio A'
    },
    {
      id: 'inv-10',
      name: 'Aputure 300x Bi-Color LED',
      category: 'Lighting',
      status: 'in_use',
      total_quantity: 4,
      available_quantity: 2,
      value_per_unit: 999,
      description: 'Bi-color LED light with wireless control',
      serial_number: 'SN-300X-001',
      purchase_date: '2024-07-10',
      last_maintenance: '2025-12-01',
      location: 'Studio B - Interview Setup',
      checked_out_to: 'Production Team B',
      return_date: '2025-12-31'
    },
    {
      id: 'inv-11',
      name: 'ARRI SkyPanel S60-C',
      category: 'Lighting',
      status: 'good',
      total_quantity: 2,
      available_quantity: 2,
      value_per_unit: 3499,
      description: 'Professional RGBW LED soft light',
      serial_number: 'SN-S60C-001',
      purchase_date: '2023-12-05',
      last_maintenance: '2025-10-30',
      location: 'Lighting Grid - Studio A'
    },
    {
      id: 'inv-12',
      name: 'Godox SL-60W LED Light',
      category: 'Lighting',
      status: 'maintenance',
      total_quantity: 6,
      available_quantity: 4,
      value_per_unit: 139,
      description: 'Compact LED video light with Bowens mount',
      serial_number: 'SN-SL60-001',
      purchase_date: '2024-03-08',
      last_maintenance: '2025-12-15',
      location: 'Repair Shop',
      maintenance_notes: 'Power supply issue - parts ordered'
    },
    {
      id: 'inv-13',
      name: 'Manfrotto 546GB Tripod',
      category: 'Support',
      status: 'good',
      total_quantity: 5,
      available_quantity: 3,
      value_per_unit: 279,
      description: 'Professional aluminum video tripod with ground spreader',
      serial_number: 'SN-546GB-001',
      purchase_date: '2024-01-15',
      last_maintenance: '2025-09-10',
      location: 'Studio A - Tripod Rack'
    },
    {
      id: 'inv-14',
      name: 'Sony 24-70mm f/2.8 GM II Lens',
      category: 'Lens',
      status: 'good',
      total_quantity: 2,
      available_quantity: 1,
      value_per_unit: 2299,
      description: 'Professional standard zoom lens',
      serial_number: 'SN-2470GM2-001',
      purchase_date: '2024-04-22',
      last_maintenance: '2025-11-10',
      location: 'Lens Cabinet - Row 1'
    },
    {
      id: 'inv-15',
      name: 'Sony 70-200mm f/2.8 GM OSS II',
      category: 'Lens',
      status: 'in_use',
      total_quantity: 1,
      available_quantity: 0,
      value_per_unit: 2799,
      description: 'Professional telephoto zoom lens',
      serial_number: 'SN-70200GM2-001',
      purchase_date: '2024-06-15',
      last_maintenance: '2025-12-02',
      location: 'On Location - Sports Shoot',
      checked_out_to: 'Photographer John',
      return_date: '2026-01-02'
    },
    {
      id: 'inv-16',
      name: 'Sony 16-35mm f/2.8 GM Lens',
      category: 'Lens',
      status: 'good',
      total_quantity: 1,
      available_quantity: 1,
      value_per_unit: 2199,
      description: 'Professional wide-angle zoom lens',
      serial_number: 'SN-1635GM-001',
      purchase_date: '2024-02-10',
      last_maintenance: '2025-10-20',
      location: 'Lens Cabinet - Row 1'
    },
    {
      id: 'inv-17',
      name: 'DJI Mavic 3 Pro Drone',
      category: 'Drone',
      status: 'good',
      total_quantity: 2,
      available_quantity: 2,
      value_per_unit: 2199,
      description: 'Professional drone with tri-camera system',
      serial_number: 'SN-M3PRO-001',
      purchase_date: '2024-05-08',
      last_maintenance: '2025-11-18',
      location: 'Drone Storage - Case 1'
    },
    {
      id: 'inv-18',
      name: 'DJI FPV Drone',
      category: 'Drone',
      status: 'in_use',
      total_quantity: 1,
      available_quantity: 0,
      value_per_unit: 1299,
      description: 'High-speed FPV racing and cinematic drone',
      serial_number: 'SN-FPV-001',
      purchase_date: '2024-07-20',
      last_maintenance: '2025-11-05',
      location: 'On Location - Commercial Shoot',
      checked_out_to: 'Drone Operator Mike',
      return_date: '2025-12-31'
    },
    {
      id: 'inv-19',
      name: 'MacBook Pro 16" M3 Max',
      category: 'Computer',
      status: 'good',
      total_quantity: 3,
      available_quantity: 2,
      value_per_unit: 3999,
      description: 'Professional editing workstation',
      serial_number: 'SN-MBP16-001',
      purchase_date: '2024-11-10',
      last_maintenance: '2025-12-10',
      location: 'Edit Suite A'
    },
    {
      id: 'inv-20',
      name: 'LaCie 8TB Rugged RAID Pro',
      category: 'Storage',
      status: 'good',
      total_quantity: 5,
      available_quantity: 4,
      value_per_unit: 499,
      description: 'Rugged portable RAID storage for field use',
      serial_number: 'SN-RAID-001',
      purchase_date: '2024-08-15',
      last_maintenance: '2025-11-01',
      location: 'Storage Room - Shelf 3'
    },
    {
      id: 'inv-21',
      name: 'Pelican 1510 Case',
      category: 'Case',
      status: 'good',
      total_quantity: 8,
      available_quantity: 5,
      value_per_unit: 229,
      description: 'Carry-on hard case with foam insert',
      serial_number: 'SN-PEL1510-001',
      purchase_date: '2023-10-20',
      last_maintenance: 'N/A',
      location: 'Storage Room - Case Stack'
    },
    {
      id: 'inv-22',
      name: 'Blackmagic DaVinci Resolve Panel',
      category: 'Computer',
      status: 'good',
      total_quantity: 1,
      available_quantity: 1,
      value_per_unit: 1195,
      description: 'Professional color grading control surface',
      serial_number: 'SN-DVR-001',
      purchase_date: '2024-09-05',
      last_maintenance: '2025-11-28',
      location: 'Color Suite'
    },
    {
      id: 'inv-23',
      name: 'Teradek Bolt 4K LT 750 TX/RX',
      category: 'Video',
      status: 'in_use',
      total_quantity: 2,
      available_quantity: 1,
      value_per_unit: 1999,
      description: 'Wireless video transmission system',
      serial_number: 'SN-BOLT-001',
      purchase_date: '2024-06-28',
      last_maintenance: '2025-12-08',
      location: 'On Location - Live Event',
      checked_out_to: 'Video Team',
      return_date: '2026-01-04'
    },
    {
      id: 'inv-24',
      name: 'Atomos Ninja V+ Monitor/Recorder',
      category: 'Monitor',
      status: 'good',
      total_quantity: 3,
      available_quantity: 2,
      value_per_unit: 799,
      description: '5.2" 4K HDR monitor with ProRes RAW recording',
      serial_number: 'SN-NINJA-001',
      purchase_date: '2024-04-12',
      last_maintenance: '2025-10-25',
      location: 'Monitor Rack'
    },
    {
      id: 'inv-25',
      name: 'Tentacle Sync E Timecode Generator',
      category: 'Sync',
      status: 'good',
      total_quantity: 6,
      available_quantity: 4,
      value_per_unit: 249,
      description: 'Wireless timecode sync for multi-camera shoots',
      serial_number: 'SN-TENT-001',
      purchase_date: '2024-03-18',
      last_maintenance: '2025-09-15',
      location: 'Audio Room - Drawer 1'
    },
    {
      id: 'inv-26',
      name: 'Litepanels Astra 6X Bi-Color',
      category: 'Lighting',
      status: 'maintenance',
      total_quantity: 2,
      available_quantity: 1,
      value_per_unit: 1599,
      description: 'Bi-color LED panel light',
      serial_number: 'SN-ASTRA-001',
      purchase_date: '2023-11-30',
      last_maintenance: '2025-12-20',
      location: 'Repair Shop',
      maintenance_notes: 'DMX control not responding - being diagnosed'
    },
    {
      id: 'inv-27',
      name: 'Hollyland Mars 400S Pro Wireless',
      category: 'Video',
      status: 'good',
      total_quantity: 3,
      available_quantity: 3,
      value_per_unit: 429,
      description: 'Wireless HDMI/SDI video transmission',
      serial_number: 'SN-MARS-001',
      purchase_date: '2024-07-22',
      last_maintenance: '2025-11-12',
      location: 'Video Gear - Shelf 2'
    },
    {
      id: 'inv-28',
      name: 'SmallRig Camera Cage Kit',
      category: 'Rig',
      status: 'good',
      total_quantity: 4,
      available_quantity: 3,
      value_per_unit: 189,
      description: 'Universal camera cage with accessories',
      serial_number: 'SN-CAGE-001',
      purchase_date: '2024-02-14',
      last_maintenance: 'N/A',
      location: 'Rig Storage'
    },
    {
      id: 'inv-29',
      name: 'Wooden Camera Director\'s Monitor Cage',
      category: 'Monitor',
      status: 'in_use',
      total_quantity: 2,
      available_quantity: 1,
      value_per_unit: 495,
      description: 'Professional monitor cage with sun hood',
      serial_number: 'SN-WCAGE-001',
      purchase_date: '2024-05-30',
      last_maintenance: 'N/A',
      location: 'On Set - Monitor Cart',
      checked_out_to: 'Director',
      return_date: '2026-01-06'
    },
    {
      id: 'inv-30',
      name: 'Sony NP-FZ100 Battery (8-Pack)',
      category: 'Battery',
      status: 'good',
      total_quantity: 16,
      available_quantity: 12,
      value_per_unit: 78,
      description: 'High-capacity camera batteries',
      serial_number: 'SN-FZ100-001',
      purchase_date: '2024-01-10',
      last_maintenance: 'N/A',
      location: 'Charging Station'
    },
    {
      id: 'inv-31',
      name: 'V-Mount Battery 150Wh',
      category: 'Battery',
      status: 'good',
      total_quantity: 8,
      available_quantity: 6,
      value_per_unit: 299,
      description: 'High-capacity V-mount batteries',
      serial_number: 'SN-VMOUNT-001',
      purchase_date: '2024-06-05',
      last_maintenance: '2025-12-01',
      location: 'Charging Station'
    },
    {
      id: 'inv-32',
      name: 'Colorama 2.72m Paper Backdrop (Black)',
      category: 'Backdrop',
      status: 'good',
      total_quantity: 3,
      available_quantity: 2,
      value_per_unit: 89,
      description: 'Professional paper backdrop roll',
      serial_number: 'SN-BG-001',
      purchase_date: '2024-08-20',
      last_maintenance: 'N/A',
      location: 'Backdrop Storage'
    },
    {
      id: 'inv-33',
      name: 'Neewer C-Stand with Boom Arm',
      category: 'Support',
      status: 'good',
      total_quantity: 10,
      available_quantity: 7,
      value_per_unit: 129,
      description: 'Heavy-duty light stand with boom',
      serial_number: 'SN-CSTAND-001',
      purchase_date: '2024-03-12',
      last_maintenance: 'N/A',
      location: 'Studio A - Stand Rack'
    },
    {
      id: 'inv-34',
      name: 'Tiffen Black Pro-Mist Filter Set',
      category: 'Filter',
      status: 'good',
      total_quantity: 2,
      available_quantity: 2,
      value_per_unit: 189,
      description: 'Professional diffusion filter set (1/4, 1/2, 1)',
      serial_number: 'SN-MIST-001',
      purchase_date: '2024-09-18',
      last_maintenance: 'N/A',
      location: 'Filter Case'
    },
    {
      id: 'inv-35',
      name: 'Matthews Baby Overhead Frame',
      category: 'Grip',
      status: 'maintenance',
      total_quantity: 2,
      available_quantity: 1,
      value_per_unit: 349,
      description: '4x4 overhead frame for diffusion',
      serial_number: 'SN-FRAME-001',
      purchase_date: '2023-12-20',
      last_maintenance: '2025-12-18',
      location: 'Repair Shop',
      maintenance_notes: 'Bent corner being straightened'
    }
  ]
};

// Contacts Mock Data (50 contacts)
export const contactsMockData = {
  localContacts: [
    { id: 'c1', name: 'Sarah Johnson', email: 'sarah.j@techcorp.com', phone: '+1 (555) 123-4501', company: 'TechCorp', role: 'VP of Sales', category: 'business', image: 'https://i.pravatar.cc/150?img=1' },
    { id: 'c2', name: 'Michael Chen', email: 'mchen@realestate.com', phone: '+1 (555) 123-4502', company: 'Prime Properties', role: 'Broker', category: 'real-estate', image: 'https://i.pravatar.cc/150?img=2' },
    { id: 'c3', name: 'Dr. Emily Rodriguez', email: 'emily.r@healthplus.org', phone: '+1 (555) 123-4503', company: 'HealthPlus Medical', role: 'Chief of Surgery', category: 'healthcare', image: 'https://i.pravatar.cc/150?img=3' },
    { id: 'c4', name: 'David Park', email: 'dpark@innovatetech.io', phone: '+1 (555) 123-4504', company: 'Innovate Tech', role: 'CTO', category: 'technology', image: 'https://i.pravatar.cc/150?img=4' },
    { id: 'c5', name: 'Jennifer Williams', email: 'jwilliams@capitalbank.com', phone: '+1 (555) 123-4505', company: 'Capital Bank', role: 'Investment Manager', category: 'finance', image: 'https://i.pravatar.cc/150?img=5' },
    { id: 'c6', name: 'Robert Martinez', email: 'rmartinez@sportsagency.com', phone: '+1 (555) 123-4506', company: 'Elite Sports Agency', role: 'Sports Agent', category: 'sports', image: 'https://i.pravatar.cc/150?img=6' },
    { id: 'c7', name: 'Lisa Anderson', email: 'landerson@lawfirm.com', phone: '+1 (555) 123-4507', company: 'Anderson & Associates', role: 'Senior Partner', category: 'legal', image: 'https://i.pravatar.cc/150?img=7' },
    { id: 'c8', name: 'James Taylor', email: 'jtaylor@university.edu', phone: '+1 (555) 123-4508', company: 'State University', role: 'Professor', category: 'education', image: 'https://i.pravatar.cc/150?img=8' },
    { id: 'c9', name: 'Maria Garcia', email: 'mgarcia@consulting.com', phone: '+1 (555) 123-4509', company: 'Garcia Consulting', role: 'Business Consultant', category: 'services', image: 'https://i.pravatar.cc/150?img=9' },
    { id: 'c10', name: 'Thomas Brown', email: 'tbrown@autogroup.com', phone: '+1 (555) 123-4510', company: 'Premium Auto Group', role: 'Sales Director', category: 'automotive', image: 'https://i.pravatar.cc/150?img=10' },
    { id: 'c11', name: 'Amanda Wilson', email: 'awilson@email.com', phone: '+1 (555) 123-4511', company: '', role: '', category: 'family', image: 'https://i.pravatar.cc/150?img=11' },
    { id: 'c12', name: 'Christopher Lee', email: 'clee@startup.io', phone: '+1 (555) 123-4512', company: 'Growth Startup', role: 'Founder & CEO', category: 'technology', image: 'https://i.pravatar.cc/150?img=12' },
    { id: 'c13', name: 'Patricia Moore', email: 'pmoore@hospital.org', phone: '+1 (555) 123-4513', company: 'City Hospital', role: 'Head Nurse', category: 'healthcare', image: 'https://i.pravatar.cc/150?img=13' },
    { id: 'c14', name: 'Daniel Kim', email: 'dkim@investment.com', phone: '+1 (555) 123-4514', company: 'Kim Investments', role: 'Portfolio Manager', category: 'finance', image: 'https://i.pravatar.cc/150?img=14' },
    { id: 'c15', name: 'Jessica Thompson', email: 'jthompson@properties.com', phone: '+1 (555) 123-4515', company: 'Thompson Real Estate', role: 'Agent', category: 'real-estate', image: 'https://i.pravatar.cc/150?img=15' },
    { id: 'c16', name: 'Matthew White', email: 'mwhite@techsolutions.com', phone: '+1 (555) 123-4516', company: 'Tech Solutions Inc', role: 'Lead Developer', category: 'technology', image: 'https://i.pravatar.cc/150?img=16' },
    { id: 'c17', name: 'Nancy Harris', email: 'nharris@school.edu', phone: '+1 (555) 123-4517', company: 'Lincoln High School', role: 'Principal', category: 'education', image: 'https://i.pravatar.cc/150?img=17' },
    { id: 'c18', name: 'Kevin Clark', email: 'kclark@legal.com', phone: '+1 (555) 123-4518', company: 'Clark Legal Services', role: 'Attorney', category: 'legal', image: 'https://i.pravatar.cc/150?img=18' },
    { id: 'c19', name: 'Stephanie Lewis', email: 'slewis@gym.com', phone: '+1 (555) 123-4519', company: 'Elite Fitness', role: 'Personal Trainer', category: 'sports', image: 'https://i.pravatar.cc/150?img=19' },
    { id: 'c20', name: 'Brian Walker', email: 'bwalker@email.com', phone: '+1 (555) 123-4520', company: '', role: '', category: 'friends', image: 'https://i.pravatar.cc/150?img=20' },
    { id: 'c21', name: 'Rebecca Hall', email: 'rhall@marketing.com', phone: '+1 (555) 123-4521', company: 'Creative Marketing', role: 'Marketing Director', category: 'business', image: 'https://i.pravatar.cc/150?img=21' },
    { id: 'c22', name: 'Steven Allen', email: 'sallen@construction.com', phone: '+1 (555) 123-4522', company: 'Allen Construction', role: 'Project Manager', category: 'services', image: 'https://i.pravatar.cc/150?img=22' },
    { id: 'c23', name: 'Michelle Young', email: 'myoung@clinic.org', phone: '+1 (555) 123-4523', company: 'Family Clinic', role: 'Physician', category: 'healthcare', image: 'https://i.pravatar.cc/150?img=23' },
    { id: 'c24', name: 'Ryan King', email: 'rking@dealership.com', phone: '+1 (555) 123-4524', company: 'King Motors', role: 'Sales Manager', category: 'automotive', image: 'https://i.pravatar.cc/150?img=24' },
    { id: 'c25', name: 'Laura Wright', email: 'lwright@bank.com', phone: '+1 (555) 123-4525', company: 'First National Bank', role: 'Loan Officer', category: 'finance', image: 'https://i.pravatar.cc/150?img=25' }
  ],
  icloudContacts: [
    { id: 'ic1', name: 'Alexander Scott', email: 'ascott@tech.com', phone: '+1 (555) 234-5001', company: 'Scott Technologies', role: 'Engineer', category: 'technology', source: 'icloud', image: 'https://i.pravatar.cc/150?img=26' },
    { id: 'ic2', name: 'Sophia Green', email: 'sgreen@design.com', phone: '+1 (555) 234-5002', company: 'Green Design Studio', role: 'Creative Director', category: 'business', source: 'icloud', image: 'https://i.pravatar.cc/150?img=27' },
    { id: 'ic3', name: 'William Baker', email: 'wbaker@law.com', phone: '+1 (555) 234-5003', company: 'Baker Law Firm', role: 'Partner', category: 'legal', source: 'icloud', image: 'https://i.pravatar.cc/150?img=28' },
    { id: 'ic4', name: 'Olivia Adams', email: 'oadams@realty.com', phone: '+1 (555) 234-5004', company: 'Adams Realty', role: 'Realtor', category: 'real-estate', source: 'icloud', image: 'https://i.pravatar.cc/150?img=29' },
    { id: 'ic5', name: 'Ethan Nelson', email: 'enelson@sports.com', phone: '+1 (555) 234-5005', company: 'Nelson Sports', role: 'Coach', category: 'sports', source: 'icloud', image: 'https://i.pravatar.cc/150?img=30' },
    { id: 'ic6', name: 'Ava Carter', email: 'acarter@hospital.org', phone: '+1 (555) 234-5006', company: 'Memorial Hospital', role: 'Surgeon', category: 'healthcare', source: 'icloud', image: 'https://i.pravatar.cc/150?img=31' },
    { id: 'ic7', name: 'Noah Mitchell', email: 'nmitchell@finance.com', phone: '+1 (555) 234-5007', company: 'Mitchell Capital', role: 'Analyst', category: 'finance', source: 'icloud', image: 'https://i.pravatar.cc/150?img=32' },
    { id: 'ic8', name: 'Emma Roberts', email: 'eroberts@college.edu', phone: '+1 (555) 234-5008', company: 'Community College', role: 'Dean', category: 'education', source: 'icloud', image: 'https://i.pravatar.cc/150?img=33' },
    { id: 'ic9', name: 'Liam Turner', email: 'lturner@consulting.com', phone: '+1 (555) 234-5009', company: 'Turner Consulting', role: 'Consultant', category: 'services', source: 'icloud', image: 'https://i.pravatar.cc/150?img=34' },
    { id: 'ic10', name: 'Isabella Phillips', email: 'iphillips@auto.com', phone: '+1 (555) 234-5010', company: 'Phillips Automotive', role: 'Owner', category: 'automotive', source: 'icloud', image: 'https://i.pravatar.cc/150?img=35' },
    { id: 'ic11', name: 'Mason Campbell', email: 'mcampbell@email.com', phone: '+1 (555) 234-5011', company: '', role: '', category: 'friends', source: 'icloud', image: 'https://i.pravatar.cc/150?img=36' },
    { id: 'ic12', name: 'Charlotte Parker', email: 'cparker@startup.io', phone: '+1 (555) 234-5012', company: 'Parker Tech', role: 'Product Manager', category: 'technology', source: 'icloud', image: 'https://i.pravatar.cc/150?img=37' },
    { id: 'ic13', name: 'Lucas Evans', email: 'levans@clinic.org', phone: '+1 (555) 234-5013', company: 'Evans Medical', role: 'Dentist', category: 'healthcare', source: 'icloud', image: 'https://i.pravatar.cc/150?img=38' },
    { id: 'ic14', name: 'Amelia Edwards', email: 'aedwards@investment.com', phone: '+1 (555) 234-5014', company: 'Edwards Wealth', role: 'Advisor', category: 'finance', source: 'icloud', image: 'https://i.pravatar.cc/150?img=39' },
    { id: 'ic15', name: 'Jackson Collins', email: 'jcollins@properties.com', phone: '+1 (555) 234-5015', company: 'Collins Estates', role: 'Broker', category: 'real-estate', source: 'icloud', image: 'https://i.pravatar.cc/150?img=40' },
    { id: 'ic16', name: 'Mia Stewart', email: 'mstewart@tech.com', phone: '+1 (555) 234-5016', company: 'Stewart Software', role: 'Developer', category: 'technology', source: 'icloud', image: 'https://i.pravatar.cc/150?img=41' },
    { id: 'ic17', name: 'Benjamin Morris', email: 'bmorris@school.edu', phone: '+1 (555) 234-5017', company: 'Morris Academy', role: 'Teacher', category: 'education', source: 'icloud', image: 'https://i.pravatar.cc/150?img=42' },
    { id: 'ic18', name: 'Harper Rogers', email: 'hrogers@legal.com', phone: '+1 (555) 234-5018', company: 'Rogers & Associates', role: 'Paralegal', category: 'legal', source: 'icloud', image: 'https://i.pravatar.cc/150?img=43' },
    { id: 'ic19', name: 'Henry Reed', email: 'hreed@fitness.com', phone: '+1 (555) 234-5019', company: 'Reed Fitness', role: 'Trainer', category: 'sports', source: 'icloud', image: 'https://i.pravatar.cc/150?img=44' },
    { id: 'ic20', name: 'Evelyn Cook', email: 'ecook@email.com', phone: '+1 (555) 234-5020', company: '', role: '', category: 'family', source: 'icloud', image: 'https://i.pravatar.cc/150?img=45' },
    { id: 'ic21', name: 'Sebastian Morgan', email: 'smorgan@marketing.com', phone: '+1 (555) 234-5021', company: 'Morgan Media', role: 'Strategist', category: 'business', source: 'icloud', image: 'https://i.pravatar.cc/150?img=46' },
    { id: 'ic22', name: 'Abigail Bell', email: 'abell@construction.com', phone: '+1 (555) 234-5022', company: 'Bell Builders', role: 'Architect', category: 'services', source: 'icloud', image: 'https://i.pravatar.cc/150?img=47' },
    { id: 'ic23', name: 'Jack Murphy', email: 'jmurphy@hospital.org', phone: '+1 (555) 234-5023', company: 'St. Mary\'s Hospital', role: 'Cardiologist', category: 'healthcare', source: 'icloud', image: 'https://i.pravatar.cc/150?img=48' },
    { id: 'ic24', name: 'Aria Bailey', email: 'abailey@dealers.com', phone: '+1 (555) 234-5024', company: 'Bailey Auto', role: 'Finance Manager', category: 'automotive', source: 'icloud', image: 'https://i.pravatar.cc/150?img=49' },
    { id: 'ic25', name: 'Logan Rivera', email: 'lrivera@bank.com', phone: '+1 (555) 234-5025', company: 'Rivera Financial', role: 'VP Operations', category: 'finance', source: 'icloud', image: 'https://i.pravatar.cc/150?img=50' }
  ]
};

// Creative Services Mock Data
export const creativeServicesMockData = [
  {
    id: 'cs-1',
    name: 'Professional Video Editing',
    category: 'creative',
    subcategory: 'video',
    base_price: 299,
    pricing_unit: 'per video',
    tagline: 'High-quality video editing with color grading, sound design, and motion graphics',
    timeline: '5-7 days',
    color: 'bg-red-500',
    deliverables: [
      { item: '4K support' },
      { item: 'Color grading' },
      { item: 'Sound mixing' },
      { item: 'Motion graphics' },
      { item: 'Unlimited revisions' }
    ]
  },
  {
    id: 'cs-2',
    name: 'Brand Identity Design',
    category: 'creative',
    subcategory: 'design',
    base_price: 499,
    pricing_unit: 'per brand',
    tagline: 'Complete brand identity package including logo, color palette, and brand guidelines',
    timeline: '7-10 days',
    color: 'bg-purple-500',
    deliverables: [
      { item: 'Logo design' },
      { item: 'Color palette' },
      { item: 'Typography' },
      { item: 'Brand guidelines' },
      { item: 'Social media templates' }
    ]
  },
  {
    id: 'cs-3',
    name: 'Social Media Content Creation',
    category: 'creative',
    subcategory: 'content',
    base_price: 399,
    pricing_unit: 'per month',
    tagline: '30 days of custom social media content for all major platforms',
    timeline: '3-5 days',
    color: 'bg-blue-500',
    deliverables: [
      { item: '30 posts' },
      { item: 'Platform optimization' },
      { item: 'Hashtag research' },
      { item: 'Engagement strategy' },
      { item: 'Analytics' }
    ]
  },
  {
    id: 'cs-4',
    name: 'Professional Photography',
    category: 'creative',
    subcategory: 'photo',
    base_price: 599,
    pricing_unit: 'per session',
    tagline: 'Professional photoshoot with editing and retouching (4 hours)',
    timeline: '1-2 days',
    color: 'bg-green-500',
    deliverables: [
      { item: '4-hour session' },
      { item: 'Professional equipment' },
      { item: 'Photo editing' },
      { item: '50+ edited photos' },
      { item: 'High-res delivery' }
    ]
  },
  {
    id: 'cs-5',
    name: 'Website Design & Development',
    category: 'creative',
    subcategory: 'web',
    base_price: 1299,
    pricing_unit: 'per website',
    tagline: 'Custom website design and development with responsive layout',
    timeline: '14-21 days',
    color: 'bg-indigo-500',
    deliverables: [
      { item: 'Custom design' },
      { item: 'Responsive' },
      { item: 'SEO optimized' },
      { item: 'CMS integration' },
      { item: '3 months support' }
    ]
  },
  {
    id: 'cs-6',
    name: 'Motion Graphics Animation',
    category: 'creative',
    subcategory: 'animation',
    base_price: 799,
    pricing_unit: 'per 30s',
    tagline: '30-second professional motion graphics animation',
    timeline: '10-14 days',
    color: 'bg-pink-500',
    deliverables: [
      { item: '30 seconds' },
      { item: 'Custom animation' },
      { item: 'Sound design' },
      { item: '4K export' },
      { item: '2 revisions' }
    ]
  },
  {
    id: 'cs-7',
    name: 'Podcast Production',
    category: 'creative',
    subcategory: 'audio',
    base_price: 199,
    pricing_unit: 'per episode',
    tagline: 'Professional podcast editing, mixing, and mastering per episode',
    timeline: '2-3 days',
    color: 'bg-yellow-500',
    deliverables: [
      { item: 'Audio editing' },
      { item: 'Noise removal' },
      { item: 'Music & intro' },
      { item: 'Mastering' },
      { item: 'Show notes' }
    ]
  },
  {
    id: 'cs-8',
    name: 'Copywriting Services',
    category: 'creative',
    subcategory: 'writing',
    base_price: 249,
    pricing_unit: 'per project',
    tagline: 'Professional copywriting for websites, ads, and marketing materials',
    timeline: '3-5 days',
    color: 'bg-orange-500',
    deliverables: [
      { item: 'SEO optimized' },
      { item: 'Brand voice' },
      { item: 'Unlimited revisions' },
      { item: 'Fast delivery' },
      { item: 'Keyword research' }
    ]
  }
];

// AI Services Mock Data
export const aiServicesMockData = [
  {
    id: 'ai-1',
    name: 'AI Content Generation',
    category: 'ai',
    subcategory: 'content',
    base_price: 149,
    pricing_unit: 'per article',
    tagline: 'AI-powered content creation for blogs, articles, and social media',
    timeline: 'Instant',
    color: 'bg-blue-500',
    icon: '✍️',
    featured: true,
    deliverables: [
      { item: 'GPT-4 powered generation' },
      { item: 'SEO optimized content' },
      { item: 'Multiple formats supported' },
      { item: 'Fact-checked articles' },
      { item: 'Plagiarism-free guarantee' }
    ]
  },
  {
    id: 'ai-2',
    name: 'AI Image Generation',
    category: 'ai',
    subcategory: 'image',
    base_price: 99,
    pricing_unit: 'per image',
    tagline: 'Create stunning AI-generated images for any purpose',
    timeline: 'Instant',
    color: 'bg-purple-500',
    icon: '🎨',
    featured: true,
    deliverables: [
      { item: 'High resolution outputs' },
      { item: 'Multiple artistic styles' },
      { item: 'Commercial use rights' },
      { item: 'Unlimited edits' },
      { item: 'Fast generation speed' }
    ]
  },
  {
    id: 'ai-3',
    name: 'AI Video Creation',
    category: 'ai',
    subcategory: 'video',
    base_price: 299,
    pricing_unit: 'per video',
    tagline: 'AI-powered video creation with avatars and voiceovers',
    timeline: '1-2 hours',
    color: 'bg-red-500',
    icon: '🎬',
    deliverables: [
      { item: 'Realistic AI avatars' },
      { item: 'Voice cloning technology' },
      { item: 'Multiple languages' },
      { item: '4K export quality' },
      { item: 'Script writing assistance' }
    ]
  },
  {
    id: 'ai-4',
    name: 'AI Voice Over',
    category: 'ai',
    subcategory: 'audio',
    base_price: 79,
    pricing_unit: 'per minute',
    tagline: 'Professional AI voiceover in multiple languages and accents',
    timeline: 'Instant',
    color: 'bg-green-500',
    icon: '🎙️',
    featured: true,
    deliverables: [
      { item: '50+ voice options' },
      { item: '30+ languages' },
      { item: 'Emotion control' },
      { item: 'Studio quality audio' },
      { item: 'Fast delivery' }
    ]
  },
  {
    id: 'ai-5',
    name: 'AI Chatbot Development',
    category: 'ai',
    subcategory: 'development',
    base_price: 799,
    pricing_unit: 'per chatbot',
    tagline: 'Custom AI chatbot for customer service and engagement',
    timeline: '7-10 days',
    color: 'bg-indigo-500',
    icon: '💬',
    deliverables: [
      { item: 'GPT-4 powered conversations' },
      { item: 'Custom training on your data' },
      { item: 'Multi-platform integration' },
      { item: 'Analytics dashboard' },
      { item: '24/7 technical support' }
    ]
  },
  {
    id: 'ai-6',
    name: 'AI Data Analysis',
    category: 'ai',
    subcategory: 'analytics',
    base_price: 499,
    pricing_unit: 'per project',
    tagline: 'Advanced AI-powered data analysis and insights generation',
    timeline: '3-5 days',
    color: 'bg-yellow-500',
    icon: '📊',
    deliverables: [
      { item: 'Predictive analytics' },
      { item: 'Data visualization' },
      { item: 'Custom reports' },
      { item: 'ML model development' },
      { item: 'API access' }
    ]
  },
  {
    id: 'ai-7',
    name: 'AI SEO Optimization',
    category: 'ai',
    subcategory: 'seo',
    base_price: 349,
    pricing_unit: 'per site',
    tagline: 'AI-driven SEO strategy and content optimization',
    timeline: '5-7 days',
    color: 'bg-teal-500',
    icon: '🔍',
    deliverables: [
      { item: 'Keyword research & analysis' },
      { item: 'Competitor analysis' },
      { item: 'Content strategy planning' },
      { item: 'Link building support' },
      { item: 'Performance tracking' }
    ]
  },
  {
    id: 'ai-8',
    name: 'AI Translation Services',
    category: 'ai',
    subcategory: 'translation',
    base_price: 129,
    pricing_unit: 'per document',
    tagline: 'Professional AI translation with human review',
    timeline: '1-2 days',
    color: 'bg-pink-500',
    icon: '🌍',
    featured: true,
    deliverables: [
      { item: '100+ languages supported' },
      { item: 'Context-aware translations' },
      { item: 'Industry-specific terminology' },
      { item: 'Human review included' },
      { item: 'Fast turnaround time' }
    ]
  },
  {
    id: 'ai-9',
    name: 'AI Design Assistant',
    category: 'ai',
    subcategory: 'design',
    base_price: 199,
    pricing_unit: 'per project',
    tagline: 'AI-powered design suggestions and automated design generation',
    timeline: 'Instant',
    color: 'bg-orange-500',
    icon: '🎯',
    deliverables: [
      { item: 'Design templates library' },
      { item: 'Brand consistency checks' },
      { item: 'Auto-layout generation' },
      { item: 'Color palette suggestions' },
      { item: 'Multiple export formats' }
    ]
  },
  {
    id: 'ai-10',
    name: 'AI Email Marketing',
    category: 'ai',
    subcategory: 'marketing',
    base_price: 249,
    pricing_unit: 'per campaign',
    tagline: 'AI-optimized email campaigns with predictive analytics',
    timeline: '3-4 days',
    color: 'bg-cyan-500',
    icon: '📧',
    deliverables: [
      { item: 'Smart audience segmentation' },
      { item: 'A/B testing automation' },
      { item: 'Personalization engine' },
      { item: 'Predictive send times' },
      { item: 'Detailed analytics' }
    ]
  }
];

// Calendar Events Mock Data for Dashboard
export const calendarEventsMockData = (() => {
  const events = [];
  const today = new Date();
  const currentMonth = today.getMonth();
  const currentYear = today.getFullYear();
  
  // Helper to create date string properly
  const getDateString = (year, month, day) => {
    const date = new Date(year, month, day);
    return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD
  };
  
  // Add events to various days in current month (not just from today forward)
  // This ensures visibility across the month
  
  // Early December events
  events.push(
    { id: 'cal-early-1', date: getDateString(currentYear, currentMonth, 3), title: 'Sprint Planning', type: 'meeting', color: 'bg-blue-400' },
    { id: 'cal-early-2', date: getDateString(currentYear, currentMonth, 3), title: 'Design Review', type: 'meeting', color: 'bg-purple-400' },
    { id: 'cal-early-3', date: getDateString(currentYear, currentMonth, 5), title: 'Client Presentation', type: 'meeting', color: 'bg-green-400' },
    { id: 'cal-early-4', date: getDateString(currentYear, currentMonth, 7), title: 'Team Workshop', type: 'event', color: 'bg-yellow-400' },
    { id: 'cal-early-5', date: getDateString(currentYear, currentMonth, 10), title: 'Product Demo', type: 'event', color: 'bg-cyan-400' },
    { id: 'cal-early-6', date: getDateString(currentYear, currentMonth, 10), title: 'Sales Meeting', type: 'meeting', color: 'bg-orange-400' },
    { id: 'cal-early-7', date: getDateString(currentYear, currentMonth, 12), title: 'Budget Review', type: 'meeting', color: 'bg-red-400' },
    { id: 'cal-early-8', date: getDateString(currentYear, currentMonth, 15), title: 'All Hands', type: 'meeting', color: 'bg-indigo-400' },
    { id: 'cal-early-9', date: getDateString(currentYear, currentMonth, 15), title: 'Training Session', type: 'event', color: 'bg-pink-400' },
    { id: 'cal-early-10', date: getDateString(currentYear, currentMonth, 18), title: 'Strategy Planning', type: 'meeting', color: 'bg-teal-400' },
    { id: 'cal-early-11', date: getDateString(currentYear, currentMonth, 20), title: 'Tech Talk', type: 'event', color: 'bg-purple-400' },
    { id: 'cal-early-12', date: getDateString(currentYear, currentMonth, 22), title: 'Performance Review', type: 'meeting', color: 'bg-blue-400' },
    { id: 'cal-early-13', date: getDateString(currentYear, currentMonth, 24), title: 'Holiday Party', type: 'event', color: 'bg-yellow-400' },
    { id: 'cal-early-14', date: getDateString(currentYear, currentMonth, 27), title: 'Year-End Review', type: 'meeting', color: 'bg-green-400' }
  );
  
  // Helper for days from today
  const getDateStringFromToday = (daysOffset) => {
    const date = new Date(today);
    date.setDate(date.getDate() + daysOffset);
    return date.toISOString().split('T')[0];
  };
  
  // Today's events
  events.push(
    { id: 'cal-1', date: getDateStringFromToday(0), title: 'Team Standup', type: 'meeting', color: 'bg-blue-400' },
    { id: 'cal-2', date: getDateStringFromToday(0), title: 'Client Call', type: 'meeting', color: 'bg-green-400' },
    { id: 'cal-3', date: getDateStringFromToday(0), title: 'Design Review', type: 'meeting', color: 'bg-purple-400' },
    { id: 'cal-4', date: getDateStringFromToday(0), title: 'Lunch with Marketing', type: 'event', color: 'bg-yellow-400' }
  );
  
  // Future events
  events.push(
    { id: 'cal-5', date: getDateStringFromToday(1), title: 'Project Review', type: 'meeting', color: 'bg-purple-400' },
    { id: 'cal-6', date: getDateStringFromToday(1), title: 'Budget Planning', type: 'meeting', color: 'bg-red-400' },
    { id: 'cal-7', date: getDateStringFromToday(1), title: 'Product Demo', type: 'event', color: 'bg-cyan-400' },
    { id: 'cal-8', date: getDateStringFromToday(2), title: 'Design Workshop', type: 'event', color: 'bg-pink-400' },
    { id: 'cal-9', date: getDateStringFromToday(2), title: 'Sprint Retrospective', type: 'meeting', color: 'bg-blue-400' },
    { id: 'cal-10', date: getDateStringFromToday(2), title: 'Security Audit', type: 'meeting', color: 'bg-red-400' },
    { id: 'cal-11', date: getDateStringFromToday(3), title: 'Product Launch', type: 'event', color: 'bg-orange-400' },
    { id: 'cal-12', date: getDateStringFromToday(3), title: 'Investor Meeting', type: 'meeting', color: 'bg-green-400' },
    { id: 'cal-13', date: getDateStringFromToday(3), title: 'Team Lunch', type: 'event', color: 'bg-yellow-400' },
    { id: 'cal-14', date: getDateStringFromToday(4), title: 'HR Interview', type: 'meeting', color: 'bg-purple-400' },
    { id: 'cal-15', date: getDateStringFromToday(4), title: 'Code Review Session', type: 'meeting', color: 'bg-blue-400' },
    { id: 'cal-16', date: getDateStringFromToday(5), title: 'Quarterly Planning', type: 'meeting', color: 'bg-indigo-400' },
    { id: 'cal-17', date: getDateStringFromToday(5), title: 'UX Workshop', type: 'event', color: 'bg-pink-400' },
    { id: 'cal-18', date: getDateStringFromToday(5), title: 'Sales Presentation', type: 'meeting', color: 'bg-green-400' },
    { id: 'cal-19', date: getDateStringFromToday(6), title: 'Customer Feedback Review', type: 'meeting', color: 'bg-cyan-400' },
    { id: 'cal-20', date: getDateStringFromToday(6), title: 'Tech Talk', type: 'event', color: 'bg-purple-400' },
    { id: 'cal-21', date: getDateStringFromToday(7), title: 'Training Session', type: 'event', color: 'bg-yellow-400' },
    { id: 'cal-22', date: getDateStringFromToday(7), title: 'All Hands Meeting', type: 'meeting', color: 'bg-blue-400' },
    { id: 'cal-23', date: getDateStringFromToday(7), title: 'Marketing Strategy', type: 'meeting', color: 'bg-orange-400' },
    { id: 'cal-24', date: getDateStringFromToday(8), title: 'Client Workshop', type: 'event', color: 'bg-green-400' },
    { id: 'cal-25', date: getDateStringFromToday(8), title: 'Engineering Sync', type: 'meeting', color: 'bg-blue-400' },
    { id: 'cal-26', date: getDateStringFromToday(10), title: 'Team Building', type: 'event', color: 'bg-teal-400' },
    { id: 'cal-27', date: getDateStringFromToday(10), title: 'Performance Review', type: 'meeting', color: 'bg-purple-400' },
    { id: 'cal-28', date: getDateStringFromToday(10), title: 'Product Roadmap', type: 'meeting', color: 'bg-indigo-400' }
  );
  
  return events;
})();

// Tasks Today Mock Data for Dashboard
export const tasksTodayMockData = [
  // High Priority Tasks
  {
    id: 'task-1',
    title: 'Review project proposal for Q1 2026',
    status: 'pending',
    priority: 'high',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  {
    id: 'task-2',
    title: 'Update client presentation slides',
    status: 'pending',
    priority: 'high',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  {
    id: 'task-3',
    title: 'Code review for authentication module',
    status: 'pending',
    priority: 'high',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  {
    id: 'task-4',
    title: 'Fix critical bug in payment gateway',
    status: 'pending',
    priority: 'high',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  {
    id: 'task-5',
    title: 'Approve marketing campaign budget',
    status: 'pending',
    priority: 'high',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  // Medium Priority Tasks
  {
    id: 'task-6',
    title: 'Respond to stakeholder emails',
    status: 'pending',
    priority: 'medium',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  {
    id: 'task-7',
    title: 'Update project documentation',
    status: 'pending',
    priority: 'medium',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  {
    id: 'task-8',
    title: 'Review design mockups for new feature',
    status: 'pending',
    priority: 'medium',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  {
    id: 'task-9',
    title: 'Schedule interviews for open positions',
    status: 'pending',
    priority: 'medium',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  {
    id: 'task-10',
    title: 'Test new analytics dashboard',
    status: 'pending',
    priority: 'medium',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  {
    id: 'task-11',
    title: 'Review and merge pull requests',
    status: 'pending',
    priority: 'medium',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  {
    id: 'task-12',
    title: 'Update API documentation',
    status: 'pending',
    priority: 'medium',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  {
    id: 'task-13',
    title: 'Optimize database queries',
    status: 'pending',
    priority: 'medium',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  // Low Priority Tasks
  {
    id: 'task-14',
    title: 'Prepare sprint planning notes',
    status: 'pending',
    priority: 'low',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  {
    id: 'task-15',
    title: 'Organize shared drive files',
    status: 'pending',
    priority: 'low',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  {
    id: 'task-16',
    title: 'Clean up old branches in Git',
    status: 'pending',
    priority: 'low',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  {
    id: 'task-17',
    title: 'Update team wiki',
    status: 'pending',
    priority: 'low',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  {
    id: 'task-18',
    title: 'Review office supply inventory',
    status: 'pending',
    priority: 'low',
    due_date: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
    type: 'task'
  },
  // Meetings Today
  {
    id: 'meeting-today-1',
    title: 'Morning Team Standup',
    status: 'Pending',
    priority: 'High',
    type: 'meeting',
    startTime: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}T09:00:00`
  },
  {
    id: 'meeting-today-2',
    title: 'Client Strategy Call - Acme Corp',
    status: 'Pending',
    priority: 'High',
    type: 'meeting',
    startTime: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}T10:30:00`
  },
  {
    id: 'meeting-today-3',
    title: 'Design Review Session',
    status: 'Pending',
    priority: 'High',
    type: 'meeting',
    startTime: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}T11:30:00`
  },
  {
    id: 'meeting-today-4',
    title: 'Lunch & Learn: AI Integration',
    status: 'Pending',
    priority: 'Medium',
    type: 'meeting',
    startTime: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}T12:00:00`
  },
  {
    id: 'meeting-today-5',
    title: 'Product Roadmap Discussion',
    status: 'Pending',
    priority: 'High',
    type: 'meeting',
    startTime: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}T14:00:00`
  },
  {
    id: 'meeting-today-6',
    title: 'Engineering Team Sync',
    status: 'Pending',
    priority: 'High',
    type: 'meeting',
    startTime: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}T15:00:00`
  },
  {
    id: 'meeting-today-7',
    title: 'HR Check-in',
    status: 'Pending',
    priority: 'Medium',
    type: 'meeting',
    startTime: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}T16:00:00`
  },
  {
    id: 'meeting-today-8',
    title: 'End of Day Wrap-up',
    status: 'Pending',
    priority: 'Medium',
    type: 'meeting',
    startTime: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}T17:00:00`
  },
  // Reminders
  {
    id: 'reminder-1',
    title: 'Submit expense report by EOD',
    status: 'Pending',
    priority: 'High',
    type: 'reminder',
    dueDate: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`
  },
  {
    id: 'reminder-2',
    title: 'Order office supplies',
    status: 'Pending',
    priority: 'Medium',
    type: 'reminder',
    dueDate: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`
  },
  {
    id: 'reminder-3',
    title: 'Renew software licenses',
    status: 'Pending',
    priority: 'High',
    type: 'reminder',
    dueDate: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`
  },
  {
    id: 'reminder-4',
    title: 'Book travel for next conference',
    status: 'Pending',
    priority: 'Medium',
    type: 'reminder',
    dueDate: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`
  },
  {
    id: 'reminder-5',
    title: 'Send birthday card to team member',
    status: 'Pending',
    priority: 'Low',
    type: 'reminder',
    dueDate: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`
  },
  {
    id: 'reminder-6',
    title: 'Schedule dental appointment',
    status: 'Pending',
    priority: 'Low',
    type: 'reminder',
    dueDate: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`
  },
  {
    id: 'reminder-7',
    title: 'Update emergency contact info',
    status: 'Pending',
    priority: 'Medium',
    type: 'reminder',
    dueDate: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`
  },
  {
    id: 'reminder-8',
    title: 'Review insurance coverage',
    status: 'Pending',
    priority: 'Medium',
    type: 'reminder',
    dueDate: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`
  },
  {
    id: 'reminder-9',
    title: 'Reply to pending LinkedIn messages',
    status: 'Pending',
    priority: 'Low',
    type: 'reminder',
    dueDate: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`
  },
  {
    id: 'reminder-10',
    title: 'Backup important files to cloud',
    status: 'Pending',
    priority: 'Medium',
    type: 'reminder',
    dueDate: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`
  }
];

// Real Estate Managing Partner Meetings Mock Data
export const realEstateMeetingsMockData = [
  // Past Meetings
  {
    id: 'stm-1',
    title: 'Player Contract Extension Negotiations - Marcus Johnson',
    date: '2025-12-18',
    time: '09:00',
    duration: 120,
    meeting_link: 'https://zoom.us/j/sportsteam001',
    location: '',
    meeting_type: 'virtual',
    category: 'Client Calls',
    agenda: '1. Contract terms review\n2. Salary cap implications\n3. Performance incentives\n4. Multi-year commitment\n5. Agent negotiations',
    notes: 'Marcus committed to 5-year extension. Agreed on $185M deal with performance bonuses. Strong commitment to team and city. Agent satisfied with terms.',
    transcript: 'Agent: Marcus is excited about long-term commitment. Team Owner: We believe Marcus is our championship foundation. Marcus: Ready to bring a title to this city.',
    transcription_id: '',
    participants: [
      {
        name: 'Marcus Johnson',
        email: 'marcus@player.com',
        company: 'Sports Team',
        role: 'Star Player',
        phone: '+1 (555) 123-0101',
        image_url: 'https://i.pravatar.cc/150?img=12'
      },
      {
        name: 'Michael Rosenberg',
        email: 'mrosenberg@sportagency.com',
        company: 'Elite Sports Agency',
        role: 'Player Agent',
        phone: '+1 (555) 123-0102',
        image_url: 'https://i.pravatar.cc/150?img=11'
      }
    ]
  },
  {
    id: 'stm-2',
    title: 'Q4 Team Performance & Financial Review',
    date: '2025-12-20',
    time: '14:00',
    duration: 90,
    meeting_link: '',
    location: 'Team Stadium - Executive Boardroom',
    meeting_type: 'in-person',
    category: 'Personal',
    agenda: '1. Win-loss record analysis\n2. Player performance metrics\n3. Revenue & ticket sales\n4. Playoff positioning\n5. Q1 2026 strategy',
    notes: 'Team record 28-12, 2nd in conference. Revenue up 22% YoY. Ticket sales at 96% capacity. Playoff berth secured. Focus on home court advantage.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Team Executive Meeting',
        email: 'exec@team.com',
        company: 'Sports Team',
        role: 'Executive Team',
        phone: '+1 (555) 123-0100',
        image_url: 'https://i.pravatar.cc/150?img=33'
      }
    ]
  },
  {
    id: 'stm-3',
    title: 'Nike Jersey Sponsorship Deal Finalization',
    date: '2025-12-22',
    time: '10:30',
    duration: 60,
    meeting_link: 'https://meet.google.com/nike-partnership',
    location: '',
    meeting_type: 'virtual',
    category: 'Client Calls',
    agenda: '1. Final contract terms\n2. Jersey design approval\n3. Marketing activation plan\n4. Revenue sharing model\n5. Multi-year agreement',
    notes: '$8M per year, 5-year deal. Jersey reveal at season opener. Co-branded marketing campaigns. Player appearance commitments. Strong brand alignment.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Jessica Park',
        email: 'jpark@nike.com',
        company: 'Nike Sportswear',
        role: 'Partnership Director',
        phone: '+1 (555) 234-0201',
        image_url: 'https://i.pravatar.cc/150?img=14'
      },
      {
        name: 'David Chen',
        email: 'dchen@nike.com',
        company: 'Nike Sportswear',
        role: 'VP of Sports Marketing',
        phone: '+1 (555) 234-0202',
        image_url: 'https://i.pravatar.cc/150?img=27'
      }
    ]
  },
  {
    id: 'stm-4',
    title: 'Coaching Staff Strategy Session - Playoff Preparation',
    date: '2026-01-13',
    time: '14:00',
    duration: 90,
    meeting_link: '',
    location: 'Team Training Facility - Film Room',
    meeting_type: 'in-person',
    category: 'Client Calls',
    agenda: '1. Playoff bracket analysis\n2. Opponent scouting reports\n3. Roster optimization strategy\n4. Practice intensity planning\n5. Player health management',
    notes: 'Focus on defensive improvements. Marcus Johnson leading playoff charge. Tyler Williams back from injury. Home court advantage critical.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Coach Mike Stevens',
        email: 'mstevens@team.com',
        company: 'Sports Team',
        role: 'Head Coach',
        phone: '+1 (555) 789-0123',
        image_url: 'https://i.pravatar.cc/150?img=14'
      }
    ]
  },
  {
    id: 'stm-5',
    title: 'Scouting Department - Draft Preparation',
    date: '2026-01-14',
    time: '17:00',
    duration: 45,
    meeting_link: '',
    location: 'Team Headquarters - Scouting Room',
    meeting_type: 'in-person',
    category: 'Personal',
    agenda: '1. Top draft prospects review\n2. College player evaluations\n3. International talent pipeline\n4. Trade scenario planning\n5. Team needs assessment',
    notes: 'Strong draft class this year. Three top prospects identified. Tom Reynolds recommends targeting shooting guard. Trade possibilities discussed.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Tom Reynolds',
        email: 'treynolds@team.com',
        company: 'Sports Team',
        role: 'Chief Scout',
        phone: '+1 (555) 123-4567',
        image_url: 'https://i.pravatar.cc/150?img=8'
      }
    ]
  },
  {
    id: 'stm-6',
    title: 'Broadcasting Partnership Review',
    date: '2026-01-15',
    time: '18:30',
    duration: 90,
    meeting_link: 'https://zoom.us/j/broadcasting-meeting',
    location: '',
    meeting_type: 'virtual',
    category: 'Client Calls',
    agenda: '1. Regional broadcast performance\n2. Viewership analytics review\n3. Digital streaming expansion\n4. Contract extension terms\n5. International broadcast rights',
    notes: 'Viewership up 18% this season. Digital streaming performing well. $142.5M multi-year extension under discussion. International markets showing interest.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'David Park',
        email: 'dpark@broadcaster.com',
        company: 'Regional Sports Network',
        role: 'VP of Sports',
        phone: '+1 (555) 678-9012',
        image_url: 'https://i.pravatar.cc/150?img=52'
      },
      {
        name: 'Rachel Kim',
        email: 'rkim@broadcaster.com',
        company: 'Regional Sports Network',
        role: 'Contract Manager',
        phone: '+1 (555) 345-6791',
        image_url: 'https://i.pravatar.cc/150?img=19'
      }
    ]
  },
  {
    id: 'stm-7',
    title: 'Board of Directors - Quarterly Review',
    date: '2026-01-17',
    time: '15:30',
    duration: 30,
    meeting_link: '',
    location: 'Team Stadium - Executive Boardroom',
    meeting_type: 'in-person',
    category: 'Personal',
    agenda: '1. Q4 financial performance\n2. Win-loss record review\n3. Attendance and revenue metrics\n4. Major investments approval\n5. Strategic initiatives for 2026',
    notes: 'Strong financial quarter. Team playoff-bound. Attendance at 96% capacity. $15M facility upgrade approved. Ownership pleased with progress.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Board Member',
        email: 'board@team.com',
        company: 'Sports Team',
        role: 'Board Member',
        phone: '+1 (555) 456-7890',
        image_url: 'https://i.pravatar.cc/150?img=47'
      }
    ]
  },
  {
    id: 'stm-8',
    title: 'Merchandise & Licensing Strategy Meeting',
    date: '2026-01-18',
    time: '16:00',
    duration: 45,
    meeting_link: '',
    location: 'Team Headquarters - Marketing Department',
    meeting_type: 'in-person',
    category: 'Client Calls',
    agenda: '1. New jersey design reveal\n2. Merchandise sales forecast\n3. International licensing expansion\n4. E-commerce platform upgrade\n5. Fan engagement initiatives',
    notes: 'New jersey designs approved! Sales projections strong. International market expansion in Asia. Online store upgrade launching next month.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Sarah Martinez',
        email: 'smartinez@team.com',
        company: 'Sports Team',
        role: 'Marketing Director',
        phone: '+1 (555) 234-5679',
        image_url: 'https://i.pravatar.cc/150?img=59'
      }
    ]
  },
  // Upcoming Meetings
  {
    id: 'stm-9',
    title: 'Training Facility Upgrade Project Kickoff',
    date: '2026-01-05',
    time: '09:00',
    duration: 120,
    meeting_link: '',
    location: 'Team Training Facility - Main Building',
    meeting_type: 'in-person',
    category: 'Personal',
    agenda: '1. Renovation timeline overview\n2. Architect presentation for new facilities\n3. Construction schedule coordination\n4. Budget allocation ($15M)\n5. Equipment upgrade plans\n6. Player amenities enhancement',
    notes: '',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Benjamin Scott',
        email: 'bscott@moderndesign.com',
        company: 'Modern Design Associates',
        role: 'Lead Architect',
        phone: '+1 (212) 555-0601',
        image_url: 'https://i.pravatar.cc/150?img=60'
      },
      {
        name: 'Christopher Hayes',
        email: 'chayes@buildconstruction.com',
        company: 'Hayes Construction Corp',
        role: 'Project Director',
        phone: '+1 (212) 555-0401',
        image_url: 'https://i.pravatar.cc/150?img=52'
      }
    ]
  },
  {
    id: 'stm-10',
    title: 'Monthly Management Meeting',
    date: '2026-01-06',
    time: '13:00',
    duration: 90,
    meeting_link: 'https://zoom.us/j/monthlymanagement',
    location: '',
    meeting_type: 'virtual',
    category: 'Personal',
    agenda: '1. Team performance updates\n2. Player development pipeline\n3. Sponsorship deal progress\n4. Staffing and recruitment updates\n5. Strategic initiatives for Q1',
    notes: '',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'William Foster',
        email: 'wfoster@team.com',
        company: 'Morrison Real Estate Group',
        role: 'Senior Partner',
        phone: '+1 (212) 555-0301',
        image_url: 'https://i.pravatar.cc/150?img=8'
      },
      {
        name: 'Victoria Kim',
        email: 'vkim@team.com',
        company: 'Morrison Real Estate Group',
        role: 'Partner',
        phone: '+1 (212) 555-0302',
        image_url: 'https://i.pravatar.cc/150?img=47'
      }
    ]
  },
  {
    id: 'stm-11',
    title: 'Sponsorship Committee - New Partnership Opportunities',
    date: '2026-01-08',
    time: '10:00',
    duration: 60,
    meeting_link: 'https://zoom.us/j/sponsorshipcom',
    location: '',
    meeting_type: 'virtual',
    category: 'Client Calls',
    agenda: '1. Corporate sponsor pipeline review\n2. Revenue projections for new deals\n3. Comparable sponsorship analysis\n4. Activation strategy options\n5. Partnership approval vote',
    notes: '',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Thomas Bennett',
        email: 'tbennett@team.com',
        company: 'Sports Team',
        role: 'Sponsorship Director',
        phone: '+1 (212) 555-0303',
        image_url: 'https://i.pravatar.cc/150?img=68'
      },
      {
        name: 'Amanda Rivera',
        email: 'arivera@team.com',
        company: 'Sports Team',
        role: 'Partnership Analyst',
        phone: '+1 (212) 555-0304',
        image_url: 'https://i.pravatar.cc/150?img=21'
      }
    ]
  },
  {
    id: 'stm-12',
    title: 'Fan Engagement Strategy - Digital Platform Launch',
    date: '2026-01-09',
    time: '15:00',
    duration: 60,
    meeting_link: 'https://teams.microsoft.com/l/marketing-meeting',
    location: '',
    meeting_type: 'virtual',
    category: 'Personal',
    agenda: '1. Fan demographic analysis\n2. Competitive positioning review\n3. Social media campaign strategy\n4. Game day experience enhancement\n5. Mobile app feature roadmap',
    notes: '',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Melissa Butler',
        email: 'mbutler@marketing.com',
        company: 'Real Estate Marketing Pro',
        role: 'Marketing Director',
        phone: '+1 (212) 555-0802',
        image_url: 'https://i.pravatar.cc/150?img=17'
      },
      {
        name: 'Natalie Ross',
        email: 'nross@realestate.com',
        company: 'Morrison Real Estate Group',
        role: 'Sales Director',
        phone: '+1 (212) 555-0904',
        image_url: 'https://i.pravatar.cc/150?img=16'
      }
    ]
  },
  {
    id: 'rem-8',
    title: 'Legal Review - Zoning Variance Application',
    date: '2026-01-10',
    time: '11:00',
    duration: 90,
    meeting_link: '',
    location: 'Law Office - 450 Lexington Ave',
    meeting_type: 'in-person',
    category: 'Legal',
    agenda: '1. Zoning code analysis\n2. Variance application requirements\n3. Community board presentation strategy\n4. Timeline and milestones\n5. Contingency planning',
    notes: '',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Richard Morgan',
        email: 'rmorgan@propertylaw.com',
        company: 'Morgan Property Law',
        role: 'Senior Partner',
        phone: '+1 (212) 555-0501',
        image_url: 'https://i.pravatar.cc/150?img=70'
      },
      {
        name: 'Jessica Coleman',
        email: 'jcoleman@realestate.com',
        company: 'Morrison Real Estate Group',
        role: 'General Counsel',
        phone: '+1 (212) 555-0502',
        image_url: 'https://i.pravatar.cc/150?img=3'
      }
    ]
  }
];

// Parent Role Meetings Mock Data for Personal 2
export const parentMeetingsMockData = [
  {
    id: 'pm-1',
    title: 'Parent-Teacher Conference - Emma',
    date: '2026-01-03',
    time: '15:00',
    duration: 30,
    meeting_link: '',
    location: 'Riverside Elementary, Room 204',
    meeting_type: 'in-person',
    category: 'School',
    agenda: '1. Review Emma\'s progress this semester\n2. Discuss math test scores\n3. Upcoming science fair project\n4. Social development',
    notes: 'Emma is excelling in math! Ms. Johnson recommends advanced reading materials. Need to help with science fair project planning.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Ms. Jennifer Johnson',
        email: 'jjohnson@school.edu',
        company: 'Riverside Elementary',
        role: 'Teacher - 3rd Grade',
        phone: '+1 (555) 234-5678',
        image_url: 'https://i.pravatar.cc/150?img=1'
      }
    ]
  },
  {
    id: 'pm-2',
    title: 'Dentist Appointment - Both Kids',
    date: '2026-01-06',
    time: '14:00',
    duration: 60,
    meeting_link: '',
    location: 'Bright Smiles Pediatric Dentistry',
    meeting_type: 'in-person',
    category: 'Healthcare',
    agenda: '1. Routine cleaning for Emma\n2. Routine cleaning for Liam\n3. Check for cavities\n4. Fluoride treatment',
    notes: 'Both kids did great! No cavities. Dr. Park recommends Emma start flossing more regularly.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Dr. David Park',
        email: 'dpark@brightsmiles.com',
        company: 'Bright Smiles Pediatric Dentistry',
        role: 'Pediatric Dentist',
        phone: '+1 (555) 456-7890',
        image_url: 'https://i.pravatar.cc/150?img=12'
      }
    ]
  },
  {
    id: 'pm-3',
    title: 'Piano Teacher Meeting - Emma Progress',
    date: '2026-01-09',
    time: '16:30',
    duration: 15,
    meeting_link: '',
    location: 'Stevens Piano Academy',
    meeting_type: 'in-person',
    category: 'Activities',
    agenda: '1. Discuss Emma\'s progress\n2. Recital preparation\n3. Practice schedule recommendations',
    notes: 'Emma is doing wonderfully! Recital piece is coming along nicely. Recommend 20 min practice daily.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Ms. Sarah Stevens',
        email: 'sarah@stevenspiano.com',
        company: 'Stevens Piano Academy',
        role: 'Piano Instructor',
        phone: '+1 (555) 789-0123',
        image_url: 'https://i.pravatar.cc/150?img=5'
      }
    ]
  },
  {
    id: 'pm-4',
    title: 'Pediatrician Checkup - Emma',
    date: '2026-01-13',
    time: '14:00',
    duration: 45,
    meeting_link: '',
    location: 'Children\'s Pediatric Care',
    meeting_type: 'in-person',
    category: 'Healthcare',
    agenda: '1. Annual physical examination\n2. Growth and development check\n3. Vaccination review\n4. Health questions',
    notes: 'Emma is healthy and growing well! All vaccinations up to date. No concerns.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Dr. Lisa Miller',
        email: 'lmiller@pediatriccare.com',
        company: 'Children\'s Pediatric Care',
        role: 'Pediatrician',
        phone: '+1 (555) 567-8901',
        image_url: 'https://i.pravatar.cc/150?img=10'
      }
    ]
  },
  {
    id: 'pm-5',
    title: 'PTA Meeting',
    date: '2026-01-15',
    time: '18:30',
    duration: 120,
    meeting_link: 'https://zoom.us/j/school-pta-001',
    location: '',
    meeting_type: 'virtual',
    category: 'School',
    agenda: '1. Spring fundraiser planning\n2. Upcoming school events\n3. Budget review\n4. Volunteer opportunities\n5. Questions and concerns',
    notes: 'Spring fundraiser will be a bake sale. Volunteered to help coordinate. School carnival planned for March.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Lisa Chen',
        email: 'lchen@parentgroup.org',
        company: 'School PTA',
        role: 'PTA President',
        phone: '+1 (555) 678-9012',
        image_url: 'https://i.pravatar.cc/150?img=47'
      }
    ]
  },
  {
    id: 'pm-6',
    title: 'Soccer Coach Meeting - Liam\'s Team',
    date: '2026-01-18',
    time: '17:00',
    duration: 30,
    meeting_link: '',
    location: 'Community Sports Field',
    meeting_type: 'in-person',
    category: 'Activities',
    agenda: '1. Team performance review\n2. Championship game preparation\n3. Practice schedule\n4. Team spirit activities',
    notes: 'Team is doing great this season! Championship game next month. Need to bring snacks for Feb 2nd game.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Coach Mike Rodriguez',
        email: 'mike@youthsoccer.com',
        company: 'Youth Soccer League',
        role: 'Head Coach',
        phone: '+1 (555) 890-1234',
        image_url: 'https://i.pravatar.cc/150?img=13'
      }
    ]
  },
  {
    id: 'pm-7',
    title: 'Summer Camp Information Session',
    date: '2026-01-22',
    time: '19:00',
    duration: 60,
    meeting_link: 'https://zoom.us/j/summercamp2026',
    location: '',
    meeting_type: 'virtual',
    category: 'Activities',
    agenda: '1. Camp overview and activities\n2. Schedule and dates\n3. Pricing and registration\n4. Q&A session',
    notes: 'Looks like a great program! Week-long sessions available. Early bird discount ends Feb 1st. Consider signing both kids up.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Amanda Wilson',
        email: 'awilson@adventurecamp.com',
        company: 'Adventure Kids Summer Camp',
        role: 'Camp Director',
        phone: '+1 (555) 901-2345',
        image_url: 'https://i.pravatar.cc/150?img=8'
      }
    ]
  },
  {
    id: 'pm-8',
    title: 'Pediatrician Checkup - Liam',
    date: '2026-01-27',
    time: '10:00',
    duration: 45,
    meeting_link: '',
    location: 'Children\'s Pediatric Care',
    meeting_type: 'in-person',
    category: 'Healthcare',
    agenda: '1. Annual physical examination\n2. Growth chart review\n3. Vaccination updates\n4. Behavioral development assessment',
    notes: 'Liam is healthy and active! Height and weight on track. All vaccinations current.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Dr. Lisa Miller',
        email: 'lmiller@pediatriccare.com',
        company: 'Children\'s Pediatric Care',
        role: 'Pediatrician',
        phone: '+1 (555) 567-8901',
        image_url: 'https://i.pravatar.cc/150?img=10'
      }
    ]
  },
  {
    id: 'pm-9',
    title: 'School Field Trip - Parent Chaperone Meeting',
    date: '2026-02-03',
    time: '17:30',
    duration: 30,
    meeting_link: '',
    location: 'School Cafeteria',
    meeting_type: 'in-person',
    category: 'School',
    agenda: '1. Zoo field trip details\n2. Chaperone responsibilities\n3. Safety guidelines\n4. Schedule and logistics',
    notes: 'Volunteered as chaperone. Trip is Feb 8th. Need to bring bag lunch and water bottle for Emma.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Ms. Jennifer Johnson',
        email: 'jjohnson@school.edu',
        company: 'Riverside Elementary',
        role: 'Teacher - 3rd Grade',
        phone: '+1 (555) 234-5678',
        image_url: 'https://i.pravatar.cc/150?img=1'
      }
    ]
  },
  {
    id: 'pm-10',
    title: 'Family Planning - Spring Break',
    date: '2026-02-10',
    time: '20:00',
    duration: 60,
    meeting_link: '',
    location: 'Home',
    meeting_type: 'in-person',
    category: 'Family',
    agenda: '1. Spring break dates discussion\n2. Vacation options (beach vs mountains)\n3. Budget planning\n4. Activities for kids\n5. Travel logistics',
    notes: 'Kids want to go to the beach! Looking at Florida or California. Need to book flights soon.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Family Discussion',
        email: '',
        company: 'Family',
        role: 'Parents & Kids',
        phone: '',
        image_url: 'https://i.pravatar.cc/150?img=32'
      }
    ]
  },
  {
    id: 'pm-11',
    title: 'Babysitter Interview - Maria',
    date: '2026-02-14',
    time: '15:00',
    duration: 45,
    meeting_link: '',
    location: 'Home',
    meeting_type: 'in-person',
    category: 'Childcare',
    agenda: '1. Experience and background check\n2. Availability and schedule\n3. Rate discussion\n4. Meet the kids\n5. Emergency procedures',
    notes: 'Maria seems great! References checked out. Kids liked her. Availability works for our schedule.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Maria Gonzalez',
        email: 'maria.babysitter@email.com',
        company: 'Independent',
        role: 'Babysitter',
        phone: '+1 (555) 012-3456',
        image_url: 'https://i.pravatar.cc/150?img=20'
      }
    ]
  },
  {
    id: 'pm-12',
    title: 'Birthday Party Planning - Emma\'s 9th',
    date: '2026-02-18',
    time: '19:30',
    duration: 45,
    meeting_link: 'https://zoom.us/j/party-planning',
    location: '',
    meeting_type: 'virtual',
    category: 'Family',
    agenda: '1. Party theme selection\n2. Guest list (20 kids)\n3. Venue options\n4. Entertainment and activities\n5. Cake and food planning',
    notes: 'Emma wants a unicorn theme! Booking bounce house place. March 15th party date.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Party Planner Consultation',
        email: 'events@kidsparty.com',
        company: 'Kids Party Planners',
        role: 'Event Coordinator',
        phone: '+1 (555) 123-4567',
        image_url: 'https://i.pravatar.cc/150?img=25'
      }
    ]
  },
  {
    id: 'pm-13',
    title: 'Teacher Conference - Liam\'s Progress',
    date: '2026-02-25',
    time: '16:00',
    duration: 30,
    meeting_link: '',
    location: 'Riverside Elementary, Room 102',
    meeting_type: 'in-person',
    category: 'School',
    agenda: '1. Reading progress review\n2. Social skills development\n3. Classroom behavior\n4. Areas for improvement',
    notes: 'Liam is doing well in reading! Very social and friendly. Teacher recommends more focus on math practice at home.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Ms. Rachel Thompson',
        email: 'rthompson@school.edu',
        company: 'Riverside Elementary',
        role: 'Teacher - 1st Grade',
        phone: '+1 (555) 456-7890',
        image_url: 'https://i.pravatar.cc/150?img=9'
      }
    ]
  }
];

// Entrepreneur Role Meetings Mock Data for Personal 2 (Small Service Business Owner)
export const entrepreneurMeetingsMockData = [
  {
    id: 'em-1',
    title: 'Client Onboarding - Thompson Manufacturing',
    date: '2026-01-03',
    time: '10:00',
    duration: 60,
    meeting_link: 'https://zoom.us/j/business-meeting-001',
    location: '',
    meeting_type: 'virtual',
    category: 'Client Calls',
    agenda: '1. Business needs assessment\n2. Service package overview\n3. Timeline and deliverables\n4. Pricing discussion\n5. Contract review',
    notes: 'Great first meeting! They need monthly marketing services. Signed 6-month contract starting Feb 1st. $3,500/month retainer.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Jennifer Thompson',
        email: 'jthompson@thompsonmfg.com',
        company: 'Thompson Manufacturing',
        role: 'CEO',
        phone: '+1 (555) 123-4501',
        image_url: 'https://i.pravatar.cc/150?img=5'
      }
    ]
  },
  {
    id: 'em-2',
    title: 'Team Standup - Weekly Sync',
    date: '2026-01-06',
    time: '09:00',
    duration: 30,
    meeting_link: '',
    location: 'Office Conference Room',
    meeting_type: 'in-person',
    category: 'Team',
    agenda: '1. Project updates from each team member\n2. Blockers and challenges\n3. This week\'s priorities\n4. Client deliverables status',
    notes: 'Marketing campaign for ABC Corp on track. Design team needs more time for Peterson project. Sarah handling new client inquiry.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Team Meeting',
        email: '',
        company: 'Internal',
        role: 'Team',
        phone: '',
        image_url: 'https://i.pravatar.cc/150?img=32'
      }
    ]
  },
  {
    id: 'em-3',
    title: 'Vendor Negotiation - Print Services',
    date: '2026-01-08',
    time: '14:00',
    duration: 45,
    meeting_link: '',
    location: 'Vendor Office',
    meeting_type: 'in-person',
    category: 'Vendors',
    agenda: '1. Review current pricing\n2. Volume discount discussion\n3. Quality expectations\n4. Delivery timelines\n5. New contract terms',
    notes: 'Negotiated 15% discount for bulk orders. Improved delivery timeline to 3 days. Great partnership!',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Mike Anderson',
        email: 'mike@qualityprint.com',
        company: 'Quality Print Services',
        role: 'Account Manager',
        phone: '+1 (555) 678-9101',
        image_url: 'https://i.pravatar.cc/150?img=12'
      }
    ]
  },
  {
    id: 'em-4',
    title: 'Business Advisor Check-in',
    date: '2026-01-10',
    time: '11:00',
    duration: 60,
    meeting_link: '',
    location: 'Coffee Shop',
    meeting_type: 'in-person',
    category: 'Advisors',
    agenda: '1. Q4 financial review\n2. Growth strategy for 2026\n3. Hiring plan discussion\n4. Marketing budget allocation\n5. Process improvements',
    notes: 'Revenue up 25% from last year! Advisor recommends hiring another designer. Focus on scaling systems.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Robert Chen',
        email: 'robert@businessadvisors.com',
        company: 'Chen Business Advisors',
        role: 'Business Consultant',
        phone: '+1 (555) 890-1201',
        image_url: 'https://i.pravatar.cc/150?img=33'
      }
    ]
  },
  {
    id: 'em-5',
    title: 'Client Project Review - ABC Corp Campaign',
    date: '2026-01-13',
    time: '15:00',
    duration: 90,
    meeting_link: 'https://zoom.us/j/abc-review',
    location: '',
    meeting_type: 'virtual',
    category: 'Client Calls',
    agenda: '1. Campaign results presentation\n2. ROI analysis\n3. Client feedback\n4. Phase 2 planning\n5. Contract renewal discussion',
    notes: 'Campaign exceeded expectations! 40% increase in leads. Client wants to expand services. Discussing $5K/month retainer.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'David Martinez',
        email: 'david@abccorp.com',
        company: 'ABC Corporation',
        role: 'Marketing Director',
        phone: '+1 (555) 234-5601',
        image_url: 'https://i.pravatar.cc/150?img=13'
      }
    ]
  },
  {
    id: 'em-6',
    title: 'Partnership Discussion - Web Development Agency',
    date: '2026-01-15',
    time: '10:30',
    duration: 60,
    meeting_link: '',
    location: 'Their Office',
    meeting_type: 'in-person',
    category: 'Partners',
    agenda: '1. Service collaboration opportunities\n2. Client referral program\n3. Joint project proposals\n4. Revenue sharing model\n5. Next steps',
    notes: 'Excellent partnership potential! They handle web dev, we do marketing. Agreed on 20% referral fee both ways.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Tom Wilson',
        email: 'tom@webdevpro.com',
        company: 'WebDev Pro',
        role: 'Founder',
        phone: '+1 (555) 345-6701',
        image_url: 'https://i.pravatar.cc/150?img=70'
      }
    ]
  },
  {
    id: 'em-7',
    title: 'Networking Event Follow-up - Chamber of Commerce',
    date: '2026-01-17',
    time: '12:00',
    duration: 45,
    meeting_link: '',
    location: 'Lunch Meeting - Downtown',
    meeting_type: 'in-person',
    category: 'Networking',
    agenda: '1. Introduction and background\n2. Business challenges discussion\n3. Potential collaboration\n4. Referral opportunities',
    notes: 'Met at Chamber event. She owns a local restaurant chain - potential client! Sending proposal next week.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Lisa Rodriguez',
        email: 'lisa@restaurantgroup.com',
        company: 'Rodriguez Restaurant Group',
        role: 'Owner',
        phone: '+1 (555) 456-7801',
        image_url: 'https://i.pravatar.cc/150?img=47'
      }
    ]
  },
  {
    id: 'em-8',
    title: 'Accountant Meeting - Tax Planning',
    date: '2026-01-20',
    time: '14:00',
    duration: 60,
    meeting_link: '',
    location: 'Accountant Office',
    meeting_type: 'in-person',
    category: 'Financial',
    agenda: '1. Q1 tax estimates\n2. Expense optimization\n3. Business structure review\n4. Retirement planning\n5. Financial goals 2026',
    notes: 'Quarterly tax payment due March 15th. Consider S-Corp election. Increase retirement contributions.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Rachel Kim',
        email: 'rachel@kimcpa.com',
        company: 'Kim & Associates CPA',
        role: 'CPA',
        phone: '+1 (555) 567-8901',
        image_url: 'https://i.pravatar.cc/150?img=9'
      }
    ]
  },
  {
    id: 'em-9',
    title: 'Team Member Interview - Designer Position',
    date: '2026-01-22',
    time: '11:00',
    duration: 60,
    meeting_link: 'https://zoom.us/j/interview-001',
    location: '',
    meeting_type: 'virtual',
    category: 'Team',
    agenda: '1. Portfolio review\n2. Experience and background\n3. Design skills assessment\n4. Culture fit discussion\n5. Availability and expectations',
    notes: 'Strong candidate! Great portfolio. Looking for $55K + benefits. Making offer this week.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Emma Rodriguez',
        email: 'emma.designer@email.com',
        company: 'Candidate',
        role: 'Graphic Designer',
        phone: '+1 (555) 678-9001',
        image_url: 'https://i.pravatar.cc/150?img=14'
      }
    ]
  },
  {
    id: 'em-10',
    title: 'Client Proposal Presentation - Peterson Industries',
    date: '2026-01-24',
    time: '10:00',
    duration: 90,
    meeting_link: '',
    location: 'Client Office - Downtown',
    meeting_type: 'in-person',
    category: 'Client Calls',
    agenda: '1. Company overview and capabilities\n2. Proposal presentation\n3. Case study reviews\n4. Pricing and timeline\n5. Q&A and next steps',
    notes: 'Presentation went well! They\'re choosing between 3 agencies. Follow-up call scheduled for next week.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'James Peterson',
        email: 'jpeterson@petersonind.com',
        company: 'Peterson Industries',
        role: 'VP Marketing',
        phone: '+1 (555) 789-0101',
        image_url: 'https://i.pravatar.cc/150?img=27'
      },
      {
        name: 'Amanda White',
        email: 'awhite@petersonind.com',
        company: 'Peterson Industries',
        role: 'Brand Manager',
        phone: '+1 (555) 890-1202',
        image_url: 'https://i.pravatar.cc/150?img=8'
      }
    ]
  },
  {
    id: 'em-11',
    title: 'Lawyer Consultation - Contract Review',
    date: '2026-01-27',
    time: '15:00',
    duration: 60,
    meeting_link: '',
    location: 'Law Office',
    meeting_type: 'in-person',
    category: 'Legal',
    agenda: '1. Service agreement template review\n2. Liability protection\n3. Payment terms discussion\n4. IP ownership clauses\n5. Contract recommendations',
    notes: 'Updated contract template with better payment terms and liability clauses. Ready to use with new clients.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Sarah Mitchell',
        email: 'sarah@businesslaw.com',
        company: 'Mitchell Business Law',
        role: 'Business Attorney',
        phone: '+1 (555) 901-2301',
        image_url: 'https://i.pravatar.cc/150?img=3'
      }
    ]
  },
  {
    id: 'em-12',
    title: 'Mastermind Group - Monthly Meeting',
    date: '2026-01-29',
    time: '18:00',
    duration: 120,
    meeting_link: 'https://zoom.us/j/mastermind-jan',
    location: '',
    meeting_type: 'virtual',
    category: 'Personal',
    agenda: '1. Monthly wins and challenges\n2. Hot seat - member presentations\n3. Goal setting for February\n4. Resource sharing\n5. Accountability check-ins',
    notes: 'Great session! Shared hiring challenges. Got advice on scaling. Next month: present growth strategy.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Business Mastermind Group',
        email: 'group@mastermind.com',
        company: 'Entrepreneur Mastermind',
        role: 'Peer Group',
        phone: '',
        image_url: 'https://i.pravatar.cc/150?img=52'
      }
    ]
  },
  {
    id: 'em-13',
    title: 'Bank Meeting - Business Line of Credit',
    date: '2026-02-03',
    time: '10:00',
    duration: 60,
    meeting_link: '',
    location: 'Bank Branch',
    meeting_type: 'in-person',
    category: 'Financial',
    agenda: '1. Business financials review\n2. Line of credit application\n3. Credit limit discussion\n4. Terms and interest rates\n5. Documentation requirements',
    notes: 'Approved for $50K line of credit at 8% interest. Great for cash flow management. Documents signed.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Michael Johnson',
        email: 'mjohnson@bankname.com',
        company: 'First National Bank',
        role: 'Business Banker',
        phone: '+1 (555) 012-3401',
        image_url: 'https://i.pravatar.cc/150?img=21'
      }
    ]
  }
];

// Photography Role Meetings Mock Data
export const photographyMeetingsMockData = [
  {
    id: 'photo-m1',
    title: 'Martinez Wedding - Final Album Review',
    date: '2026-01-03',
    time: '14:00',
    duration: 60,
    meeting_link: 'https://zoom.us/j/wedding-album-review',
    location: '',
    meeting_type: 'virtual',
    category: 'Client Calls',
    agenda: '1. Review 450 wedding photos\n2. Select favorites for album layout\n3. Discuss print sizes and materials\n4. Finalize album design and order',
    notes: 'Emily loves the ceremony photos! Wants 20-page premium leather album. Approved all edits.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Emily Martinez',
        email: 'emily.martinez@email.com',
        company: 'Martinez Family',
        role: 'Bride',
        phone: '+1 (555) 234-5678',
        image_url: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop'
      }
    ]
  },
  {
    id: 'photo-m2',
    title: 'Smith Products - Commercial Shoot Planning',
    date: '2026-01-06',
    time: '10:00',
    duration: 90,
    meeting_link: '',
    location: 'Smith Products HQ, Conference Room A',
    meeting_type: 'in-person',
    category: 'Client Calls',
    agenda: '1. Product line overview\n2. Shot list and styling requirements\n3. Studio vs location discussion\n4. Timeline and deliverables\n5. Budget and contract review',
    notes: '15 products to shoot. Need white background and lifestyle shots. Delivery: 5 business days. $3.5K project.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Sarah Smith',
        email: 'sarah@smithproducts.com',
        company: 'Smith Products',
        role: 'Marketing Director',
        phone: '+1 (555) 456-7890',
        image_url: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop'
      }
    ]
  },
  {
    id: 'photo-m3',
    title: 'Anderson Family Portrait - Location Scout',
    date: '2026-01-08',
    time: '15:00',
    duration: 45,
    meeting_link: '',
    location: 'Riverside Park - Main Entrance',
    meeting_type: 'in-person',
    category: 'Client Calls',
    agenda: '1. Walk through Riverside Park location\n2. Discuss best spots for family of 4\n3. Lighting and timing considerations\n4. Wardrobe recommendations',
    notes: 'Park has beautiful golden hour lighting. Recommended 3pm slot. Family bringing coordinated casual outfits.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'David Anderson',
        email: 'd.anderson@email.com',
        company: 'Anderson Family',
        role: 'Client',
        phone: '+1 (555) 345-6789',
        image_url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop'
      }
    ]
  },
  {
    id: 'photo-m4',
    title: 'Sophie Turner - Second Shooter Coordination',
    date: '2026-01-10',
    time: '11:00',
    duration: 30,
    meeting_link: 'https://zoom.us/j/second-shooter-briefing',
    location: '',
    meeting_type: 'virtual',
    category: 'Other',
    agenda: '1. Review upcoming wedding schedule\n2. Assign coverage areas (ceremony, reception, portraits)\n3. Equipment checklist\n4. Communication plan during event',
    notes: 'Sophie will cover getting ready photos and reception. I\'ll handle ceremony and family portraits. Both bringing backup cameras.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Sophie Turner',
        email: 'sophie@photohelp.com',
        company: 'Freelance Photographer',
        role: 'Second Shooter',
        phone: '+1 (555) 456-7890',
        image_url: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop'
      }
    ]
  },
  {
    id: 'photo-m5',
    title: 'Mark Wilson - Print Lab Partnership Discussion',
    date: '2026-01-14',
    time: '13:00',
    duration: 45,
    meeting_link: '',
    location: 'Professional Print Lab, Office',
    meeting_type: 'in-person',
    category: 'Networking',
    agenda: '1. Bulk pricing for wedding albums\n2. Print quality standards\n3. Turnaround time expectations\n4. Referral partnership opportunities',
    notes: 'Negotiated 20% discount on albums over $500. 7-10 day turnaround. Will refer my clients for additional prints.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Mark Wilson',
        email: 'mark@profprint.com',
        company: 'Professional Print Lab',
        role: 'Lab Manager',
        phone: '+1 (555) 012-3456',
        image_url: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=150&h=150&fit=crop'
      }
    ]
  },
  {
    id: 'photo-m6',
    title: 'Victoria Stone - Model Agency Collaboration',
    date: '2026-01-17',
    time: '10:30',
    duration: 60,
    meeting_link: 'https://meet.google.com/model-collab-jan',
    location: '',
    meeting_type: 'virtual',
    category: 'Networking',
    agenda: '1. Commercial photography opportunities\n2. Model portfolio shoots arrangement\n3. Trade collaboration (TFP) possibilities\n4. Rate cards and usage rights',
    notes: 'Agency looking for photographer for e-commerce shoots. Potential $5K monthly retainer. Will provide models for portfolio builds.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Victoria Stone',
        email: 'victoria@modelagency.com',
        company: 'Stone Model Agency',
        role: 'Agency Director',
        phone: '+1 (555) 789-0123',
        image_url: 'https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=150&h=150&fit=crop'
      }
    ]
  },
  {
    id: 'photo-m7',
    title: 'Chen Corporate Event - Photo Delivery Review',
    date: '2026-01-20',
    time: '16:00',
    duration: 30,
    meeting_link: 'https://zoom.us/j/chen-corp-delivery',
    location: '',
    meeting_type: 'virtual',
    category: 'Client Calls',
    agenda: '1. Present 250 edited event photos\n2. Review keynote speaker portraits\n3. Discuss additional retouching needs\n4. Plan for future events',
    notes: 'Client very happy with event coverage! CEO loved his keynote photos. Booked for Q2 product launch.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Michael Chen',
        email: 'mchen@techcorp.com',
        company: 'Tech Corp',
        role: 'Marketing Manager',
        phone: '+1 (555) 678-9012',
        image_url: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop'
      }
    ]
  }
];

// Podcaster Role Meetings Mock Data (alias to existing photography meetings data)
export const podcasterMeetingsMockData = photographyMeetingsMockData;

// Talent Agency Owner Meetings Mock Data
export const talentAgencyMeetingsMockData = [
  {
    id: 'tam-1',
    title: 'Sarah Chen - Netflix Series Audition Prep',
    date: '2026-01-03',
    time: '10:00',
    duration: 60,
    meeting_link: 'https://zoom.us/j/talent-prep-001',
    location: '',
    meeting_type: 'virtual',
    category: 'Talent',
    agenda: '1. Review character breakdown\n2. Script analysis\n3. Self-tape strategy\n4. Wardrobe & styling discussion\n5. Callback preparation',
    notes: 'Sarah is perfect for the lead role. Netflix looking for strong dramatic range. Callback likely next week if tape impresses.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Sarah Chen',
        email: 'sarah.chen@talent.agency',
        company: 'Elite Talent Roster',
        role: 'Actor - Series Regular',
        phone: '+1 (555) 234-5601',
        image_url: 'https://i.pravatar.cc/150?img=5'
      }
    ]
  },
  {
    id: 'tam-2',
    title: 'Casting Director Meeting - Warner Bros Feature',
    date: '2026-01-06',
    time: '14:00',
    duration: 45,
    meeting_link: '',
    location: 'Warner Bros Studios, Lot 3',
    meeting_type: 'in-person',
    category: 'Casting',
    agenda: '1. Discuss upcoming feature film roles\n2. Review client roster fit\n3. Audition scheduling\n4. Contract negotiations timeline',
    notes: 'Great meeting! CD wants to see Marcus Flynn and Jake Morrison for supporting roles. Budget: $15M production.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Lisa Rodriguez',
        email: 'lrodriguez@warnerbros.com',
        company: 'Warner Bros',
        role: 'Casting Director',
        phone: '+1 (555) 345-6701',
        image_url: 'https://i.pravatar.cc/150?img=47'
      }
    ]
  },
  {
    id: 'tam-3',
    title: 'Marcus Flynn - Nike Campaign Deal Review',
    date: '2026-01-08',
    time: '11:00',
    duration: 90,
    meeting_link: '',
    location: 'Agency Office - Conference Room A',
    meeting_type: 'in-person',
    category: 'Commercial',
    agenda: '1. Review Nike contract terms\n2. Usage rights discussion\n3. Compensation package\n4. Exclusivity clauses\n5. Shoot schedule coordination',
    notes: '$500K deal + royalties. 2-year term. Marcus excited about the partnership. Legal review needed before signing.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Marcus Flynn',
        email: 'marcus.flynn@talent.agency',
        company: 'Elite Talent Roster',
        role: 'Actor/Brand Ambassador',
        phone: '+1 (555) 456-7801',
        image_url: 'https://i.pravatar.cc/150?img=12'
      },
      {
        name: 'Jennifer Kim',
        email: 'jkim@nike.com',
        company: 'Nike',
        role: 'Brand Partnerships Manager',
        phone: '+1 (555) 567-8901',
        image_url: 'https://i.pravatar.cc/150?img=9'
      }
    ]
  },
  {
    id: 'tam-4',
    title: 'Agent Team Meeting - Weekly Pipeline Review',
    date: '2026-01-09',
    time: '09:00',
    duration: 60,
    meeting_link: '',
    location: 'Agency Office - Main Conference Room',
    meeting_type: 'in-person',
    category: 'Internal',
    agenda: '1. Active auditions status\n2. Deal negotiations update\n3. New talent scouting\n4. Client relationship check-ins\n5. Q1 strategy alignment',
    notes: '12 active auditions, 3 deals in final negotiation, 2 new talent meetings scheduled. Strong start to Q1!',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Agency Team',
        email: '',
        company: 'Elite Talent Agency',
        role: 'Agents & Staff',
        phone: '',
        image_url: 'https://i.pravatar.cc/150?img=32'
      }
    ]
  },
  {
    id: 'tam-5',
    title: 'Emma Davis - Career Strategy Session',
    date: '2026-01-10',
    time: '13:00',
    duration: 60,
    meeting_link: 'https://zoom.us/j/career-strategy-001',
    location: '',
    meeting_type: 'virtual',
    category: 'Talent',
    agenda: '1. Career goals for 2026\n2. Role selection strategy\n3. Brand building opportunities\n4. Social media growth plan\n5. Upcoming projects pipeline',
    notes: 'Emma wants to transition from supporting to lead roles. Focus on indie films and streaming series. Build dramatic range.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Emma Davis',
        email: 'emma.davis@talent.agency',
        company: 'Elite Talent Roster',
        role: 'Actor - Rising Star',
        phone: '+1 (555) 678-9001',
        image_url: 'https://i.pravatar.cc/150?img=8'
      }
    ]
  },
  {
    id: 'tam-6',
    title: 'Producer Meeting - Amazon Series Development',
    date: '2026-01-13',
    time: '15:00',
    duration: 90,
    meeting_link: 'https://zoom.us/j/amazon-dev-meeting',
    location: '',
    meeting_type: 'virtual',
    category: 'Casting',
    agenda: '1. Series concept overview\n2. Casting needs discussion\n3. Timeline and production schedule\n4. Budget parameters\n5. Talent availability',
    notes: 'New Amazon thriller series. Looking for 2 leads and 4 supporting roles. Production starts April. Great opportunity!',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Michael Torres',
        email: 'mtorres@amazonstudios.com',
        company: 'Amazon Studios',
        role: 'Executive Producer',
        phone: '+1 (555) 789-0101',
        image_url: 'https://i.pravatar.cc/150?img=13'
      }
    ]
  },
  {
    id: 'tam-7',
    title: 'Contract Negotiation - HBO Series Regular',
    date: '2026-01-15',
    time: '10:30',
    duration: 120,
    meeting_link: '',
    location: 'Law Office - Downtown LA',
    meeting_type: 'in-person',
    category: 'Legal',
    agenda: '1. Review series regular contract\n2. Per-episode compensation\n3. Profit participation\n4. Option years\n5. Exclusivity terms\n6. Credits negotiation',
    notes: 'Jake Morrison HBO series - $75K per episode, 8 episodes guaranteed. 3-year option. Excellent deal!',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Sarah Mitchell',
        email: 'sarah@entertainmentlaw.com',
        company: 'Entertainment Law Group',
        role: 'Entertainment Attorney',
        phone: '+1 (555) 890-1201',
        image_url: 'https://i.pravatar.cc/150?img=3'
      },
      {
        name: 'Jake Morrison',
        email: 'jake.morrison@talent.agency',
        company: 'Elite Talent Roster',
        role: 'Actor',
        phone: '+1 (555) 901-2301',
        image_url: 'https://i.pravatar.cc/150?img=27'
      }
    ]
  },
  {
    id: 'tam-8',
    title: 'New Talent Showcase - Industry Night',
    date: '2026-01-17',
    time: '19:00',
    duration: 180,
    meeting_link: '',
    location: 'Showcase Theater - Hollywood',
    meeting_type: 'in-person',
    category: 'Industry',
    agenda: '1. Talent performances\n2. Industry networking\n3. Casting director introductions\n4. Post-show mixer',
    notes: '5 of our clients performing. 20+ casting directors attending. Great exposure opportunity!',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Industry Guests',
        email: '',
        company: 'Various Studios & Networks',
        role: 'Casting Directors & Producers',
        phone: '',
        image_url: 'https://i.pravatar.cc/150?img=52'
      }
    ]
  },
  {
    id: 'tam-9',
    title: 'Brand Partnership Pitch - L\'Oréal Campaign',
    date: '2026-01-20',
    time: '14:00',
    duration: 60,
    meeting_link: 'https://zoom.us/j/loreal-pitch',
    location: '',
    meeting_type: 'virtual',
    category: 'Commercial',
    agenda: '1. Present Emma Davis for L\'Oréal face\n2. Portfolio review\n3. Social media metrics\n4. Campaign vision alignment\n5. Compensation discussion',
    notes: 'L\'Oréal looking for fresh face for new skincare line. Emma\'s social reach (500K) is attractive. Presenting her reel.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Rachel Kim',
        email: 'rkim@loreal.com',
        company: 'L\'Oréal',
        role: 'Marketing Director',
        phone: '+1 (555) 012-3401',
        image_url: 'https://i.pravatar.cc/150?img=9'
      }
    ]
  },
  {
    id: 'tam-10',
    title: 'Audition - Tyler James - Apple TV+ Series',
    date: '2026-01-22',
    time: '11:00',
    duration: 30,
    meeting_link: '',
    location: 'Apple Studios - Culver City',
    meeting_type: 'in-person',
    category: 'Audition',
    agenda: '1. Cold read with casting director\n2. Chemistry read with lead actor\n3. Director introduction\n4. Callback discussion',
    notes: 'Tyler nailed the audition! CD loved his energy. Callback scheduled for next week. This could be his breakout role!',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Tyler James',
        email: 'tyler.james@talent.agency',
        company: 'Elite Talent Roster',
        role: 'Actor',
        phone: '+1 (555) 123-4501',
        image_url: 'https://i.pravatar.cc/150?img=21'
      }
    ]
  },
  {
    id: 'tam-11',
    title: 'Financial Review - Q4 Earnings & Q1 Projections',
    date: '2026-01-24',
    time: '10:00',
    duration: 90,
    meeting_link: '',
    location: 'Agency Office - Executive Suite',
    meeting_type: 'in-person',
    category: 'Business',
    agenda: '1. Q4 commission revenue review\n2. Top-earning clients analysis\n3. Q1 pipeline projections\n4. Operating expenses\n5. Investment opportunities',
    notes: 'Q4: $2.8M in commissions. Strong year! Q1 pipeline looking healthy with 15 active deals.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'David Chen',
        email: 'dchen@accountingfirm.com',
        company: 'Entertainment Accounting',
        role: 'Business Manager',
        phone: '+1 (555) 234-5601',
        image_url: 'https://i.pravatar.cc/150?img=33'
      }
    ]
  },
  {
    id: 'tam-12',
    title: 'Talent Check-in - Sophia Martinez Performance Review',
    date: '2026-01-27',
    time: '16:00',
    duration: 45,
    meeting_link: '',
    location: 'Coffee Shop - West Hollywood',
    meeting_type: 'in-person',
    category: 'Talent',
    agenda: '1. Recent booking feedback\n2. Training & coaching needs\n3. Upcoming audition prep\n4. Career satisfaction check\n5. Personal support',
    notes: 'Sophia feeling great after landing recurring role on ABC series. Wants more comedy auditions. Great momentum!',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Sophia Martinez',
        email: 'sophia.martinez@talent.agency',
        company: 'Elite Talent Roster',
        role: 'Actor',
        phone: '+1 (555) 345-6701',
        image_url: 'https://i.pravatar.cc/150?img=47'
      }
    ]
  },
  {
    id: 'tam-13',
    title: 'Studio Pitch - Universal Pictures Feature',
    date: '2026-01-29',
    time: '13:00',
    duration: 60,
    meeting_link: '',
    location: 'Universal Studios - Executive Building',
    meeting_type: 'in-person',
    category: 'Casting',
    agenda: '1. Present Marcus Flynn for lead role\n2. Screen test discussion\n3. Availability confirmation\n4. Deal terms framework',
    notes: 'Universal very interested in Marcus for action-thriller lead. $10M budget film. Screen test next week!',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Amanda White',
        email: 'awhite@universalpictures.com',
        company: 'Universal Pictures',
        role: 'VP of Talent',
        phone: '+1 (555) 456-7801',
        image_url: 'https://i.pravatar.cc/150?img=8'
      }
    ]
  }
];

// ==========================================
// C-SUITE EXECUTIVE ENTERPRISE COMPANY DATA
// ==========================================

// C-Suite Executive Contacts Mock Data
export const csuiteExecutiveContactsMockData = [
  // Board Members
  { id: 'cs-1', name: 'Richard Blackwell', email: 'rblackwell@boardadvisors.com', phone: '+1 (415) 555-0101', company: 'Board of Directors', role: 'Board Chair', category: 'board', image: 'https://i.pravatar.cc/150?img=70', notes: 'Former Fortune 500 CEO, 25 years experience' },
  { id: 'cs-2', name: 'Patricia Morrison', email: 'pmorrison@venture capital.com', phone: '+1 (650) 555-0102', company: 'Summit Ventures', role: 'Board Member & Investor', category: 'board', image: 'https://i.pravatar.cc/150?img=47', notes: 'Lead Series A investor, holds 18% equity' },
  { id: 'cs-3', name: 'Dr. James Chen', email: 'jchen@techfund.com', phone: '+1 (415) 555-0103', company: 'Innovation Capital', role: 'Board Member', category: 'board', image: 'https://i.pravatar.cc/150?img=33', notes: 'Technology expertise, 3 successful exits' },
  { id: 'cs-4', name: 'Margaret Thompson', email: 'mthompson@independent.com', phone: '+1 (415) 555-0104', company: 'Independent', role: 'Independent Director', category: 'board', image: 'https://i.pravatar.cc/150?img=21', notes: 'Audit committee chair, CFO background' },

  // Executive Team
  { id: 'cs-5', name: 'Robert Martinez', email: 'robert.martinez@company.com', phone: '+1 (415) 555-0201', company: 'Company', role: 'Chief Financial Officer', category: 'executive', image: 'https://i.pravatar.cc/150?img=12', notes: 'Managing financials, board reporting, fundraising' },
  { id: 'cs-6', name: 'Jennifer Wilson', email: 'jennifer.wilson@company.com', phone: '+1 (415) 555-0202', company: 'Company', role: 'Chief Technology Officer', category: 'executive', image: 'https://i.pravatar.cc/150?img=5', notes: 'Engineering leadership, product architecture' },
  { id: 'cs-7', name: 'David Anderson', email: 'david.anderson@company.com', phone: '+1 (415) 555-0203', company: 'Company', role: 'Chief Operating Officer', category: 'executive', image: 'https://i.pravatar.cc/150?img=14', notes: 'Operations, scaling, process optimization' },
  { id: 'cs-8', name: 'Sarah Johnson', email: 'sarah.johnson@company.com', phone: '+1 (415) 555-0204', company: 'Company', role: 'Chief Marketing Officer', category: 'executive', image: 'https://i.pravatar.cc/150?img=9', notes: 'Brand, growth marketing, customer acquisition' },
  { id: 'cs-9', name: 'Michael Chang', email: 'michael.chang@company.com', phone: '+1 (415) 555-0205', company: 'Company', role: 'Chief Revenue Officer', category: 'executive', image: 'https://i.pravatar.cc/150?img=52', notes: 'Sales leadership, enterprise accounts, revenue growth' },
  { id: 'cs-10', name: 'Amanda Foster', email: 'amanda.foster@company.com', phone: '+1 (415) 555-0206', company: 'Company', role: 'Chief People Officer', category: 'executive', image: 'https://i.pravatar.cc/150?img=27', notes: 'HR, talent, culture, leadership development' },
  
  // Major Customers
  { id: 'cs-11', name: 'Thomas Richardson', email: 'trichardson@globaltech.com', phone: '+1 (212) 555-0301', company: 'GlobalTech Corp', role: 'CEO', category: 'customer', image: 'https://i.pravatar.cc/150?img=60', notes: '$4.2M ARR customer, renewal Q1 2026' },
  { id: 'cs-12', name: 'Elizabeth Parker', email: 'eparker@enterprisesoft.com', phone: '+1 (617) 555-0302', company: 'Enterprise Software Inc', role: 'CIO', category: 'customer', image: 'https://i.pravatar.cc/150?img=29', notes: 'Fortune 500 customer, expansion opportunity' },
  { id: 'cs-13', name: 'William Hughes', email: 'whughes@financialservices.com', phone: '+1 (312) 555-0303', company: 'Financial Services Group', role: 'SVP Technology', category: 'customer', image: 'https://i.pravatar.cc/150?img=11', notes: 'Strategic account, considering enterprise tier' },
  
  // Strategic Partners
  { id: 'cs-14', name: 'Catherine Lee', email: 'clee@cloudplatform.com', phone: '+1 (206) 555-0401', company: 'Cloud Platform Inc', role: 'VP Partnerships', category: 'partner', image: 'https://i.pravatar.cc/150?img=31', notes: 'Technology partnership, co-selling agreement' },
  { id: 'cs-15', name: 'Daniel Brooks', email: 'dbrooks@systemintegrator.com', phone: '+1 (404) 555-0402', company: 'System Integrator LLC', role: 'Managing Partner', category: 'partner', image: 'https://i.pravatar.cc/150?img=56', notes: 'Channel partner, $2M pipeline' },
  
  // Investors
  { id: 'cs-16', name: 'Alexandra Bennett', email: 'abennett@growthequity.com', phone: '+1 (650) 555-0501', company: 'Growth Equity Partners', role: 'Managing Director', category: 'investor', image: 'https://i.pravatar.cc/150?img=19', notes: 'Series B lead investor, $50M investment' },
  { id: 'cs-17', name: 'Jonathan Reed', email: 'jreed@venturefund.com', phone: '+1 (650) 555-0502', company: 'Venture Fund Associates', role: 'General Partner', category: 'investor', image: 'https://i.pravatar.cc/150?img=68', notes: 'Series A investor, board observer' },
  
  // Advisors
  { id: 'cs-18', name: 'Dr. Susan Phillips', email: 'sphillips@strategy advisors.com', phone: '+1 (617) 555-0601', company: 'Strategy Advisors', role: 'Senior Advisor', category: 'advisor', image: 'https://i.pravatar.cc/150?img=35', notes: 'GTM strategy, market expansion expertise' },
  { id: 'cs-19', name: 'Mark Davidson', email: 'mdavidson@legal advisors.com', phone: '+1 (212) 555-0602', company: 'Corporate Legal', role: 'General Counsel Advisor', category: 'advisor', image: 'https://i.pravatar.cc/150?img=15', notes: 'M&A, compliance, corporate governance' },
  
  // Regulators & Government
  { id: 'cs-20', name: 'Linda Morrison', email: 'lmorrison@sec.gov', phone: '+1 (202) 555-0701', company: 'SEC', role: 'Senior Examiner', category: 'regulator', image: 'https://i.pravatar.cc/150?img=45', notes: 'Financial reporting compliance contact' },
  
  // Press & Analysts
  { id: 'cs-21', name: 'Brian Foster', email: 'bfoster@techcrunch.com', phone: '+1 (415) 555-0801', company: 'TechCrunch', role: 'Senior Editor', category: 'media', image: 'https://i.pravatar.cc/150?img=25', notes: 'Key press relationship, product launches' },
  { id: 'cs-22', name: 'Nicole Garcia', email: 'ngarcia@analyst firm.com', phone: '+1 (415) 555-0802', company: 'Industry Analyst Group', role: 'Lead Analyst', category: 'analyst', image: 'https://i.pravatar.cc/150?img=38', notes: 'Market research, industry reports' }
];

// C-Suite Executive Meetings Mock Data
export const csuiteExecutiveMeetingsMockData = [
  {
    id: 'csm-1',
    title: 'Board of Directors - Q4 Review',
    date: '2026-01-22',
    time: '09:00',
    duration: 180,
    meeting_link: 'https://zoom.us/j/csuite001',
    location: '',
    meeting_type: 'virtual',
    category: 'Board',
    agenda: '1. Q4 financial results\n2. 2025 strategic initiatives review\n3. 2026 guidance and priorities\n4. Executive compensation discussion\n5. Risk management update',
    notes: 'All board materials distributed. Earnings call scheduled for same day at 2PM.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Richard Blackwell',
        email: 'rblackwell@boardadvisors.com',
        company: 'Board of Directors',
        role: 'Board Chair',
        phone: '+1 (415) 555-0101',
        image_url: 'https://i.pravatar.cc/150?img=70'
      },
      {
        name: 'Patricia Morrison',
        email: 'pmorrison@venturecapital.com',
        company: 'Summit Ventures',
        role: 'Board Member',
        phone: '+1 (650) 555-0102',
        image_url: 'https://i.pravatar.cc/150?img=47'
      }
    ]
  },
  {
    id: 'csm-2',
    title: 'Executive Leadership Team Meeting',
    date: '2026-01-06',
    time: '09:00',
    duration: 90,
    meeting_link: 'https://zoom.us/j/csuite002',
    location: '',
    meeting_type: 'virtual',
    category: 'Executive',
    agenda: '1. Week priorities and alignment\n2. Cross-functional blockers\n3. Key metrics review\n4. Escalations and decisions needed\n5. Upcoming milestones',
    notes: 'Weekly ELT standup - focused on execution and coordination',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Robert Martinez',
        email: 'robert.martinez@company.com',
        company: 'Company',
        role: 'CFO',
        phone: '+1 (415) 555-0201',
        image_url: 'https://i.pravatar.cc/150?img=12'
      },
      {
        name: 'Jennifer Wilson',
        email: 'jennifer.wilson@company.com',
        company: 'Company',
        role: 'CTO',
        phone: '+1 (415) 555-0202',
        image_url: 'https://i.pravatar.cc/150?img=5'
      }
    ]
  },
  {
    id: 'csm-3',
    title: 'GlobalTech CEO Strategic Partnership Discussion',
    date: '2026-01-08',
    time: '14:00',
    duration: 60,
    meeting_link: 'https://zoom.us/j/csuite003',
    location: '',
    meeting_type: 'virtual',
    category: 'Customer',
    agenda: '1. Current partnership review\n2. Expansion opportunities\n3. Product roadmap alignment\n4. Joint go-to-market discussion\n5. Contract renewal terms',
    notes: '$4.2M ARR customer - critical relationship. Prepare case studies.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Thomas Richardson',
        email: 'trichardson@globaltech.com',
        company: 'GlobalTech Corp',
        role: 'CEO',
        phone: '+1 (212) 555-0301',
        image_url: 'https://i.pravatar.cc/150?img=60'
      }
    ]
  },
  {
    id: 'csm-4',
    title: 'Series B Investor Update Call',
    date: '2026-01-10',
    time: '11:00',
    duration: 60,
    meeting_link: '',
    location: 'Growth Equity Partners Office',
    meeting_type: 'in-person',
    category: 'Investor',
    agenda: '1. Q4 performance review\n2. Key metrics and milestones\n3. 2026 strategic priorities\n4. Hiring and team updates\n5. Market opportunities',
    notes: 'Quarterly investor update - prepare financial deck',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Alexandra Bennett',
        email: 'abennett@growthequity.com',
        company: 'Growth Equity Partners',
        role: 'Managing Director',
        phone: '+1 (650) 555-0501',
        image_url: 'https://i.pravatar.cc/150?img=19'
      }
    ]
  },
  {
    id: 'csm-5',
    title: 'CFO 1:1 - Q1 Budget & Fundraising',
    date: '2026-01-09',
    time: '15:00',
    duration: 45,
    meeting_link: 'https://zoom.us/j/csuite004',
    location: '',
    meeting_type: 'virtual',
    category: 'Executive',
    agenda: '1. Q1 budget status and variances\n2. Series C fundraising timeline\n3. Board deck preparation\n4. Financial metrics review\n5. Hiring budget allocation',
    notes: 'Weekly 1:1 with CFO - strategic financial planning',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Robert Martinez',
        email: 'robert.martinez@company.com',
        company: 'Company',
        role: 'CFO',
        phone: '+1 (415) 555-0201',
        image_url: 'https://i.pravatar.cc/150?img=12'
      }
    ]
  },
  {
    id: 'csm-6',
    title: 'CTO 1:1 - Engineering Strategy & Retention',
    date: '2026-01-09',
    time: '16:00',
    duration: 45,
    meeting_link: 'https://zoom.us/j/csuite005',
    location: '',
    meeting_type: 'virtual',
    category: 'Executive',
    agenda: '1. Platform stability concerns\n2. Engineering attrition discussion\n3. Q1 product roadmap priorities\n4. Technical debt management\n5. Team morale and retention plan',
    notes: 'Critical - 3 senior engineers at risk. Discuss retention packages.',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Jennifer Wilson',
        email: 'jennifer.wilson@company.com',
        company: 'Company',
        role: 'CTO',
        phone: '+1 (415) 555-0202',
        image_url: 'https://i.pravatar.cc/150?img=5'
      }
    ]
  },
  {
    id: 'csm-7',
    title: 'Strategic Planning Session - 2026 OKRs',
    date: '2026-01-15',
    time: '10:00',
    duration: 240,
    meeting_link: '',
    location: 'Executive Conference Room',
    meeting_type: 'in-person',
    category: 'Strategic',
    agenda: '1. 2026 company objectives definition\n2. Key results and metrics\n3. Resource allocation planning\n4. Market expansion strategy\n5. Product strategy alignment',
    notes: 'Full-day executive team offsite - annual planning',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Executive Leadership Team',
        email: 'elt@company.com',
        company: 'Company',
        role: 'Leadership Team',
        phone: '',
        image_url: ''
      }
    ]
  },
  {
    id: 'csm-8',
    title: 'All-Hands Company Meeting',
    date: '2026-01-17',
    time: '16:00',
    duration: 60,
    meeting_link: 'https://zoom.us/j/allhands001',
    location: '',
    meeting_type: 'virtual',
    category: 'Company',
    agenda: '1. Q4 results announcement\n2. 2026 strategy overview\n3. Team wins and recognition\n4. New hires introduction\n5. Open Q&A session',
    notes: 'Monthly all-hands - entire company attendance',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'All Employees',
        email: 'team@company.com',
        company: 'Company',
        role: 'Team',
        phone: '',
        image_url: ''
      }
    ]
  },
  {
    id: 'csm-9',
    title: 'M&A Advisory Session - Target Evaluation',
    date: '2026-01-12',
    time: '13:00',
    duration: 120,
    meeting_link: 'https://zoom.us/j/csuite006',
    location: '',
    meeting_type: 'virtual',
    category: 'Strategic',
    agenda: '1. Acquisition target overview\n2. Strategic fit assessment\n3. Financial analysis and valuation\n4. Integration considerations\n5. Next steps and timeline',
    notes: 'Confidential - acquisition opportunity evaluation',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Mark Davidson',
        email: 'mdavidson@legaladvisors.com',
        company: 'Corporate Legal',
        role: 'M&A Advisor',
        phone: '+1 (212) 555-0602',
        image_url: 'https://i.pravatar.cc/150?img=15'
      }
    ]
  },
  {
    id: 'csm-10',
    title: 'Q4 Earnings Call Preparation',
    date: '2026-01-20',
    time: '14:00',
    duration: 90,
    meeting_link: 'https://zoom.us/j/csuite007',
    location: '',
    meeting_type: 'virtual',
    category: 'Board',
    agenda: '1. Earnings script review\n2. Q&A preparation\n3. Key message alignment\n4. Guidance discussion\n5. Risk factors review',
    notes: 'Final prep before public earnings call on Jan 22',
    transcript: '',
    transcription_id: '',
    participants: [
      {
        name: 'Robert Martinez',
        email: 'robert.martinez@company.com',
        company: 'Company',
        role: 'CFO',
        phone: '+1 (415) 555-0201',
        image_url: 'https://i.pravatar.cc/150?img=12'
      }
    ]
  }
];

// Photography Role Projects Mock Data
export const photographyProjects = [
  {
    id: 'photo-p1',
    name: 'Martinez Wedding Photography',
    client: 'Emily & Carlos Martinez',
    status: 'Review',
    progress: 95,
    deadline: '2026-01-10',
    budget: 4500,
    team: ['You', 'Sophie Turner']
  },
  {
    id: 'photo-p2',
    name: 'Anderson Family Portrait Session',
    client: 'Anderson Family',
    status: 'In Progress',
    progress: 60,
    deadline: '2026-01-15',
    budget: 800,
    team: ['You']
  },
  {
    id: 'photo-p3',
    name: 'Smith Products Commercial Shoot',
    client: 'Smith Products Inc',
    status: 'In Progress',
    progress: 40,
    deadline: '2026-01-18',
    budget: 3500,
    team: ['You', 'Jake Miller']
  },
  {
    id: 'photo-p4',
    name: 'Chen Corporate Event Coverage',
    client: 'Tech Corp',
    status: 'Completed',
    progress: 100,
    deadline: '2025-12-20',
    budget: 2800,
    team: ['You']
  },
  {
    id: 'photo-p5',
    name: 'Johnson Professional Headshots',
    client: 'Jennifer Johnson',
    status: 'Planning',
    progress: 25,
    deadline: '2026-01-25',
    budget: 600,
    team: ['You']
  },
  {
    id: 'photo-p6',
    name: 'Wilson Real Estate Portfolio',
    client: 'Wilson Realty Group',
    status: 'In Progress',
    progress: 70,
    deadline: '2026-01-12',
    budget: 1200,
    team: ['You']
  },
  {
    id: 'photo-p7',
    name: 'Garcia Brand Lifestyle Shoot',
    client: 'Garcia Apparel',
    status: 'Review',
    progress: 85,
    deadline: '2026-01-08',
    budget: 5200,
    team: ['You', 'Sophie Turner']
  },
  {
    id: 'photo-p8',
    name: 'Parker Engagement Photography',
    client: 'Rachel & Tom Parker',
    status: 'Completed',
    progress: 100,
    deadline: '2025-12-28',
    budget: 950,
    team: ['You']
  }
];

// Photography Role Finances Mock Data
export const photographyFinancesMockData = {
  stats: {
    revenue: 87450.00,
    expenses: 24680.50,
    profit: 62769.50,
    balance: 94320.75
  },
  accounts: [
    {
      id: 'photo-acc-1',
      name: 'Chase Business Checking',
      institution: 'JPMorgan Chase',
      type: 'checking',
      balances: {
        current: 34520.75,
        available: 34520.75
      },
      last_four: '8247',
      status: 'active'
    },
    {
      id: 'photo-acc-2',
      name: 'Photography Business Savings',
      institution: 'JPMorgan Chase',
      type: 'savings',
      balances: {
        current: 58000.00,
        available: 58000.00
      },
      last_four: '3156',
      status: 'active'
    },
    {
      id: 'photo-acc-3',
      name: 'Chase Sapphire Business',
      institution: 'Chase',
      type: 'credit',
      balances: {
        current: -1800.00,
        available: 48200.00
      },
      last_four: '4921',
      status: 'active'
    }
  ],
  transactions: [
    {
      id: 'photo-txn-1',
      date: '2025-12-28',
      description: 'Martinez Wedding - Final Payment',
      category: 'Income',
      amount: 2250.00,
      type: 'income',
      account: 'Chase Business Checking',
      status: 'completed',
      merchant: 'Emily Martinez',
      notes: 'Final 50% payment for wedding photography'
    },
    {
      id: 'photo-txn-2',
      date: '2025-12-27',
      description: 'Chen Corporate Event Payment',
      category: 'Income',
      amount: 2800.00,
      type: 'income',
      account: 'Chase Business Checking',
      status: 'completed',
      merchant: 'Tech Corp',
      notes: 'Corporate event photography - full payment'
    },
    {
      id: 'photo-txn-3',
      date: '2025-12-26',
      description: 'Adobe Creative Cloud',
      category: 'Software',
      amount: 54.99,
      type: 'expense',
      account: 'Chase Sapphire',
      status: 'completed',
      merchant: 'Adobe Inc',
      notes: 'Monthly subscription - Photoshop, Lightroom'
    },
    {
      id: 'photo-txn-4',
      date: '2025-12-26',
      description: 'Equipment Insurance - Quarterly',
      category: 'Insurance',
      amount: 450.00,
      type: 'expense',
      account: 'Chase Business Checking',
      status: 'completed',
      merchant: 'Photography Insurance Co',
      notes: 'Q4 equipment insurance premium'
    },
    {
      id: 'photo-txn-5',
      date: '2025-12-25',
      description: 'Smith Products - Deposit',
      category: 'Income',
      amount: 1750.00,
      type: 'income',
      account: 'Chase Business Checking',
      status: 'completed',
      merchant: 'Smith Products Inc',
      notes: '50% deposit for commercial shoot'
    },
    {
      id: 'photo-txn-6',
      date: '2025-12-24',
      description: 'Canon RF 85mm f/1.2 Lens',
      category: 'Equipment',
      amount: 2699.00,
      type: 'expense',
      account: 'Chase Sapphire',
      status: 'completed',
      merchant: 'B&H Photo Video',
      notes: 'New portrait lens for professional work'
    },
    {
      id: 'photo-txn-7',
      date: '2025-12-23',
      description: 'Wilson Real Estate - Payment',
      category: 'Income',
      amount: 1200.00,
      type: 'income',
      account: 'Chase Business Checking',
      status: 'completed',
      merchant: 'Wilson Realty Group',
      notes: 'Real estate photography package'
    },
    {
      id: 'photo-txn-8',
      date: '2025-12-22',
      description: 'Studio Rental - December',
      category: 'Studio',
      amount: 800.00,
      type: 'expense',
      account: 'Chase Business Checking',
      status: 'completed',
      merchant: 'Downtown Photo Studio',
      notes: 'Monthly studio space rental'
    },
    {
      id: 'photo-txn-9',
      date: '2025-12-21',
      description: 'Garcia Brand Shoot - Deposit',
      category: 'Income',
      amount: 2600.00,
      type: 'income',
      account: 'Chase Business Checking',
      status: 'completed',
      merchant: 'Garcia Apparel',
      notes: '50% deposit for lifestyle brand shoot'
    },
    {
      id: 'photo-txn-10',
      date: '2025-12-20',
      description: 'Sophie Turner - Second Shooter',
      category: 'Contractors',
      amount: 500.00,
      type: 'expense',
      account: 'Chase Business Checking',
      status: 'completed',
      merchant: 'Sophie Turner',
      notes: 'Payment for Martinez wedding assistance'
    },
    {
      id: 'photo-txn-11',
      date: '2025-12-19',
      description: 'Professional Print Lab',
      category: 'Printing',
      amount: 380.00,
      type: 'expense',
      account: 'Chase Sapphire',
      status: 'completed',
      merchant: 'Mark Wilson Print Lab',
      notes: 'Wedding album printing - Martinez'
    },
    {
      id: 'photo-txn-12',
      date: '2025-12-18',
      description: 'Johnson Headshots - Payment',
      category: 'Income',
      amount: 600.00,
      type: 'income',
      account: 'Chase Business Checking',
      status: 'completed',
      merchant: 'Jennifer Johnson',
      notes: 'Professional headshot session'
    },
    {
      id: 'photo-txn-13',
      date: '2025-12-17',
      description: 'Dropbox Business Storage',
      category: 'Software',
      amount: 19.99,
      type: 'expense',
      account: 'Chase Sapphire',
      status: 'completed',
      merchant: 'Dropbox Inc',
      notes: 'Monthly cloud storage subscription'
    },
    {
      id: 'photo-txn-14',
      date: '2025-12-16',
      description: 'Camera Cleaning Kit',
      category: 'Equipment',
      amount: 45.99,
      type: 'expense',
      account: 'Chase Sapphire',
      status: 'completed',
      merchant: 'Amazon',
      notes: 'Professional camera maintenance supplies'
    },
    {
      id: 'photo-txn-15',
      date: '2025-12-15',
      description: 'Parker Engagement - Payment',
      category: 'Income',
      amount: 950.00,
      type: 'income',
      account: 'Chase Business Checking',
      status: 'completed',
      merchant: 'Rachel Parker',
      notes: 'Engagement photography session'
    },
    {
      id: 'photo-txn-16',
      date: '2025-12-14',
      description: 'Website Hosting - Annual',
      category: 'Marketing',
      amount: 180.00,
      type: 'expense',
      account: 'Chase Business Checking',
      status: 'completed',
      merchant: 'Squarespace',
      notes: 'Annual portfolio website hosting'
    },
    {
      id: 'photo-txn-17',
      date: '2025-12-13',
      description: 'SD Memory Cards (256GB x2)',
      category: 'Equipment',
      amount: 189.98,
      type: 'expense',
      account: 'Chase Sapphire',
      status: 'completed',
      merchant: 'B&H Photo Video',
      notes: 'High-speed memory cards for shoots'
    },
    {
      id: 'photo-txn-18',
      date: '2025-12-12',
      description: 'Anderson Family - Deposit',
      category: 'Income',
      amount: 400.00,
      type: 'income',
      account: 'Chase Business Checking',
      status: 'completed',
      merchant: 'David Anderson',
      notes: '50% deposit for family portrait session'
    },
    {
      id: 'photo-txn-19',
      date: '2025-12-11',
      description: 'Business Lunch - Model Agency',
      category: 'Meals',
      amount: 125.50,
      type: 'expense',
      account: 'Chase Sapphire',
      status: 'completed',
      merchant: 'The Palm Restaurant',
      notes: 'Client meeting with Victoria Stone'
    },
    {
      id: 'photo-txn-20',
      date: '2025-12-10',
      description: 'QuickBooks Subscription',
      category: 'Software',
      amount: 35.00,
      type: 'expense',
      account: 'Chase Business Checking',
      status: 'completed',
      merchant: 'Intuit QuickBooks',
      notes: 'Monthly accounting software'
    }
  ]
};
